export const ubigeoData = [
  {
    departamento: "01",
    provincia: "00",
    distrito: "00",
    text: "Amazonas",
  },
  {
    departamento: "01",
    provincia: "01",
    distrito: "00",
    text: "Chachapoyas",
  },
  {
    departamento: "01",
    provincia: "01",
    distrito: "01",
    text: "Chachapoyas",
  },
  {
    departamento: "01",
    provincia: "01",
    distrito: "02",
    text: "Asunción",
  },
  {
    departamento: "01",
    provincia: "01",
    distrito: "03",
    text: "Balsas",
  },
  {
    departamento: "01",
    provincia: "01",
    distrito: "04",
    text: "Cheto",
  },
  {
    departamento: "01",
    provincia: "01",
    distrito: "05",
    text: "Chiliquin",
  },
  {
    departamento: "01",
    provincia: "01",
    distrito: "06",
    text: "Chuquibamba",
  },
  {
    departamento: "01",
    provincia: "01",
    distrito: "07",
    text: "Granada",
  },
  {
    departamento: "01",
    provincia: "01",
    distrito: "08",
    text: "Huancas",
  },
  {
    departamento: "01",
    provincia: "01",
    distrito: "09",
    text: "La Jalca",
  },
  {
    departamento: "01",
    provincia: "01",
    distrito: "10",
    text: "Leimebamba",
  },
  {
    departamento: "01",
    provincia: "01",
    distrito: "11",
    text: "Levanto",
  },
  {
    departamento: "01",
    provincia: "01",
    distrito: "12",
    text: "Magdalena",
  },
  {
    departamento: "01",
    provincia: "01",
    distrito: "13",
    text: "Mariscal Castilla",
  },
  {
    departamento: "01",
    provincia: "01",
    distrito: "14",
    text: "Molinopampa",
  },
  {
    departamento: "01",
    provincia: "01",
    distrito: "15",
    text: "Montevideo",
  },
  {
    departamento: "01",
    provincia: "01",
    distrito: "16",
    text: "Olleros",
  },
  {
    departamento: "01",
    provincia: "01",
    distrito: "17",
    text: "Quinjalca",
  },
  {
    departamento: "01",
    provincia: "01",
    distrito: "18",
    text: "San Francisco de Daguas",
  },
  {
    departamento: "01",
    provincia: "01",
    distrito: "19",
    text: "San Isidro de Maino",
  },
  {
    departamento: "01",
    provincia: "01",
    distrito: "20",
    text: "Soloco",
  },
  {
    departamento: "01",
    provincia: "01",
    distrito: "21",
    text: "Sonche",
  },
  {
    departamento: "01",
    provincia: "02",
    distrito: "00",
    text: "Bagua",
  },
  {
    departamento: "01",
    provincia: "02",
    distrito: "01",
    text: "La Peca",
  },
  {
    departamento: "01",
    provincia: "02",
    distrito: "02",
    text: "Aramango",
  },
  {
    departamento: "01",
    provincia: "02",
    distrito: "03",
    text: "Copallin",
  },
  {
    departamento: "01",
    provincia: "02",
    distrito: "04",
    text: "El Parco",
  },
  {
    departamento: "01",
    provincia: "02",
    distrito: "05",
    text: "Bagua",
  },
  {
    departamento: "01",
    provincia: "02",
    distrito: "06",
    text: "Imaza",
  },
  {
    departamento: "01",
    provincia: "03",
    distrito: "00",
    text: "Bongará",
  },
  {
    departamento: "01",
    provincia: "03",
    distrito: "01",
    text: "Jumbilla",
  },
  {
    departamento: "01",
    provincia: "03",
    distrito: "02",
    text: "Corosha",
  },
  {
    departamento: "01",
    provincia: "03",
    distrito: "03",
    text: "Cuispes",
  },
  {
    departamento: "01",
    provincia: "03",
    distrito: "04",
    text: "Chisquilla",
  },
  {
    departamento: "01",
    provincia: "03",
    distrito: "05",
    text: "Churuja",
  },
  {
    departamento: "01",
    provincia: "03",
    distrito: "06",
    text: "Florida",
  },
  {
    departamento: "01",
    provincia: "03",
    distrito: "07",
    text: "Recta",
  },
  {
    departamento: "01",
    provincia: "03",
    distrito: "08",
    text: "San Carlos",
  },
  {
    departamento: "01",
    provincia: "03",
    distrito: "09",
    text: "Shipasbamba",
  },
  {
    departamento: "01",
    provincia: "03",
    distrito: "10",
    text: "Valera",
  },
  {
    departamento: "01",
    provincia: "03",
    distrito: "11",
    text: "Yambrasbamba",
  },
  {
    departamento: "01",
    provincia: "03",
    distrito: "12",
    text: "Jazan",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "00",
    text: "Luya",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "01",
    text: "Lamud",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "02",
    text: "Camporredondo",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "03",
    text: "Cocabamba",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "04",
    text: "Colcamar",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "05",
    text: "Conila",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "06",
    text: "Inguilpata",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "07",
    text: "Longuita",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "08",
    text: "Lonya Chico",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "09",
    text: "Luya",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "10",
    text: "Luya Viejo",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "11",
    text: "Maria",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "12",
    text: "Ocalli",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "13",
    text: "Ocumal",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "14",
    text: "Pisuquia",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "15",
    text: "San Cristóbal",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "16",
    text: "San Francisco del Yeso",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "17",
    text: "San Jerónimo",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "18",
    text: "San Juan de Lopecancha",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "19",
    text: "Santa Catalina",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "20",
    text: "Santo Tomas",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "21",
    text: "Tingo",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "22",
    text: "Trita",
  },
  {
    departamento: "01",
    provincia: "04",
    distrito: "23",
    text: "Providencia",
  },
  {
    departamento: "01",
    provincia: "05",
    distrito: "00",
    text: "Rodríguez de Mendoza",
  },
  {
    departamento: "01",
    provincia: "05",
    distrito: "01",
    text: "San Nicolas",
  },
  {
    departamento: "01",
    provincia: "05",
    distrito: "02",
    text: "Cochamal",
  },
  {
    departamento: "01",
    provincia: "05",
    distrito: "03",
    text: "Chirimoto",
  },
  {
    departamento: "01",
    provincia: "05",
    distrito: "04",
    text: "Huambo",
  },
  {
    departamento: "01",
    provincia: "05",
    distrito: "05",
    text: "Limabamba",
  },
  {
    departamento: "01",
    provincia: "05",
    distrito: "06",
    text: "Longar",
  },
  {
    departamento: "01",
    provincia: "05",
    distrito: "07",
    text: "Milpuc",
  },
  {
    departamento: "01",
    provincia: "05",
    distrito: "08",
    text: "Mariscal Benavides",
  },
  {
    departamento: "01",
    provincia: "05",
    distrito: "09",
    text: "Omia",
  },
  {
    departamento: "01",
    provincia: "05",
    distrito: "10",
    text: "Santa Rosa",
  },
  {
    departamento: "01",
    provincia: "05",
    distrito: "11",
    text: "Totora",
  },
  {
    departamento: "01",
    provincia: "05",
    distrito: "12",
    text: "Vista Alegre",
  },
  {
    departamento: "01",
    provincia: "06",
    distrito: "00",
    text: "Condorcanqui",
  },
  {
    departamento: "01",
    provincia: "06",
    distrito: "01",
    text: "Nieva",
  },
  {
    departamento: "01",
    provincia: "06",
    distrito: "02",
    text: "Rio Santiago",
  },
  {
    departamento: "01",
    provincia: "06",
    distrito: "03",
    text: "El Cenepa",
  },
  {
    departamento: "01",
    provincia: "07",
    distrito: "00",
    text: "Utcubamba",
  },
  {
    departamento: "01",
    provincia: "07",
    distrito: "01",
    text: "Bagua Grande",
  },
  {
    departamento: "01",
    provincia: "07",
    distrito: "02",
    text: "Cajaruro",
  },
  {
    departamento: "01",
    provincia: "07",
    distrito: "03",
    text: "Cumba",
  },
  {
    departamento: "01",
    provincia: "07",
    distrito: "04",
    text: "El Milagro",
  },
  {
    departamento: "01",
    provincia: "07",
    distrito: "05",
    text: "Jamalca",
  },
  {
    departamento: "01",
    provincia: "07",
    distrito: "06",
    text: "Lonya Grande",
  },
  {
    departamento: "01",
    provincia: "07",
    distrito: "07",
    text: "Yamon",
  },
  {
    departamento: "02",
    provincia: "00",
    distrito: "00",
    text: "Áncash",
  },
  {
    departamento: "02",
    provincia: "01",
    distrito: "00",
    text: "Huaraz",
  },
  {
    departamento: "02",
    provincia: "01",
    distrito: "01",
    text: "Huaraz",
  },
  {
    departamento: "02",
    provincia: "01",
    distrito: "02",
    text: "Independencia",
  },
  {
    departamento: "02",
    provincia: "01",
    distrito: "03",
    text: "Cochabamba",
  },
  {
    departamento: "02",
    provincia: "01",
    distrito: "04",
    text: "Colcabamba",
  },
  {
    departamento: "02",
    provincia: "01",
    distrito: "05",
    text: "Huanchay",
  },
  {
    departamento: "02",
    provincia: "01",
    distrito: "06",
    text: "Jangas",
  },
  {
    departamento: "02",
    provincia: "01",
    distrito: "07",
    text: "La Libertad",
  },
  {
    departamento: "02",
    provincia: "01",
    distrito: "08",
    text: "Olleros",
  },
  {
    departamento: "02",
    provincia: "01",
    distrito: "09",
    text: "Pampas",
  },
  {
    departamento: "02",
    provincia: "01",
    distrito: "10",
    text: "Pariacoto",
  },
  {
    departamento: "02",
    provincia: "01",
    distrito: "11",
    text: "Pira",
  },
  {
    departamento: "02",
    provincia: "01",
    distrito: "12",
    text: "Tarica",
  },
  {
    departamento: "02",
    provincia: "02",
    distrito: "00",
    text: "Aija",
  },
  {
    departamento: "02",
    provincia: "02",
    distrito: "01",
    text: "Aija",
  },
  {
    departamento: "02",
    provincia: "02",
    distrito: "03",
    text: "Coris",
  },
  {
    departamento: "02",
    provincia: "02",
    distrito: "05",
    text: "Huacllan",
  },
  {
    departamento: "02",
    provincia: "02",
    distrito: "06",
    text: "La Merced",
  },
  {
    departamento: "02",
    provincia: "02",
    distrito: "08",
    text: "Succha",
  },
  {
    departamento: "02",
    provincia: "03",
    distrito: "00",
    text: "Bolognesi",
  },
  {
    departamento: "02",
    provincia: "03",
    distrito: "01",
    text: "Chiquian",
  },
  {
    departamento: "02",
    provincia: "03",
    distrito: "02",
    text: "Abelardo Pardo Lezameta",
  },
  {
    departamento: "02",
    provincia: "03",
    distrito: "04",
    text: "Aquia",
  },
  {
    departamento: "02",
    provincia: "03",
    distrito: "05",
    text: "Cajacay",
  },
  {
    departamento: "02",
    provincia: "03",
    distrito: "10",
    text: "Huayllacayan",
  },
  {
    departamento: "02",
    provincia: "03",
    distrito: "11",
    text: "Huasta",
  },
  {
    departamento: "02",
    provincia: "03",
    distrito: "13",
    text: "Mangas",
  },
  {
    departamento: "02",
    provincia: "03",
    distrito: "15",
    text: "Pacllon",
  },
  {
    departamento: "02",
    provincia: "03",
    distrito: "17",
    text: "San Miguel de Corpanqui",
  },
  {
    departamento: "02",
    provincia: "03",
    distrito: "20",
    text: "Ticllos",
  },
  {
    departamento: "02",
    provincia: "03",
    distrito: "21",
    text: "Antonio Raymondi",
  },
  {
    departamento: "02",
    provincia: "03",
    distrito: "22",
    text: "Canis",
  },
  {
    departamento: "02",
    provincia: "03",
    distrito: "23",
    text: "Colquioc",
  },
  {
    departamento: "02",
    provincia: "03",
    distrito: "24",
    text: "La Primavera",
  },
  {
    departamento: "02",
    provincia: "03",
    distrito: "25",
    text: "Huallanca",
  },
  {
    departamento: "02",
    provincia: "04",
    distrito: "00",
    text: "Carhuaz",
  },
  {
    departamento: "02",
    provincia: "04",
    distrito: "01",
    text: "Carhuaz",
  },
  {
    departamento: "02",
    provincia: "04",
    distrito: "02",
    text: "Acopampa",
  },
  {
    departamento: "02",
    provincia: "04",
    distrito: "03",
    text: "Amashca",
  },
  {
    departamento: "02",
    provincia: "04",
    distrito: "04",
    text: "Anta",
  },
  {
    departamento: "02",
    provincia: "04",
    distrito: "05",
    text: "Ataquero",
  },
  {
    departamento: "02",
    provincia: "04",
    distrito: "06",
    text: "Marcara",
  },
  {
    departamento: "02",
    provincia: "04",
    distrito: "07",
    text: "Pariahuanca",
  },
  {
    departamento: "02",
    provincia: "04",
    distrito: "08",
    text: "San Miguel de Aco",
  },
  {
    departamento: "02",
    provincia: "04",
    distrito: "09",
    text: "Shilla",
  },
  {
    departamento: "02",
    provincia: "04",
    distrito: "10",
    text: "Tinco",
  },
  {
    departamento: "02",
    provincia: "04",
    distrito: "11",
    text: "Yungar",
  },
  {
    departamento: "02",
    provincia: "05",
    distrito: "00",
    text: "Casma",
  },
  {
    departamento: "02",
    provincia: "05",
    distrito: "01",
    text: "Casma",
  },
  {
    departamento: "02",
    provincia: "05",
    distrito: "02",
    text: "Buena Vista Alta",
  },
  {
    departamento: "02",
    provincia: "05",
    distrito: "03",
    text: "Comandante Noel",
  },
  {
    departamento: "02",
    provincia: "05",
    distrito: "05",
    text: "Yautan",
  },
  {
    departamento: "02",
    provincia: "06",
    distrito: "00",
    text: "Corongo",
  },
  {
    departamento: "02",
    provincia: "06",
    distrito: "01",
    text: "Corongo",
  },
  {
    departamento: "02",
    provincia: "06",
    distrito: "02",
    text: "Aco",
  },
  {
    departamento: "02",
    provincia: "06",
    distrito: "03",
    text: "Bambas",
  },
  {
    departamento: "02",
    provincia: "06",
    distrito: "04",
    text: "Cusca",
  },
  {
    departamento: "02",
    provincia: "06",
    distrito: "05",
    text: "La Pampa",
  },
  {
    departamento: "02",
    provincia: "06",
    distrito: "06",
    text: "Yanac",
  },
  {
    departamento: "02",
    provincia: "06",
    distrito: "07",
    text: "Yupan",
  },
  {
    departamento: "02",
    provincia: "07",
    distrito: "00",
    text: "Huaylas",
  },
  {
    departamento: "02",
    provincia: "07",
    distrito: "01",
    text: "Caraz",
  },
  {
    departamento: "02",
    provincia: "07",
    distrito: "02",
    text: "Huallanca",
  },
  {
    departamento: "02",
    provincia: "07",
    distrito: "03",
    text: "Huata",
  },
  {
    departamento: "02",
    provincia: "07",
    distrito: "04",
    text: "Huaylas",
  },
  {
    departamento: "02",
    provincia: "07",
    distrito: "05",
    text: "Mato",
  },
  {
    departamento: "02",
    provincia: "07",
    distrito: "06",
    text: "Pamparomas",
  },
  {
    departamento: "02",
    provincia: "07",
    distrito: "07",
    text: "Pueblo Libre",
  },
  {
    departamento: "02",
    provincia: "07",
    distrito: "08",
    text: "Santa Cruz",
  },
  {
    departamento: "02",
    provincia: "07",
    distrito: "09",
    text: "Yuracmarca",
  },
  {
    departamento: "02",
    provincia: "07",
    distrito: "10",
    text: "Santo Toribio",
  },
  {
    departamento: "02",
    provincia: "08",
    distrito: "00",
    text: "Huari",
  },
  {
    departamento: "02",
    provincia: "08",
    distrito: "01",
    text: "Huari",
  },
  {
    departamento: "02",
    provincia: "08",
    distrito: "02",
    text: "Cajay",
  },
  {
    departamento: "02",
    provincia: "08",
    distrito: "03",
    text: "Chavin de Huantar",
  },
  {
    departamento: "02",
    provincia: "08",
    distrito: "04",
    text: "Huacachi",
  },
  {
    departamento: "02",
    provincia: "08",
    distrito: "05",
    text: "Huachis",
  },
  {
    departamento: "02",
    provincia: "08",
    distrito: "06",
    text: "Huacchis",
  },
  {
    departamento: "02",
    provincia: "08",
    distrito: "07",
    text: "Huantar",
  },
  {
    departamento: "02",
    provincia: "08",
    distrito: "08",
    text: "Masin",
  },
  {
    departamento: "02",
    provincia: "08",
    distrito: "09",
    text: "Paucas",
  },
  {
    departamento: "02",
    provincia: "08",
    distrito: "10",
    text: "Ponto",
  },
  {
    departamento: "02",
    provincia: "08",
    distrito: "11",
    text: "Rahuapampa",
  },
  {
    departamento: "02",
    provincia: "08",
    distrito: "12",
    text: "Rapayan",
  },
  {
    departamento: "02",
    provincia: "08",
    distrito: "13",
    text: "San Marcos",
  },
  {
    departamento: "02",
    provincia: "08",
    distrito: "14",
    text: "San Pedro de Chana",
  },
  {
    departamento: "02",
    provincia: "08",
    distrito: "15",
    text: "Uco",
  },
  {
    departamento: "02",
    provincia: "08",
    distrito: "16",
    text: "Anra",
  },
  {
    departamento: "02",
    provincia: "09",
    distrito: "00",
    text: "Mariscal Luzuriaga",
  },
  {
    departamento: "02",
    provincia: "09",
    distrito: "01",
    text: "Piscobamba",
  },
  {
    departamento: "02",
    provincia: "09",
    distrito: "02",
    text: "Casca",
  },
  {
    departamento: "02",
    provincia: "09",
    distrito: "03",
    text: "Lucma",
  },
  {
    departamento: "02",
    provincia: "09",
    distrito: "04",
    text: "Fidel Olivas Escudero",
  },
  {
    departamento: "02",
    provincia: "09",
    distrito: "05",
    text: "Llama",
  },
  {
    departamento: "02",
    provincia: "09",
    distrito: "06",
    text: "Llumpa",
  },
  {
    departamento: "02",
    provincia: "09",
    distrito: "07",
    text: "Musga",
  },
  {
    departamento: "02",
    provincia: "09",
    distrito: "08",
    text: "Eleazar Guzmán Barron",
  },
  {
    departamento: "02",
    provincia: "10",
    distrito: "00",
    text: "Pallasca",
  },
  {
    departamento: "02",
    provincia: "10",
    distrito: "01",
    text: "Cabana",
  },
  {
    departamento: "02",
    provincia: "10",
    distrito: "02",
    text: "Bolognesi",
  },
  {
    departamento: "02",
    provincia: "10",
    distrito: "03",
    text: "Conchucos",
  },
  {
    departamento: "02",
    provincia: "10",
    distrito: "04",
    text: "Huacaschuque",
  },
  {
    departamento: "02",
    provincia: "10",
    distrito: "05",
    text: "Huandoval",
  },
  {
    departamento: "02",
    provincia: "10",
    distrito: "06",
    text: "Lacabamba",
  },
  {
    departamento: "02",
    provincia: "10",
    distrito: "07",
    text: "Llapo",
  },
  {
    departamento: "02",
    provincia: "10",
    distrito: "08",
    text: "Pallasca",
  },
  {
    departamento: "02",
    provincia: "10",
    distrito: "09",
    text: "Pampas",
  },
  {
    departamento: "02",
    provincia: "10",
    distrito: "10",
    text: "Santa Rosa",
  },
  {
    departamento: "02",
    provincia: "10",
    distrito: "11",
    text: "Tauca",
  },
  {
    departamento: "02",
    provincia: "11",
    distrito: "00",
    text: "Pomabamba",
  },
  {
    departamento: "02",
    provincia: "11",
    distrito: "01",
    text: "Pomabamba",
  },
  {
    departamento: "02",
    provincia: "11",
    distrito: "02",
    text: "Huayllan",
  },
  {
    departamento: "02",
    provincia: "11",
    distrito: "03",
    text: "Parobamba",
  },
  {
    departamento: "02",
    provincia: "11",
    distrito: "04",
    text: "Quinuabamba",
  },
  {
    departamento: "02",
    provincia: "12",
    distrito: "00",
    text: "Recuay",
  },
  {
    departamento: "02",
    provincia: "12",
    distrito: "01",
    text: "Recuay",
  },
  {
    departamento: "02",
    provincia: "12",
    distrito: "02",
    text: "Cotaparaco",
  },
  {
    departamento: "02",
    provincia: "12",
    distrito: "03",
    text: "Huayllapampa",
  },
  {
    departamento: "02",
    provincia: "12",
    distrito: "04",
    text: "Marca",
  },
  {
    departamento: "02",
    provincia: "12",
    distrito: "05",
    text: "Pampas Chico",
  },
  {
    departamento: "02",
    provincia: "12",
    distrito: "06",
    text: "Pararin",
  },
  {
    departamento: "02",
    provincia: "12",
    distrito: "07",
    text: "Tapacocha",
  },
  {
    departamento: "02",
    provincia: "12",
    distrito: "08",
    text: "Ticapampa",
  },
  {
    departamento: "02",
    provincia: "12",
    distrito: "09",
    text: "Llacllin",
  },
  {
    departamento: "02",
    provincia: "12",
    distrito: "10",
    text: "Catac",
  },
  {
    departamento: "02",
    provincia: "13",
    distrito: "00",
    text: "Santa",
  },
  {
    departamento: "02",
    provincia: "13",
    distrito: "01",
    text: "Chimbote",
  },
  {
    departamento: "02",
    provincia: "13",
    distrito: "02",
    text: "Cáceres del Perú",
  },
  {
    departamento: "02",
    provincia: "13",
    distrito: "03",
    text: "Macate",
  },
  {
    departamento: "02",
    provincia: "13",
    distrito: "04",
    text: "Moro",
  },
  {
    departamento: "02",
    provincia: "13",
    distrito: "05",
    text: "Nepeña",
  },
  {
    departamento: "02",
    provincia: "13",
    distrito: "06",
    text: "Samanco",
  },
  {
    departamento: "02",
    provincia: "13",
    distrito: "07",
    text: "Santa",
  },
  {
    departamento: "02",
    provincia: "13",
    distrito: "08",
    text: "Coishco",
  },
  {
    departamento: "02",
    provincia: "13",
    distrito: "09",
    text: "Nuevo Chimbote",
  },
  {
    departamento: "02",
    provincia: "14",
    distrito: "00",
    text: "Sihuas",
  },
  {
    departamento: "02",
    provincia: "14",
    distrito: "01",
    text: "Sihuas",
  },
  {
    departamento: "02",
    provincia: "14",
    distrito: "02",
    text: "Alfonso Ugarte",
  },
  {
    departamento: "02",
    provincia: "14",
    distrito: "03",
    text: "Chingalpo",
  },
  {
    departamento: "02",
    provincia: "14",
    distrito: "04",
    text: "Huayllabamba",
  },
  {
    departamento: "02",
    provincia: "14",
    distrito: "05",
    text: "Quiches",
  },
  {
    departamento: "02",
    provincia: "14",
    distrito: "06",
    text: "Sicsibamba",
  },
  {
    departamento: "02",
    provincia: "14",
    distrito: "07",
    text: "Acobamba",
  },
  {
    departamento: "02",
    provincia: "14",
    distrito: "08",
    text: "Cashapampa",
  },
  {
    departamento: "02",
    provincia: "14",
    distrito: "09",
    text: "Ragash",
  },
  {
    departamento: "02",
    provincia: "14",
    distrito: "10",
    text: "San Juan",
  },
  {
    departamento: "02",
    provincia: "15",
    distrito: "00",
    text: "Yungay",
  },
  {
    departamento: "02",
    provincia: "15",
    distrito: "01",
    text: "Yungay",
  },
  {
    departamento: "02",
    provincia: "15",
    distrito: "02",
    text: "Cascapara",
  },
  {
    departamento: "02",
    provincia: "15",
    distrito: "03",
    text: "Mancos",
  },
  {
    departamento: "02",
    provincia: "15",
    distrito: "04",
    text: "Matacoto",
  },
  {
    departamento: "02",
    provincia: "15",
    distrito: "05",
    text: "Quillo",
  },
  {
    departamento: "02",
    provincia: "15",
    distrito: "06",
    text: "Ranrahirca",
  },
  {
    departamento: "02",
    provincia: "15",
    distrito: "07",
    text: "Shupluy",
  },
  {
    departamento: "02",
    provincia: "15",
    distrito: "08",
    text: "Yanama",
  },
  {
    departamento: "02",
    provincia: "16",
    distrito: "00",
    text: "Antonio Raymondi",
  },
  {
    departamento: "02",
    provincia: "16",
    distrito: "01",
    text: "Llamellin",
  },
  {
    departamento: "02",
    provincia: "16",
    distrito: "02",
    text: "Aczo",
  },
  {
    departamento: "02",
    provincia: "16",
    distrito: "03",
    text: "Chaccho",
  },
  {
    departamento: "02",
    provincia: "16",
    distrito: "04",
    text: "Chingas",
  },
  {
    departamento: "02",
    provincia: "16",
    distrito: "05",
    text: "Mirgas",
  },
  {
    departamento: "02",
    provincia: "16",
    distrito: "06",
    text: "San Juan de Rontoy",
  },
  {
    departamento: "02",
    provincia: "17",
    distrito: "00",
    text: "Carlos Fermín Fitzcarral",
  },
  {
    departamento: "02",
    provincia: "17",
    distrito: "01",
    text: "San Luis",
  },
  {
    departamento: "02",
    provincia: "17",
    distrito: "02",
    text: "Yauya",
  },
  {
    departamento: "02",
    provincia: "17",
    distrito: "03",
    text: "San Nicolas",
  },
  {
    departamento: "02",
    provincia: "18",
    distrito: "00",
    text: "Asunción",
  },
  {
    departamento: "02",
    provincia: "18",
    distrito: "01",
    text: "Chacas",
  },
  {
    departamento: "02",
    provincia: "18",
    distrito: "02",
    text: "Acochaca",
  },
  {
    departamento: "02",
    provincia: "19",
    distrito: "00",
    text: "Huarmey",
  },
  {
    departamento: "02",
    provincia: "19",
    distrito: "01",
    text: "Huarmey",
  },
  {
    departamento: "02",
    provincia: "19",
    distrito: "02",
    text: "Cochapeti",
  },
  {
    departamento: "02",
    provincia: "19",
    distrito: "03",
    text: "Huayan",
  },
  {
    departamento: "02",
    provincia: "19",
    distrito: "04",
    text: "Malvas",
  },
  {
    departamento: "02",
    provincia: "19",
    distrito: "05",
    text: "Culebras",
  },
  {
    departamento: "02",
    provincia: "20",
    distrito: "00",
    text: "Ocros",
  },
  {
    departamento: "02",
    provincia: "20",
    distrito: "01",
    text: "Acas",
  },
  {
    departamento: "02",
    provincia: "20",
    distrito: "02",
    text: "Cajamarquilla",
  },
  {
    departamento: "02",
    provincia: "20",
    distrito: "03",
    text: "Carhuapampa",
  },
  {
    departamento: "02",
    provincia: "20",
    distrito: "04",
    text: "Cochas",
  },
  {
    departamento: "02",
    provincia: "20",
    distrito: "05",
    text: "Congas",
  },
  {
    departamento: "02",
    provincia: "20",
    distrito: "06",
    text: "Llipa",
  },
  {
    departamento: "02",
    provincia: "20",
    distrito: "07",
    text: "Ocros",
  },
  {
    departamento: "02",
    provincia: "20",
    distrito: "08",
    text: "San Cristóbal de Rajan",
  },
  {
    departamento: "02",
    provincia: "20",
    distrito: "09",
    text: "San Pedro",
  },
  {
    departamento: "02",
    provincia: "20",
    distrito: "10",
    text: "Santiago de Chilcas",
  },
  {
    departamento: "03",
    provincia: "00",
    distrito: "00",
    text: "Apurímac",
  },
  {
    departamento: "03",
    provincia: "01",
    distrito: "00",
    text: "Abancay",
  },
  {
    departamento: "03",
    provincia: "01",
    distrito: "01",
    text: "Abancay",
  },
  {
    departamento: "03",
    provincia: "01",
    distrito: "02",
    text: "Circa",
  },
  {
    departamento: "03",
    provincia: "01",
    distrito: "03",
    text: "Curahuasi",
  },
  {
    departamento: "03",
    provincia: "01",
    distrito: "04",
    text: "Chacoche",
  },
  {
    departamento: "03",
    provincia: "01",
    distrito: "05",
    text: "Huanipaca",
  },
  {
    departamento: "03",
    provincia: "01",
    distrito: "06",
    text: "Lambrama",
  },
  {
    departamento: "03",
    provincia: "01",
    distrito: "07",
    text: "Pichirhua",
  },
  {
    departamento: "03",
    provincia: "01",
    distrito: "08",
    text: "San Pedro de Cachora",
  },
  {
    departamento: "03",
    provincia: "01",
    distrito: "09",
    text: "Tamburco",
  },
  {
    departamento: "03",
    provincia: "02",
    distrito: "00",
    text: "Aymaraes",
  },
  {
    departamento: "03",
    provincia: "02",
    distrito: "01",
    text: "Chalhuanca",
  },
  {
    departamento: "03",
    provincia: "02",
    distrito: "02",
    text: "Capaya",
  },
  {
    departamento: "03",
    provincia: "02",
    distrito: "03",
    text: "Caraybamba",
  },
  {
    departamento: "03",
    provincia: "02",
    distrito: "04",
    text: "Colcabamba",
  },
  {
    departamento: "03",
    provincia: "02",
    distrito: "05",
    text: "Cotaruse",
  },
  {
    departamento: "03",
    provincia: "02",
    distrito: "06",
    text: "Chapimarca",
  },
  {
    departamento: "03",
    provincia: "02",
    distrito: "07",
    text: "Huayllo",
  },
  {
    departamento: "03",
    provincia: "02",
    distrito: "08",
    text: "Lucre",
  },
  {
    departamento: "03",
    provincia: "02",
    distrito: "09",
    text: "Pocohuanca",
  },
  {
    departamento: "03",
    provincia: "02",
    distrito: "10",
    text: "Sañayca",
  },
  {
    departamento: "03",
    provincia: "02",
    distrito: "11",
    text: "Soraya",
  },
  {
    departamento: "03",
    provincia: "02",
    distrito: "12",
    text: "Tapairihua",
  },
  {
    departamento: "03",
    provincia: "02",
    distrito: "13",
    text: "Tintay",
  },
  {
    departamento: "03",
    provincia: "02",
    distrito: "14",
    text: "Toraya",
  },
  {
    departamento: "03",
    provincia: "02",
    distrito: "15",
    text: "Yanaca",
  },
  {
    departamento: "03",
    provincia: "02",
    distrito: "16",
    text: "San Juan de Chacña",
  },
  {
    departamento: "03",
    provincia: "02",
    distrito: "17",
    text: "Justo Apu Sahuaraura",
  },
  {
    departamento: "03",
    provincia: "03",
    distrito: "00",
    text: "Andahuaylas",
  },
  {
    departamento: "03",
    provincia: "03",
    distrito: "01",
    text: "Andahuaylas",
  },
  {
    departamento: "03",
    provincia: "03",
    distrito: "02",
    text: "Andarapa",
  },
  {
    departamento: "03",
    provincia: "03",
    distrito: "03",
    text: "Chiara",
  },
  {
    departamento: "03",
    provincia: "03",
    distrito: "04",
    text: "Huancarama",
  },
  {
    departamento: "03",
    provincia: "03",
    distrito: "05",
    text: "Huancaray",
  },
  {
    departamento: "03",
    provincia: "03",
    distrito: "06",
    text: "Kishuara",
  },
  {
    departamento: "03",
    provincia: "03",
    distrito: "07",
    text: "Pacobamba",
  },
  {
    departamento: "03",
    provincia: "03",
    distrito: "08",
    text: "Pampachiri",
  },
  {
    departamento: "03",
    provincia: "03",
    distrito: "09",
    text: "San Antonio de Cachi",
  },
  {
    departamento: "03",
    provincia: "03",
    distrito: "10",
    text: "San Jerónimo",
  },
  {
    departamento: "03",
    provincia: "03",
    distrito: "11",
    text: "Talavera",
  },
  {
    departamento: "03",
    provincia: "03",
    distrito: "12",
    text: "Turpo",
  },
  {
    departamento: "03",
    provincia: "03",
    distrito: "13",
    text: "Pacucha",
  },
  {
    departamento: "03",
    provincia: "03",
    distrito: "14",
    text: "Pomacocha",
  },
  {
    departamento: "03",
    provincia: "03",
    distrito: "15",
    text: "Santa Maria de Chicmo",
  },
  {
    departamento: "03",
    provincia: "03",
    distrito: "16",
    text: "Tumay Huaraca",
  },
  {
    departamento: "03",
    provincia: "03",
    distrito: "17",
    text: "Huayana",
  },
  {
    departamento: "03",
    provincia: "03",
    distrito: "18",
    text: "San Miguel de Chaccrampa",
  },
  {
    departamento: "03",
    provincia: "03",
    distrito: "19",
    text: "Kaquiabamba",
  },
  {
    departamento: "03",
    provincia: "04",
    distrito: "00",
    text: "Antabamba",
  },
  {
    departamento: "03",
    provincia: "04",
    distrito: "01",
    text: "Antabamba",
  },
  {
    departamento: "03",
    provincia: "04",
    distrito: "02",
    text: "El Oro",
  },
  {
    departamento: "03",
    provincia: "04",
    distrito: "03",
    text: "Huaquirca",
  },
  {
    departamento: "03",
    provincia: "04",
    distrito: "04",
    text: "Juan Espinoza Medrano",
  },
  {
    departamento: "03",
    provincia: "04",
    distrito: "05",
    text: "Oropesa",
  },
  {
    departamento: "03",
    provincia: "04",
    distrito: "06",
    text: "Pachaconas",
  },
  {
    departamento: "03",
    provincia: "04",
    distrito: "07",
    text: "Sabaino",
  },
  {
    departamento: "03",
    provincia: "05",
    distrito: "00",
    text: "Cotabambas",
  },
  {
    departamento: "03",
    provincia: "05",
    distrito: "01",
    text: "Tambobamba",
  },
  {
    departamento: "03",
    provincia: "05",
    distrito: "02",
    text: "Coyllurqui",
  },
  {
    departamento: "03",
    provincia: "05",
    distrito: "03",
    text: "Cotabambas",
  },
  {
    departamento: "03",
    provincia: "05",
    distrito: "04",
    text: "Haquira",
  },
  {
    departamento: "03",
    provincia: "05",
    distrito: "05",
    text: "Mara",
  },
  {
    departamento: "03",
    provincia: "05",
    distrito: "06",
    text: "Challhuahuacho",
  },
  {
    departamento: "03",
    provincia: "06",
    distrito: "00",
    text: "Grau",
  },
  {
    departamento: "03",
    provincia: "06",
    distrito: "01",
    text: "Chuquibambilla",
  },
  {
    departamento: "03",
    provincia: "06",
    distrito: "02",
    text: "Curpahuasi",
  },
  {
    departamento: "03",
    provincia: "06",
    distrito: "03",
    text: "Huayllati",
  },
  {
    departamento: "03",
    provincia: "06",
    distrito: "04",
    text: "Mamara",
  },
  {
    departamento: "03",
    provincia: "06",
    distrito: "05",
    text: "Gamarra",
  },
  {
    departamento: "03",
    provincia: "06",
    distrito: "06",
    text: "Micaela Bastidas",
  },
  {
    departamento: "03",
    provincia: "06",
    distrito: "07",
    text: "Progreso",
  },
  {
    departamento: "03",
    provincia: "06",
    distrito: "08",
    text: "Pataypampa",
  },
  {
    departamento: "03",
    provincia: "06",
    distrito: "09",
    text: "San Antonio",
  },
  {
    departamento: "03",
    provincia: "06",
    distrito: "10",
    text: "Turpay",
  },
  {
    departamento: "03",
    provincia: "06",
    distrito: "11",
    text: "Vilcabamba",
  },
  {
    departamento: "03",
    provincia: "06",
    distrito: "12",
    text: "Virundo",
  },
  {
    departamento: "03",
    provincia: "06",
    distrito: "13",
    text: "Santa Rosa",
  },
  {
    departamento: "03",
    provincia: "06",
    distrito: "14",
    text: "Curasco",
  },
  {
    departamento: "03",
    provincia: "07",
    distrito: "00",
    text: "Chincheros",
  },
  {
    departamento: "03",
    provincia: "07",
    distrito: "01",
    text: "Chincheros",
  },
  {
    departamento: "03",
    provincia: "07",
    distrito: "02",
    text: "Ongoy",
  },
  {
    departamento: "03",
    provincia: "07",
    distrito: "03",
    text: "Ocobamba",
  },
  {
    departamento: "03",
    provincia: "07",
    distrito: "04",
    text: "Cocharcas",
  },
  {
    departamento: "03",
    provincia: "07",
    distrito: "05",
    text: "Anco Huallo",
  },
  {
    departamento: "03",
    provincia: "07",
    distrito: "06",
    text: "Huaccana",
  },
  {
    departamento: "03",
    provincia: "07",
    distrito: "07",
    text: "Uranmarca",
  },
  {
    departamento: "03",
    provincia: "07",
    distrito: "08",
    text: "Ranracancha",
  },
  {
    departamento: "04",
    provincia: "00",
    distrito: "00",
    text: "Arequipa",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "00",
    text: "Arequipa",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "01",
    text: "Arequipa",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "02",
    text: "Cayma",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "03",
    text: "Cerro Colorado",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "04",
    text: "Characato",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "05",
    text: "Chiguata",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "06",
    text: "La Joya",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "07",
    text: "Miraflores",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "08",
    text: "Mollebaya",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "09",
    text: "Paucarpata",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "10",
    text: "Pocsi",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "11",
    text: "Polobaya",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "12",
    text: "Quequeña",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "13",
    text: "Sabandia",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "14",
    text: "Sachaca",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "15",
    text: "San Juan de Siguas",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "16",
    text: "San Juan de Tarucani",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "17",
    text: "Santa Isabel de Siguas",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "18",
    text: "Santa Rita de Siguas",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "19",
    text: "Socabaya",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "20",
    text: "Tiabaya",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "21",
    text: "Uchumayo",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "22",
    text: "Vitor",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "23",
    text: "Yanahuara",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "24",
    text: "Yarabamba",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "25",
    text: "Yura",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "26",
    text: "Mariano Melgar",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "27",
    text: "Jacobo Hunter",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "28",
    text: "Alto Selva Alegre",
  },
  {
    departamento: "04",
    provincia: "01",
    distrito: "29",
    text: "José Luis Bustamante y Rivero",
  },
  {
    departamento: "04",
    provincia: "02",
    distrito: "00",
    text: "Caylloma",
  },
  {
    departamento: "04",
    provincia: "02",
    distrito: "01",
    text: "Chivay",
  },
  {
    departamento: "04",
    provincia: "02",
    distrito: "02",
    text: "Achoma",
  },
  {
    departamento: "04",
    provincia: "02",
    distrito: "03",
    text: "Cabanaconde",
  },
  {
    departamento: "04",
    provincia: "02",
    distrito: "04",
    text: "Caylloma",
  },
  {
    departamento: "04",
    provincia: "02",
    distrito: "05",
    text: "Callalli",
  },
  {
    departamento: "04",
    provincia: "02",
    distrito: "06",
    text: "Coporaque",
  },
  {
    departamento: "04",
    provincia: "02",
    distrito: "07",
    text: "Huambo",
  },
  {
    departamento: "04",
    provincia: "02",
    distrito: "08",
    text: "Huanca",
  },
  {
    departamento: "04",
    provincia: "02",
    distrito: "09",
    text: "Ichupampa",
  },
  {
    departamento: "04",
    provincia: "02",
    distrito: "10",
    text: "Lari",
  },
  {
    departamento: "04",
    provincia: "02",
    distrito: "11",
    text: "Lluta",
  },
  {
    departamento: "04",
    provincia: "02",
    distrito: "12",
    text: "Maca",
  },
  {
    departamento: "04",
    provincia: "02",
    distrito: "13",
    text: "Madrigal",
  },
  {
    departamento: "04",
    provincia: "02",
    distrito: "14",
    text: "San Antonio de Chuca",
  },
  {
    departamento: "04",
    provincia: "02",
    distrito: "15",
    text: "Sibayo",
  },
  {
    departamento: "04",
    provincia: "02",
    distrito: "16",
    text: "Tapay",
  },
  {
    departamento: "04",
    provincia: "02",
    distrito: "17",
    text: "Tisco",
  },
  {
    departamento: "04",
    provincia: "02",
    distrito: "18",
    text: "Tuti",
  },
  {
    departamento: "04",
    provincia: "02",
    distrito: "19",
    text: "Yanque",
  },
  {
    departamento: "04",
    provincia: "02",
    distrito: "20",
    text: "Majes",
  },
  {
    departamento: "04",
    provincia: "03",
    distrito: "00",
    text: "Camaná",
  },
  {
    departamento: "04",
    provincia: "03",
    distrito: "01",
    text: "Camaná",
  },
  {
    departamento: "04",
    provincia: "03",
    distrito: "02",
    text: "José Maria Quimper",
  },
  {
    departamento: "04",
    provincia: "03",
    distrito: "03",
    text: "Mariano Nicolas Valcárcel",
  },
  {
    departamento: "04",
    provincia: "03",
    distrito: "04",
    text: "Mariscal Cáceres",
  },
  {
    departamento: "04",
    provincia: "03",
    distrito: "05",
    text: "Nicolas de Pierola",
  },
  {
    departamento: "04",
    provincia: "03",
    distrito: "06",
    text: "Ocoña",
  },
  {
    departamento: "04",
    provincia: "03",
    distrito: "07",
    text: "Quilca",
  },
  {
    departamento: "04",
    provincia: "03",
    distrito: "08",
    text: "Samuel Pastor",
  },
  {
    departamento: "04",
    provincia: "04",
    distrito: "00",
    text: "Caravelí",
  },
  {
    departamento: "04",
    provincia: "04",
    distrito: "01",
    text: "Caravelí",
  },
  {
    departamento: "04",
    provincia: "04",
    distrito: "02",
    text: "Acarí",
  },
  {
    departamento: "04",
    provincia: "04",
    distrito: "03",
    text: "Atico",
  },
  {
    departamento: "04",
    provincia: "04",
    distrito: "04",
    text: "Atiquipa",
  },
  {
    departamento: "04",
    provincia: "04",
    distrito: "05",
    text: "Bella Union",
  },
  {
    departamento: "04",
    provincia: "04",
    distrito: "06",
    text: "Cahuacho",
  },
  {
    departamento: "04",
    provincia: "04",
    distrito: "07",
    text: "Chala",
  },
  {
    departamento: "04",
    provincia: "04",
    distrito: "08",
    text: "Chaparra",
  },
  {
    departamento: "04",
    provincia: "04",
    distrito: "09",
    text: "Huanuhuanu",
  },
  {
    departamento: "04",
    provincia: "04",
    distrito: "10",
    text: "Jaqui",
  },
  {
    departamento: "04",
    provincia: "04",
    distrito: "11",
    text: "Lomas",
  },
  {
    departamento: "04",
    provincia: "04",
    distrito: "12",
    text: "Quicacha",
  },
  {
    departamento: "04",
    provincia: "04",
    distrito: "13",
    text: "Yauca",
  },
  {
    departamento: "04",
    provincia: "05",
    distrito: "00",
    text: "Castilla",
  },
  {
    departamento: "04",
    provincia: "05",
    distrito: "01",
    text: "Aplao",
  },
  {
    departamento: "04",
    provincia: "05",
    distrito: "02",
    text: "Andagua",
  },
  {
    departamento: "04",
    provincia: "05",
    distrito: "03",
    text: "Ayo",
  },
  {
    departamento: "04",
    provincia: "05",
    distrito: "04",
    text: "Chachas",
  },
  {
    departamento: "04",
    provincia: "05",
    distrito: "05",
    text: "Chilcaymarca",
  },
  {
    departamento: "04",
    provincia: "05",
    distrito: "06",
    text: "Choco",
  },
  {
    departamento: "04",
    provincia: "05",
    distrito: "07",
    text: "Huancarqui",
  },
  {
    departamento: "04",
    provincia: "05",
    distrito: "08",
    text: "Machaguay",
  },
  {
    departamento: "04",
    provincia: "05",
    distrito: "09",
    text: "Orcopampa",
  },
  {
    departamento: "04",
    provincia: "05",
    distrito: "10",
    text: "Pampacolca",
  },
  {
    departamento: "04",
    provincia: "05",
    distrito: "11",
    text: "Tipan",
  },
  {
    departamento: "04",
    provincia: "05",
    distrito: "12",
    text: "Uraca",
  },
  {
    departamento: "04",
    provincia: "05",
    distrito: "13",
    text: "Uñon",
  },
  {
    departamento: "04",
    provincia: "05",
    distrito: "14",
    text: "Viraco",
  },
  {
    departamento: "04",
    provincia: "06",
    distrito: "00",
    text: "Condesuyos",
  },
  {
    departamento: "04",
    provincia: "06",
    distrito: "01",
    text: "Chuquibamba",
  },
  {
    departamento: "04",
    provincia: "06",
    distrito: "02",
    text: "Andaray",
  },
  {
    departamento: "04",
    provincia: "06",
    distrito: "03",
    text: "Cayarani",
  },
  {
    departamento: "04",
    provincia: "06",
    distrito: "04",
    text: "Chichas",
  },
  {
    departamento: "04",
    provincia: "06",
    distrito: "05",
    text: "Iray",
  },
  {
    departamento: "04",
    provincia: "06",
    distrito: "06",
    text: "Salamanca",
  },
  {
    departamento: "04",
    provincia: "06",
    distrito: "07",
    text: "Yanaquihua",
  },
  {
    departamento: "04",
    provincia: "06",
    distrito: "08",
    text: "Rio Grande",
  },
  {
    departamento: "04",
    provincia: "07",
    distrito: "00",
    text: "Islay",
  },
  {
    departamento: "04",
    provincia: "07",
    distrito: "01",
    text: "Mollendo",
  },
  {
    departamento: "04",
    provincia: "07",
    distrito: "02",
    text: "Cocachacra",
  },
  {
    departamento: "04",
    provincia: "07",
    distrito: "03",
    text: "Dean Valdivia",
  },
  {
    departamento: "04",
    provincia: "07",
    distrito: "04",
    text: "Islay",
  },
  {
    departamento: "04",
    provincia: "07",
    distrito: "05",
    text: "Mejia",
  },
  {
    departamento: "04",
    provincia: "07",
    distrito: "06",
    text: "Punta de Bombón",
  },
  {
    departamento: "04",
    provincia: "08",
    distrito: "00",
    text: "La Union",
  },
  {
    departamento: "04",
    provincia: "08",
    distrito: "01",
    text: "Cotahuasi",
  },
  {
    departamento: "04",
    provincia: "08",
    distrito: "02",
    text: "Alca",
  },
  {
    departamento: "04",
    provincia: "08",
    distrito: "03",
    text: "Charcana",
  },
  {
    departamento: "04",
    provincia: "08",
    distrito: "04",
    text: "Huaynacotas",
  },
  {
    departamento: "04",
    provincia: "08",
    distrito: "05",
    text: "Pampamarca",
  },
  {
    departamento: "04",
    provincia: "08",
    distrito: "06",
    text: "Puyca",
  },
  {
    departamento: "04",
    provincia: "08",
    distrito: "07",
    text: "Quechualla",
  },
  {
    departamento: "04",
    provincia: "08",
    distrito: "08",
    text: "Sayla",
  },
  {
    departamento: "04",
    provincia: "08",
    distrito: "09",
    text: "Tauria",
  },
  {
    departamento: "04",
    provincia: "08",
    distrito: "10",
    text: "Tomepampa",
  },
  {
    departamento: "04",
    provincia: "08",
    distrito: "11",
    text: "Toro",
  },
  {
    departamento: "05",
    provincia: "00",
    distrito: "00",
    text: "Ayacucho",
  },
  {
    departamento: "05",
    provincia: "01",
    distrito: "00",
    text: "Huamanga",
  },
  {
    departamento: "05",
    provincia: "01",
    distrito: "01",
    text: "Ayacucho",
  },
  {
    departamento: "05",
    provincia: "01",
    distrito: "02",
    text: "Acos Vinchos",
  },
  {
    departamento: "05",
    provincia: "01",
    distrito: "03",
    text: "Carmen Alto",
  },
  {
    departamento: "05",
    provincia: "01",
    distrito: "04",
    text: "Chiara",
  },
  {
    departamento: "05",
    provincia: "01",
    distrito: "05",
    text: "Quinua",
  },
  {
    departamento: "05",
    provincia: "01",
    distrito: "06",
    text: "San José de Ticllas",
  },
  {
    departamento: "05",
    provincia: "01",
    distrito: "07",
    text: "San Juan Bautista",
  },
  {
    departamento: "05",
    provincia: "01",
    distrito: "08",
    text: "Santiago de Pischa",
  },
  {
    departamento: "05",
    provincia: "01",
    distrito: "09",
    text: "Vinchos",
  },
  {
    departamento: "05",
    provincia: "01",
    distrito: "10",
    text: "Tambillo",
  },
  {
    departamento: "05",
    provincia: "01",
    distrito: "11",
    text: "Acocro",
  },
  {
    departamento: "05",
    provincia: "01",
    distrito: "12",
    text: "Socos",
  },
  {
    departamento: "05",
    provincia: "01",
    distrito: "13",
    text: "Ocros",
  },
  {
    departamento: "05",
    provincia: "01",
    distrito: "14",
    text: "Pacaycasa",
  },
  {
    departamento: "05",
    provincia: "01",
    distrito: "15",
    text: "Jesus Nazareno",
  },
  {
    departamento: "05",
    provincia: "02",
    distrito: "00",
    text: "Cangallo",
  },
  {
    departamento: "05",
    provincia: "02",
    distrito: "01",
    text: "Cangallo",
  },
  {
    departamento: "05",
    provincia: "02",
    distrito: "04",
    text: "Chuschi",
  },
  {
    departamento: "05",
    provincia: "02",
    distrito: "06",
    text: "Los Morochucos",
  },
  {
    departamento: "05",
    provincia: "02",
    distrito: "07",
    text: "Paras",
  },
  {
    departamento: "05",
    provincia: "02",
    distrito: "08",
    text: "Totos",
  },
  {
    departamento: "05",
    provincia: "02",
    distrito: "11",
    text: "Maria Parado de Bellido",
  },
  {
    departamento: "05",
    provincia: "03",
    distrito: "00",
    text: "Huanta",
  },
  {
    departamento: "05",
    provincia: "03",
    distrito: "01",
    text: "Huanta",
  },
  {
    departamento: "05",
    provincia: "03",
    distrito: "02",
    text: "Ayahuanco",
  },
  {
    departamento: "05",
    provincia: "03",
    distrito: "03",
    text: "Huamanguilla",
  },
  {
    departamento: "05",
    provincia: "03",
    distrito: "04",
    text: "Iguain",
  },
  {
    departamento: "05",
    provincia: "03",
    distrito: "05",
    text: "Luricocha",
  },
  {
    departamento: "05",
    provincia: "03",
    distrito: "07",
    text: "Santillana",
  },
  {
    departamento: "05",
    provincia: "03",
    distrito: "08",
    text: "Sivia",
  },
  {
    departamento: "05",
    provincia: "03",
    distrito: "09",
    text: "Llochegua",
  },
  {
    departamento: "05",
    provincia: "04",
    distrito: "00",
    text: "La Mar",
  },
  {
    departamento: "05",
    provincia: "04",
    distrito: "01",
    text: "San Miguel",
  },
  {
    departamento: "05",
    provincia: "04",
    distrito: "02",
    text: "Anco",
  },
  {
    departamento: "05",
    provincia: "04",
    distrito: "03",
    text: "Ayna",
  },
  {
    departamento: "05",
    provincia: "04",
    distrito: "04",
    text: "Chilcas",
  },
  {
    departamento: "05",
    provincia: "04",
    distrito: "05",
    text: "Chungui",
  },
  {
    departamento: "05",
    provincia: "04",
    distrito: "06",
    text: "Tambo",
  },
  {
    departamento: "05",
    provincia: "04",
    distrito: "07",
    text: "Luis Carranza",
  },
  {
    departamento: "05",
    provincia: "04",
    distrito: "08",
    text: "Santa Rosa",
  },
  {
    departamento: "05",
    provincia: "04",
    distrito: "09",
    text: "Samugari",
  },
  {
    departamento: "05",
    provincia: "05",
    distrito: "00",
    text: "Lucanas",
  },
  {
    departamento: "05",
    provincia: "05",
    distrito: "01",
    text: "Puquio",
  },
  {
    departamento: "05",
    provincia: "05",
    distrito: "02",
    text: "Aucara",
  },
  {
    departamento: "05",
    provincia: "05",
    distrito: "03",
    text: "Cabana",
  },
  {
    departamento: "05",
    provincia: "05",
    distrito: "04",
    text: "Carmen Salcedo",
  },
  {
    departamento: "05",
    provincia: "05",
    distrito: "06",
    text: "Chaviña",
  },
  {
    departamento: "05",
    provincia: "05",
    distrito: "08",
    text: "Chipao",
  },
  {
    departamento: "05",
    provincia: "05",
    distrito: "10",
    text: "Huac-Huas",
  },
  {
    departamento: "05",
    provincia: "05",
    distrito: "11",
    text: "Laramate",
  },
  {
    departamento: "05",
    provincia: "05",
    distrito: "12",
    text: "Leoncio Prado",
  },
  {
    departamento: "05",
    provincia: "05",
    distrito: "13",
    text: "Lucanas",
  },
  {
    departamento: "05",
    provincia: "05",
    distrito: "14",
    text: "Llauta",
  },
  {
    departamento: "05",
    provincia: "05",
    distrito: "16",
    text: "Ocaña",
  },
  {
    departamento: "05",
    provincia: "05",
    distrito: "17",
    text: "Otoca",
  },
  {
    departamento: "05",
    provincia: "05",
    distrito: "20",
    text: "Sancos",
  },
  {
    departamento: "05",
    provincia: "05",
    distrito: "21",
    text: "San Juan",
  },
  {
    departamento: "05",
    provincia: "05",
    distrito: "22",
    text: "San Pedro",
  },
  {
    departamento: "05",
    provincia: "05",
    distrito: "24",
    text: "Santa Ana de Huaycahuacho",
  },
  {
    departamento: "05",
    provincia: "05",
    distrito: "25",
    text: "Santa Lucia",
  },
  {
    departamento: "05",
    provincia: "05",
    distrito: "29",
    text: "Saisa",
  },
  {
    departamento: "05",
    provincia: "05",
    distrito: "31",
    text: "San Pedro de Palco",
  },
  {
    departamento: "05",
    provincia: "05",
    distrito: "32",
    text: "San Cristóbal",
  },
  {
    departamento: "05",
    provincia: "06",
    distrito: "00",
    text: "Parinacochas",
  },
  {
    departamento: "05",
    provincia: "06",
    distrito: "01",
    text: "Coracora",
  },
  {
    departamento: "05",
    provincia: "06",
    distrito: "04",
    text: "Coronel Castañeda",
  },
  {
    departamento: "05",
    provincia: "06",
    distrito: "05",
    text: "Chumpi",
  },
  {
    departamento: "05",
    provincia: "06",
    distrito: "08",
    text: "Pacapausa",
  },
  {
    departamento: "05",
    provincia: "06",
    distrito: "11",
    text: "Pullo",
  },
  {
    departamento: "05",
    provincia: "06",
    distrito: "12",
    text: "Puyusca",
  },
  {
    departamento: "05",
    provincia: "06",
    distrito: "15",
    text: "San Francisco de Ravacayco",
  },
  {
    departamento: "05",
    provincia: "06",
    distrito: "16",
    text: "Upahuacho",
  },
  {
    departamento: "05",
    provincia: "07",
    distrito: "00",
    text: "Victor Fajardo",
  },
  {
    departamento: "05",
    provincia: "07",
    distrito: "01",
    text: "Huancapi",
  },
  {
    departamento: "05",
    provincia: "07",
    distrito: "02",
    text: "Alcamenca",
  },
  {
    departamento: "05",
    provincia: "07",
    distrito: "03",
    text: "Apongo",
  },
  {
    departamento: "05",
    provincia: "07",
    distrito: "04",
    text: "Canaria",
  },
  {
    departamento: "05",
    provincia: "07",
    distrito: "06",
    text: "Cayara",
  },
  {
    departamento: "05",
    provincia: "07",
    distrito: "07",
    text: "Colca",
  },
  {
    departamento: "05",
    provincia: "07",
    distrito: "08",
    text: "Huaya",
  },
  {
    departamento: "05",
    provincia: "07",
    distrito: "09",
    text: "Huamanquiquia",
  },
  {
    departamento: "05",
    provincia: "07",
    distrito: "10",
    text: "Huancaraylla",
  },
  {
    departamento: "05",
    provincia: "07",
    distrito: "13",
    text: "Sarhua",
  },
  {
    departamento: "05",
    provincia: "07",
    distrito: "14",
    text: "Vilcanchos",
  },
  {
    departamento: "05",
    provincia: "07",
    distrito: "15",
    text: "Asquipata",
  },
  {
    departamento: "05",
    provincia: "08",
    distrito: "00",
    text: "Huanca Sancos",
  },
  {
    departamento: "05",
    provincia: "08",
    distrito: "01",
    text: "Sancos",
  },
  {
    departamento: "05",
    provincia: "08",
    distrito: "02",
    text: "Sacsamarca",
  },
  {
    departamento: "05",
    provincia: "08",
    distrito: "03",
    text: "Santiago de Lucanamarca",
  },
  {
    departamento: "05",
    provincia: "08",
    distrito: "04",
    text: "Carapo",
  },
  {
    departamento: "05",
    provincia: "09",
    distrito: "00",
    text: "Vilcas Huaman",
  },
  {
    departamento: "05",
    provincia: "09",
    distrito: "01",
    text: "Vilcas Huaman",
  },
  {
    departamento: "05",
    provincia: "09",
    distrito: "02",
    text: "Vischongo",
  },
  {
    departamento: "05",
    provincia: "09",
    distrito: "03",
    text: "Accomarca",
  },
  {
    departamento: "05",
    provincia: "09",
    distrito: "04",
    text: "Carhuanca",
  },
  {
    departamento: "05",
    provincia: "09",
    distrito: "05",
    text: "Concepcion",
  },
  {
    departamento: "05",
    provincia: "09",
    distrito: "06",
    text: "Huambalpa",
  },
  {
    departamento: "05",
    provincia: "09",
    distrito: "07",
    text: "Saurama",
  },
  {
    departamento: "05",
    provincia: "09",
    distrito: "08",
    text: "Independencia",
  },
  {
    departamento: "05",
    provincia: "10",
    distrito: "00",
    text: "Paucar del Sara Sara",
  },
  {
    departamento: "05",
    provincia: "10",
    distrito: "01",
    text: "Pausa",
  },
  {
    departamento: "05",
    provincia: "10",
    distrito: "02",
    text: "Colta",
  },
  {
    departamento: "05",
    provincia: "10",
    distrito: "03",
    text: "Corculla",
  },
  {
    departamento: "05",
    provincia: "10",
    distrito: "04",
    text: "Lampa",
  },
  {
    departamento: "05",
    provincia: "10",
    distrito: "05",
    text: "Marcabamba",
  },
  {
    departamento: "05",
    provincia: "10",
    distrito: "06",
    text: "Oyolo",
  },
  {
    departamento: "05",
    provincia: "10",
    distrito: "07",
    text: "Pararca",
  },
  {
    departamento: "05",
    provincia: "10",
    distrito: "08",
    text: "San Javier de Alpabamba",
  },
  {
    departamento: "05",
    provincia: "10",
    distrito: "09",
    text: "San José de Ushua",
  },
  {
    departamento: "05",
    provincia: "10",
    distrito: "10",
    text: "Sara Sara",
  },
  {
    departamento: "05",
    provincia: "11",
    distrito: "00",
    text: "Sucre",
  },
  {
    departamento: "05",
    provincia: "11",
    distrito: "01",
    text: "Querobamba",
  },
  {
    departamento: "05",
    provincia: "11",
    distrito: "02",
    text: "Belén",
  },
  {
    departamento: "05",
    provincia: "11",
    distrito: "03",
    text: "Chalcos",
  },
  {
    departamento: "05",
    provincia: "11",
    distrito: "04",
    text: "San Salvador de Quije",
  },
  {
    departamento: "05",
    provincia: "11",
    distrito: "05",
    text: "Paico",
  },
  {
    departamento: "05",
    provincia: "11",
    distrito: "06",
    text: "Santiago de Paucaray",
  },
  {
    departamento: "05",
    provincia: "11",
    distrito: "07",
    text: "San Pedro de Larcay",
  },
  {
    departamento: "05",
    provincia: "11",
    distrito: "08",
    text: "Soras",
  },
  {
    departamento: "05",
    provincia: "11",
    distrito: "09",
    text: "Huacaña",
  },
  {
    departamento: "05",
    provincia: "11",
    distrito: "10",
    text: "Chilcayoc",
  },
  {
    departamento: "05",
    provincia: "11",
    distrito: "11",
    text: "Morcolla",
  },
  {
    departamento: "06",
    provincia: "00",
    distrito: "00",
    text: "Cajamarca",
  },
  {
    departamento: "06",
    provincia: "01",
    distrito: "00",
    text: "Cajamarca",
  },
  {
    departamento: "06",
    provincia: "01",
    distrito: "01",
    text: "Cajamarca",
  },
  {
    departamento: "06",
    provincia: "01",
    distrito: "02",
    text: "Asunción",
  },
  {
    departamento: "06",
    provincia: "01",
    distrito: "03",
    text: "Cospan",
  },
  {
    departamento: "06",
    provincia: "01",
    distrito: "04",
    text: "Chetilla",
  },
  {
    departamento: "06",
    provincia: "01",
    distrito: "05",
    text: "Encañada",
  },
  {
    departamento: "06",
    provincia: "01",
    distrito: "06",
    text: "Jesus",
  },
  {
    departamento: "06",
    provincia: "01",
    distrito: "07",
    text: "Los Baños del Inca",
  },
  {
    departamento: "06",
    provincia: "01",
    distrito: "08",
    text: "Llacanora",
  },
  {
    departamento: "06",
    provincia: "01",
    distrito: "09",
    text: "Magdalena",
  },
  {
    departamento: "06",
    provincia: "01",
    distrito: "10",
    text: "Matara",
  },
  {
    departamento: "06",
    provincia: "01",
    distrito: "11",
    text: "Namora",
  },
  {
    departamento: "06",
    provincia: "01",
    distrito: "12",
    text: "San Juan",
  },
  {
    departamento: "06",
    provincia: "02",
    distrito: "00",
    text: "Cajabamba",
  },
  {
    departamento: "06",
    provincia: "02",
    distrito: "01",
    text: "Cajabamba",
  },
  {
    departamento: "06",
    provincia: "02",
    distrito: "02",
    text: "Cachachi",
  },
  {
    departamento: "06",
    provincia: "02",
    distrito: "03",
    text: "Condebamba",
  },
  {
    departamento: "06",
    provincia: "02",
    distrito: "05",
    text: "Sitacocha",
  },
  {
    departamento: "06",
    provincia: "03",
    distrito: "00",
    text: "Celendín",
  },
  {
    departamento: "06",
    provincia: "03",
    distrito: "01",
    text: "Celendín",
  },
  {
    departamento: "06",
    provincia: "03",
    distrito: "02",
    text: "Cortegana",
  },
  {
    departamento: "06",
    provincia: "03",
    distrito: "03",
    text: "Chumuch",
  },
  {
    departamento: "06",
    provincia: "03",
    distrito: "04",
    text: "Huasmin",
  },
  {
    departamento: "06",
    provincia: "03",
    distrito: "05",
    text: "Jorge Chávez",
  },
  {
    departamento: "06",
    provincia: "03",
    distrito: "06",
    text: "José Gálvez",
  },
  {
    departamento: "06",
    provincia: "03",
    distrito: "07",
    text: "Miguel Iglesias",
  },
  {
    departamento: "06",
    provincia: "03",
    distrito: "08",
    text: "Oxamarca",
  },
  {
    departamento: "06",
    provincia: "03",
    distrito: "09",
    text: "Sorochuco",
  },
  {
    departamento: "06",
    provincia: "03",
    distrito: "10",
    text: "Sucre",
  },
  {
    departamento: "06",
    provincia: "03",
    distrito: "11",
    text: "Utco",
  },
  {
    departamento: "06",
    provincia: "03",
    distrito: "12",
    text: "La Libertad de Pallan",
  },
  {
    departamento: "06",
    provincia: "04",
    distrito: "00",
    text: "Contumaza",
  },
  {
    departamento: "06",
    provincia: "04",
    distrito: "01",
    text: "Contumaza",
  },
  {
    departamento: "06",
    provincia: "04",
    distrito: "03",
    text: "Chilete",
  },
  {
    departamento: "06",
    provincia: "04",
    distrito: "04",
    text: "Guzmango",
  },
  {
    departamento: "06",
    provincia: "04",
    distrito: "05",
    text: "San Benito",
  },
  {
    departamento: "06",
    provincia: "04",
    distrito: "06",
    text: "Cupisnique",
  },
  {
    departamento: "06",
    provincia: "04",
    distrito: "07",
    text: "Tantarica",
  },
  {
    departamento: "06",
    provincia: "04",
    distrito: "08",
    text: "Yonan",
  },
  {
    departamento: "06",
    provincia: "04",
    distrito: "09",
    text: "Santa Cruz de Toled",
  },
  {
    departamento: "06",
    provincia: "05",
    distrito: "00",
    text: "Cutervo",
  },
  {
    departamento: "06",
    provincia: "05",
    distrito: "01",
    text: "Cutervo",
  },
  {
    departamento: "06",
    provincia: "05",
    distrito: "02",
    text: "Callayuc",
  },
  {
    departamento: "06",
    provincia: "05",
    distrito: "03",
    text: "Cujillo",
  },
  {
    departamento: "06",
    provincia: "05",
    distrito: "04",
    text: "Choros",
  },
  {
    departamento: "06",
    provincia: "05",
    distrito: "05",
    text: "La Ramada",
  },
  {
    departamento: "06",
    provincia: "05",
    distrito: "06",
    text: "Pimpingos",
  },
  {
    departamento: "06",
    provincia: "05",
    distrito: "07",
    text: "Querocotillo",
  },
  {
    departamento: "06",
    provincia: "05",
    distrito: "08",
    text: "San Andrés de Cutervo",
  },
  {
    departamento: "06",
    provincia: "05",
    distrito: "09",
    text: "San Juan de Cutervo",
  },
  {
    departamento: "06",
    provincia: "05",
    distrito: "10",
    text: "San Luis de Lucma",
  },
  {
    departamento: "06",
    provincia: "05",
    distrito: "11",
    text: "Santa Cruz",
  },
  {
    departamento: "06",
    provincia: "05",
    distrito: "12",
    text: "Santo Domingo de La Capilla",
  },
  {
    departamento: "06",
    provincia: "05",
    distrito: "13",
    text: "Santo Tomas",
  },
  {
    departamento: "06",
    provincia: "05",
    distrito: "14",
    text: "Socota",
  },
  {
    departamento: "06",
    provincia: "05",
    distrito: "15",
    text: "Toribio Casanova",
  },
  {
    departamento: "06",
    provincia: "06",
    distrito: "00",
    text: "Chota",
  },
  {
    departamento: "06",
    provincia: "06",
    distrito: "01",
    text: "Chota",
  },
  {
    departamento: "06",
    provincia: "06",
    distrito: "02",
    text: "Anguia",
  },
  {
    departamento: "06",
    provincia: "06",
    distrito: "03",
    text: "Cochabamba",
  },
  {
    departamento: "06",
    provincia: "06",
    distrito: "04",
    text: "Conchan",
  },
  {
    departamento: "06",
    provincia: "06",
    distrito: "05",
    text: "Chadin",
  },
  {
    departamento: "06",
    provincia: "06",
    distrito: "06",
    text: "Chiguirip",
  },
  {
    departamento: "06",
    provincia: "06",
    distrito: "07",
    text: "Chimban",
  },
  {
    departamento: "06",
    provincia: "06",
    distrito: "08",
    text: "Huambos",
  },
  {
    departamento: "06",
    provincia: "06",
    distrito: "09",
    text: "Lajas",
  },
  {
    departamento: "06",
    provincia: "06",
    distrito: "10",
    text: "Llama",
  },
  {
    departamento: "06",
    provincia: "06",
    distrito: "11",
    text: "Miracosta",
  },
  {
    departamento: "06",
    provincia: "06",
    distrito: "12",
    text: "Paccha",
  },
  {
    departamento: "06",
    provincia: "06",
    distrito: "13",
    text: "Pion",
  },
  {
    departamento: "06",
    provincia: "06",
    distrito: "14",
    text: "Querocoto",
  },
  {
    departamento: "06",
    provincia: "06",
    distrito: "15",
    text: "Tacabamba",
  },
  {
    departamento: "06",
    provincia: "06",
    distrito: "16",
    text: "Tocmoche",
  },
  {
    departamento: "06",
    provincia: "06",
    distrito: "17",
    text: "San Juan de Licupis",
  },
  {
    departamento: "06",
    provincia: "06",
    distrito: "18",
    text: "Choropampa",
  },
  {
    departamento: "06",
    provincia: "06",
    distrito: "19",
    text: "Chalamarca",
  },
  {
    departamento: "06",
    provincia: "07",
    distrito: "00",
    text: "Hualgayoc",
  },
  {
    departamento: "06",
    provincia: "07",
    distrito: "01",
    text: "Bambamarca",
  },
  {
    departamento: "06",
    provincia: "07",
    distrito: "02",
    text: "Chugur",
  },
  {
    departamento: "06",
    provincia: "07",
    distrito: "03",
    text: "Hualgayoc",
  },
  {
    departamento: "06",
    provincia: "08",
    distrito: "00",
    text: "Jaén",
  },
  {
    departamento: "06",
    provincia: "08",
    distrito: "01",
    text: "Jaén",
  },
  {
    departamento: "06",
    provincia: "08",
    distrito: "02",
    text: "Bellavista",
  },
  {
    departamento: "06",
    provincia: "08",
    distrito: "03",
    text: "Colasay",
  },
  {
    departamento: "06",
    provincia: "08",
    distrito: "04",
    text: "Chontali",
  },
  {
    departamento: "06",
    provincia: "08",
    distrito: "05",
    text: "Pomahuaca",
  },
  {
    departamento: "06",
    provincia: "08",
    distrito: "06",
    text: "Pucara",
  },
  {
    departamento: "06",
    provincia: "08",
    distrito: "07",
    text: "Sallique",
  },
  {
    departamento: "06",
    provincia: "08",
    distrito: "08",
    text: "San Felipe",
  },
  {
    departamento: "06",
    provincia: "08",
    distrito: "09",
    text: "San Jose del Alto",
  },
  {
    departamento: "06",
    provincia: "08",
    distrito: "10",
    text: "Santa Rosa",
  },
  {
    departamento: "06",
    provincia: "08",
    distrito: "11",
    text: "Las Pirias",
  },
  {
    departamento: "06",
    provincia: "08",
    distrito: "12",
    text: "Huabal",
  },
  {
    departamento: "06",
    provincia: "09",
    distrito: "00",
    text: "Santa Cruz",
  },
  {
    departamento: "06",
    provincia: "09",
    distrito: "01",
    text: "Santa Cruz",
  },
  {
    departamento: "06",
    provincia: "09",
    distrito: "02",
    text: "Catache",
  },
  {
    departamento: "06",
    provincia: "09",
    distrito: "03",
    text: "Chancaybaños",
  },
  {
    departamento: "06",
    provincia: "09",
    distrito: "04",
    text: "La Esperanza",
  },
  {
    departamento: "06",
    provincia: "09",
    distrito: "05",
    text: "Ninabamba",
  },
  {
    departamento: "06",
    provincia: "09",
    distrito: "06",
    text: "Pulan",
  },
  {
    departamento: "06",
    provincia: "09",
    distrito: "07",
    text: "Sexi",
  },
  {
    departamento: "06",
    provincia: "09",
    distrito: "08",
    text: "Uticyacu",
  },
  {
    departamento: "06",
    provincia: "09",
    distrito: "09",
    text: "Yauyucan",
  },
  {
    departamento: "06",
    provincia: "09",
    distrito: "10",
    text: "Andabamba",
  },
  {
    departamento: "06",
    provincia: "09",
    distrito: "11",
    text: "Saucepampa",
  },
  {
    departamento: "06",
    provincia: "10",
    distrito: "00",
    text: "San Miguel",
  },
  {
    departamento: "06",
    provincia: "10",
    distrito: "01",
    text: "San Miguel",
  },
  {
    departamento: "06",
    provincia: "10",
    distrito: "02",
    text: "Calquis",
  },
  {
    departamento: "06",
    provincia: "10",
    distrito: "03",
    text: "La Florida",
  },
  {
    departamento: "06",
    provincia: "10",
    distrito: "04",
    text: "Llapa",
  },
  {
    departamento: "06",
    provincia: "10",
    distrito: "05",
    text: "Nanchoc",
  },
  {
    departamento: "06",
    provincia: "10",
    distrito: "06",
    text: "Niepos",
  },
  {
    departamento: "06",
    provincia: "10",
    distrito: "07",
    text: "San Gregorio",
  },
  {
    departamento: "06",
    provincia: "10",
    distrito: "08",
    text: "San Silvestre de Cochan",
  },
  {
    departamento: "06",
    provincia: "10",
    distrito: "09",
    text: "El Prado",
  },
  {
    departamento: "06",
    provincia: "10",
    distrito: "10",
    text: "Union Agua Blanca",
  },
  {
    departamento: "06",
    provincia: "10",
    distrito: "11",
    text: "Tongod",
  },
  {
    departamento: "06",
    provincia: "10",
    distrito: "12",
    text: "Catilluc",
  },
  {
    departamento: "06",
    provincia: "10",
    distrito: "13",
    text: "Bolivar",
  },
  {
    departamento: "06",
    provincia: "11",
    distrito: "00",
    text: "San Ignacio",
  },
  {
    departamento: "06",
    provincia: "11",
    distrito: "01",
    text: "San Ignacio",
  },
  {
    departamento: "06",
    provincia: "11",
    distrito: "02",
    text: "Chirinos",
  },
  {
    departamento: "06",
    provincia: "11",
    distrito: "03",
    text: "Huarango",
  },
  {
    departamento: "06",
    provincia: "11",
    distrito: "04",
    text: "Namballe",
  },
  {
    departamento: "06",
    provincia: "11",
    distrito: "05",
    text: "La Coipa",
  },
  {
    departamento: "06",
    provincia: "11",
    distrito: "06",
    text: "San José de Lourdes",
  },
  {
    departamento: "06",
    provincia: "11",
    distrito: "07",
    text: "Tabaconas",
  },
  {
    departamento: "06",
    provincia: "12",
    distrito: "00",
    text: "San Marcos",
  },
  {
    departamento: "06",
    provincia: "12",
    distrito: "01",
    text: "Pedro Gálvez",
  },
  {
    departamento: "06",
    provincia: "12",
    distrito: "02",
    text: "Ichocan",
  },
  {
    departamento: "06",
    provincia: "12",
    distrito: "03",
    text: "Gregorio Pita",
  },
  {
    departamento: "06",
    provincia: "12",
    distrito: "04",
    text: "José Manuel Quiroz",
  },
  {
    departamento: "06",
    provincia: "12",
    distrito: "05",
    text: "Eduardo Villanueva",
  },
  {
    departamento: "06",
    provincia: "12",
    distrito: "06",
    text: "José Sabogal",
  },
  {
    departamento: "06",
    provincia: "12",
    distrito: "07",
    text: "Chancay",
  },
  {
    departamento: "06",
    provincia: "13",
    distrito: "00",
    text: "San Pablo",
  },
  {
    departamento: "06",
    provincia: "13",
    distrito: "01",
    text: "San Pablo",
  },
  {
    departamento: "06",
    provincia: "13",
    distrito: "02",
    text: "San Bernardino",
  },
  {
    departamento: "06",
    provincia: "13",
    distrito: "03",
    text: "San Luis",
  },
  {
    departamento: "06",
    provincia: "13",
    distrito: "04",
    text: "Tumbaden",
  },
  {
    departamento: "07",
    provincia: "00",
    distrito: "00",
    text: "Cusco",
  },
  {
    departamento: "07",
    provincia: "01",
    distrito: "00",
    text: "Cusco",
  },
  {
    departamento: "07",
    provincia: "01",
    distrito: "01",
    text: "Cusco",
  },
  {
    departamento: "07",
    provincia: "01",
    distrito: "02",
    text: "Ccorca",
  },
  {
    departamento: "07",
    provincia: "01",
    distrito: "03",
    text: "Poroy",
  },
  {
    departamento: "07",
    provincia: "01",
    distrito: "04",
    text: "San Jerónimo",
  },
  {
    departamento: "07",
    provincia: "01",
    distrito: "05",
    text: "San Sebastian",
  },
  {
    departamento: "07",
    provincia: "01",
    distrito: "06",
    text: "Santiago",
  },
  {
    departamento: "07",
    provincia: "01",
    distrito: "07",
    text: "Saylla",
  },
  {
    departamento: "07",
    provincia: "01",
    distrito: "08",
    text: "Wanchaq",
  },
  {
    departamento: "07",
    provincia: "02",
    distrito: "00",
    text: "Acomayo",
  },
  {
    departamento: "07",
    provincia: "02",
    distrito: "01",
    text: "Acomayo",
  },
  {
    departamento: "07",
    provincia: "02",
    distrito: "02",
    text: "Acopia",
  },
  {
    departamento: "07",
    provincia: "02",
    distrito: "03",
    text: "Acos",
  },
  {
    departamento: "07",
    provincia: "02",
    distrito: "04",
    text: "Pomacanchi",
  },
  {
    departamento: "07",
    provincia: "02",
    distrito: "05",
    text: "Rondocan",
  },
  {
    departamento: "07",
    provincia: "02",
    distrito: "06",
    text: "Sangarara",
  },
  {
    departamento: "07",
    provincia: "02",
    distrito: "07",
    text: "Mosoc Llacta",
  },
  {
    departamento: "07",
    provincia: "03",
    distrito: "00",
    text: "Anta",
  },
  {
    departamento: "07",
    provincia: "03",
    distrito: "01",
    text: "Anta",
  },
  {
    departamento: "07",
    provincia: "03",
    distrito: "02",
    text: "Chinchaypujio",
  },
  {
    departamento: "07",
    provincia: "03",
    distrito: "03",
    text: "Huarocondo",
  },
  {
    departamento: "07",
    provincia: "03",
    distrito: "04",
    text: "Limatambo",
  },
  {
    departamento: "07",
    provincia: "03",
    distrito: "05",
    text: "Mollepata",
  },
  {
    departamento: "07",
    provincia: "03",
    distrito: "06",
    text: "Pucyura",
  },
  {
    departamento: "07",
    provincia: "03",
    distrito: "07",
    text: "Zurite",
  },
  {
    departamento: "07",
    provincia: "03",
    distrito: "08",
    text: "Cachimayo",
  },
  {
    departamento: "07",
    provincia: "03",
    distrito: "09",
    text: "Ancahuasi",
  },
  {
    departamento: "07",
    provincia: "04",
    distrito: "00",
    text: "Calca",
  },
  {
    departamento: "07",
    provincia: "04",
    distrito: "01",
    text: "Calca",
  },
  {
    departamento: "07",
    provincia: "04",
    distrito: "02",
    text: "Coya",
  },
  {
    departamento: "07",
    provincia: "04",
    distrito: "03",
    text: "Lamay",
  },
  {
    departamento: "07",
    provincia: "04",
    distrito: "04",
    text: "Lares",
  },
  {
    departamento: "07",
    provincia: "04",
    distrito: "05",
    text: "Pisac",
  },
  {
    departamento: "07",
    provincia: "04",
    distrito: "06",
    text: "San Salvador",
  },
  {
    departamento: "07",
    provincia: "04",
    distrito: "07",
    text: "Taray",
  },
  {
    departamento: "07",
    provincia: "04",
    distrito: "08",
    text: "Yanatile",
  },
  {
    departamento: "07",
    provincia: "05",
    distrito: "00",
    text: "Canas",
  },
  {
    departamento: "07",
    provincia: "05",
    distrito: "01",
    text: "Yanaoca",
  },
  {
    departamento: "07",
    provincia: "05",
    distrito: "02",
    text: "Checca",
  },
  {
    departamento: "07",
    provincia: "05",
    distrito: "03",
    text: "Kunturkanki",
  },
  {
    departamento: "07",
    provincia: "05",
    distrito: "04",
    text: "Langui",
  },
  {
    departamento: "07",
    provincia: "05",
    distrito: "05",
    text: "Layo",
  },
  {
    departamento: "07",
    provincia: "05",
    distrito: "06",
    text: "Pampamarca",
  },
  {
    departamento: "07",
    provincia: "05",
    distrito: "07",
    text: "Quehue",
  },
  {
    departamento: "07",
    provincia: "05",
    distrito: "08",
    text: "Tupac Amaru",
  },
  {
    departamento: "07",
    provincia: "06",
    distrito: "00",
    text: "Canchis",
  },
  {
    departamento: "07",
    provincia: "06",
    distrito: "01",
    text: "Sicuani",
  },
  {
    departamento: "07",
    provincia: "06",
    distrito: "02",
    text: "Combapata",
  },
  {
    departamento: "07",
    provincia: "06",
    distrito: "03",
    text: "Checacupe",
  },
  {
    departamento: "07",
    provincia: "06",
    distrito: "04",
    text: "Marangani",
  },
  {
    departamento: "07",
    provincia: "06",
    distrito: "05",
    text: "Pitumarca",
  },
  {
    departamento: "07",
    provincia: "06",
    distrito: "06",
    text: "San Pablo",
  },
  {
    departamento: "07",
    provincia: "06",
    distrito: "07",
    text: "San Pedro",
  },
  {
    departamento: "07",
    provincia: "06",
    distrito: "08",
    text: "Tinta",
  },
  {
    departamento: "07",
    provincia: "07",
    distrito: "00",
    text: "Chumbivilcas",
  },
  {
    departamento: "07",
    provincia: "07",
    distrito: "01",
    text: "Santo Tomas",
  },
  {
    departamento: "07",
    provincia: "07",
    distrito: "02",
    text: "Capacmarca",
  },
  {
    departamento: "07",
    provincia: "07",
    distrito: "03",
    text: "Colquemarca",
  },
  {
    departamento: "07",
    provincia: "07",
    distrito: "04",
    text: "Chamaca",
  },
  {
    departamento: "07",
    provincia: "07",
    distrito: "05",
    text: "Livitaca",
  },
  {
    departamento: "07",
    provincia: "07",
    distrito: "06",
    text: "Llusco",
  },
  {
    departamento: "07",
    provincia: "07",
    distrito: "07",
    text: "Quiñota",
  },
  {
    departamento: "07",
    provincia: "07",
    distrito: "08",
    text: "Velille",
  },
  {
    departamento: "07",
    provincia: "08",
    distrito: "00",
    text: "Espinar",
  },
  {
    departamento: "07",
    provincia: "08",
    distrito: "01",
    text: "Espinar",
  },
  {
    departamento: "07",
    provincia: "08",
    distrito: "02",
    text: "Condoroma",
  },
  {
    departamento: "07",
    provincia: "08",
    distrito: "03",
    text: "Coporaque",
  },
  {
    departamento: "07",
    provincia: "08",
    distrito: "04",
    text: "Ocoruro",
  },
  {
    departamento: "07",
    provincia: "08",
    distrito: "05",
    text: "Pallpata",
  },
  {
    departamento: "07",
    provincia: "08",
    distrito: "06",
    text: "Pichigua",
  },
  {
    departamento: "07",
    provincia: "08",
    distrito: "07",
    text: "Suyckutambo",
  },
  {
    departamento: "07",
    provincia: "08",
    distrito: "08",
    text: "Alto Pichigua",
  },
  {
    departamento: "07",
    provincia: "09",
    distrito: "00",
    text: "La Convención",
  },
  {
    departamento: "07",
    provincia: "09",
    distrito: "01",
    text: "Santa Ana",
  },
  {
    departamento: "07",
    provincia: "09",
    distrito: "02",
    text: "Echarate",
  },
  {
    departamento: "07",
    provincia: "09",
    distrito: "03",
    text: "Huayopata",
  },
  {
    departamento: "07",
    provincia: "09",
    distrito: "04",
    text: "Maranura",
  },
  {
    departamento: "07",
    provincia: "09",
    distrito: "05",
    text: "Ocobamba",
  },
  {
    departamento: "07",
    provincia: "09",
    distrito: "06",
    text: "Santa Teresa",
  },
  {
    departamento: "07",
    provincia: "09",
    distrito: "07",
    text: "Vilcabamba",
  },
  {
    departamento: "07",
    provincia: "09",
    distrito: "08",
    text: "Quellouno",
  },
  {
    departamento: "07",
    provincia: "09",
    distrito: "09",
    text: "Kimbiri",
  },
  {
    departamento: "07",
    provincia: "09",
    distrito: "10",
    text: "Pichari",
  },
  {
    departamento: "07",
    provincia: "10",
    distrito: "00",
    text: "Paruro",
  },
  {
    departamento: "07",
    provincia: "10",
    distrito: "01",
    text: "Paruro",
  },
  {
    departamento: "07",
    provincia: "10",
    distrito: "02",
    text: "Accha",
  },
  {
    departamento: "07",
    provincia: "10",
    distrito: "03",
    text: "Ccapi",
  },
  {
    departamento: "07",
    provincia: "10",
    distrito: "04",
    text: "Colcha",
  },
  {
    departamento: "07",
    provincia: "10",
    distrito: "05",
    text: "Huanoquite",
  },
  {
    departamento: "07",
    provincia: "10",
    distrito: "06",
    text: "Omacha",
  },
  {
    departamento: "07",
    provincia: "10",
    distrito: "07",
    text: "Yaurisque",
  },
  {
    departamento: "07",
    provincia: "10",
    distrito: "08",
    text: "Paccaritambo",
  },
  {
    departamento: "07",
    provincia: "10",
    distrito: "09",
    text: "Pillpinto",
  },
  {
    departamento: "07",
    provincia: "11",
    distrito: "00",
    text: "Paucartambo",
  },
  {
    departamento: "07",
    provincia: "11",
    distrito: "01",
    text: "Paucartambo",
  },
  {
    departamento: "07",
    provincia: "11",
    distrito: "02",
    text: "Caicay",
  },
  {
    departamento: "07",
    provincia: "11",
    distrito: "03",
    text: "Colquepata",
  },
  {
    departamento: "07",
    provincia: "11",
    distrito: "04",
    text: "Challabamba",
  },
  {
    departamento: "07",
    provincia: "11",
    distrito: "05",
    text: "Kosñipata",
  },
  {
    departamento: "07",
    provincia: "11",
    distrito: "06",
    text: "Huancarani",
  },
  {
    departamento: "07",
    provincia: "12",
    distrito: "00",
    text: "Quispicanchi",
  },
  {
    departamento: "07",
    provincia: "12",
    distrito: "01",
    text: "Urcos",
  },
  {
    departamento: "07",
    provincia: "12",
    distrito: "02",
    text: "Andahuaylillas",
  },
  {
    departamento: "07",
    provincia: "12",
    distrito: "03",
    text: "Camanti",
  },
  {
    departamento: "07",
    provincia: "12",
    distrito: "04",
    text: "Ccarhuayo",
  },
  {
    departamento: "07",
    provincia: "12",
    distrito: "05",
    text: "Ccatca",
  },
  {
    departamento: "07",
    provincia: "12",
    distrito: "06",
    text: "Cusipata",
  },
  {
    departamento: "07",
    provincia: "12",
    distrito: "07",
    text: "Huaro",
  },
  {
    departamento: "07",
    provincia: "12",
    distrito: "08",
    text: "Lucre",
  },
  {
    departamento: "07",
    provincia: "12",
    distrito: "09",
    text: "Marcapata",
  },
  {
    departamento: "07",
    provincia: "12",
    distrito: "10",
    text: "Ocongate",
  },
  {
    departamento: "07",
    provincia: "12",
    distrito: "11",
    text: "Oropesa",
  },
  {
    departamento: "07",
    provincia: "12",
    distrito: "12",
    text: "Quiquijana",
  },
  {
    departamento: "07",
    provincia: "13",
    distrito: "00",
    text: "Urubamba",
  },
  {
    departamento: "07",
    provincia: "13",
    distrito: "01",
    text: "Urubamba",
  },
  {
    departamento: "07",
    provincia: "13",
    distrito: "02",
    text: "Chinchero",
  },
  {
    departamento: "07",
    provincia: "13",
    distrito: "03",
    text: "Huayllabamba",
  },
  {
    departamento: "07",
    provincia: "13",
    distrito: "04",
    text: "Machupicchu",
  },
  {
    departamento: "07",
    provincia: "13",
    distrito: "05",
    text: "Maras",
  },
  {
    departamento: "07",
    provincia: "13",
    distrito: "06",
    text: "Ollantaytambo",
  },
  {
    departamento: "07",
    provincia: "13",
    distrito: "07",
    text: "Yucay",
  },
  {
    departamento: "08",
    provincia: "00",
    distrito: "00",
    text: "Huancavelica",
  },
  {
    departamento: "08",
    provincia: "01",
    distrito: "00",
    text: "Huancavelica",
  },
  {
    departamento: "08",
    provincia: "01",
    distrito: "01",
    text: "Huancavelica",
  },
  {
    departamento: "08",
    provincia: "01",
    distrito: "02",
    text: "Acobambilla",
  },
  {
    departamento: "08",
    provincia: "01",
    distrito: "03",
    text: "Acoria",
  },
  {
    departamento: "08",
    provincia: "01",
    distrito: "04",
    text: "Conayca",
  },
  {
    departamento: "08",
    provincia: "01",
    distrito: "05",
    text: "Cuenca",
  },
  {
    departamento: "08",
    provincia: "01",
    distrito: "06",
    text: "Huachocolpa",
  },
  {
    departamento: "08",
    provincia: "01",
    distrito: "08",
    text: "Huayllahuara",
  },
  {
    departamento: "08",
    provincia: "01",
    distrito: "09",
    text: "Izcuchaca",
  },
  {
    departamento: "08",
    provincia: "01",
    distrito: "10",
    text: "Laria",
  },
  {
    departamento: "08",
    provincia: "01",
    distrito: "11",
    text: "Manta",
  },
  {
    departamento: "08",
    provincia: "01",
    distrito: "12",
    text: "Mariscal Cáceres",
  },
  {
    departamento: "08",
    provincia: "01",
    distrito: "13",
    text: "Moya",
  },
  {
    departamento: "08",
    provincia: "01",
    distrito: "14",
    text: "Nuevo Occoro",
  },
  {
    departamento: "08",
    provincia: "01",
    distrito: "15",
    text: "Palca",
  },
  {
    departamento: "08",
    provincia: "01",
    distrito: "16",
    text: "Pilchaca",
  },
  {
    departamento: "08",
    provincia: "01",
    distrito: "17",
    text: "Vilca",
  },
  {
    departamento: "08",
    provincia: "01",
    distrito: "18",
    text: "Yauli",
  },
  {
    departamento: "08",
    provincia: "01",
    distrito: "19",
    text: "Ascensión",
  },
  {
    departamento: "08",
    provincia: "01",
    distrito: "20",
    text: "Huando",
  },
  {
    departamento: "08",
    provincia: "02",
    distrito: "00",
    text: "Acobamba",
  },
  {
    departamento: "08",
    provincia: "02",
    distrito: "01",
    text: "Acobamba",
  },
  {
    departamento: "08",
    provincia: "02",
    distrito: "02",
    text: "Anta",
  },
  {
    departamento: "08",
    provincia: "02",
    distrito: "03",
    text: "Andabamba",
  },
  {
    departamento: "08",
    provincia: "02",
    distrito: "04",
    text: "Caja",
  },
  {
    departamento: "08",
    provincia: "02",
    distrito: "05",
    text: "Marcas",
  },
  {
    departamento: "08",
    provincia: "02",
    distrito: "06",
    text: "Paucara",
  },
  {
    departamento: "08",
    provincia: "02",
    distrito: "07",
    text: "Pomacocha",
  },
  {
    departamento: "08",
    provincia: "02",
    distrito: "08",
    text: "Rosario",
  },
  {
    departamento: "08",
    provincia: "03",
    distrito: "00",
    text: "Angaraes",
  },
  {
    departamento: "08",
    provincia: "03",
    distrito: "01",
    text: "Lircay",
  },
  {
    departamento: "08",
    provincia: "03",
    distrito: "02",
    text: "Anchonga",
  },
  {
    departamento: "08",
    provincia: "03",
    distrito: "03",
    text: "Callanmarca",
  },
  {
    departamento: "08",
    provincia: "03",
    distrito: "04",
    text: "Congalla",
  },
  {
    departamento: "08",
    provincia: "03",
    distrito: "05",
    text: "Chincho",
  },
  {
    departamento: "08",
    provincia: "03",
    distrito: "06",
    text: "Huayllay Grande",
  },
  {
    departamento: "08",
    provincia: "03",
    distrito: "07",
    text: "Huanca-Huanca",
  },
  {
    departamento: "08",
    provincia: "03",
    distrito: "08",
    text: "Julcamarca",
  },
  {
    departamento: "08",
    provincia: "03",
    distrito: "09",
    text: "San Antonio de Antaparco",
  },
  {
    departamento: "08",
    provincia: "03",
    distrito: "10",
    text: "Santo Tomas de Pata",
  },
  {
    departamento: "08",
    provincia: "03",
    distrito: "11",
    text: "Secclla",
  },
  {
    departamento: "08",
    provincia: "03",
    distrito: "12",
    text: "Ccochaccasa",
  },
  {
    departamento: "08",
    provincia: "04",
    distrito: "00",
    text: "Castrovirreyna",
  },
  {
    departamento: "08",
    provincia: "04",
    distrito: "01",
    text: "Castrovirreyna",
  },
  {
    departamento: "08",
    provincia: "04",
    distrito: "02",
    text: "Arma",
  },
  {
    departamento: "08",
    provincia: "04",
    distrito: "03",
    text: "Aurahua",
  },
  {
    departamento: "08",
    provincia: "04",
    distrito: "05",
    text: "Capillas",
  },
  {
    departamento: "08",
    provincia: "04",
    distrito: "06",
    text: "Cocas",
  },
  {
    departamento: "08",
    provincia: "04",
    distrito: "08",
    text: "Chupamarca",
  },
  {
    departamento: "08",
    provincia: "04",
    distrito: "09",
    text: "Huachos",
  },
  {
    departamento: "08",
    provincia: "04",
    distrito: "10",
    text: "Huamatambo",
  },
  {
    departamento: "08",
    provincia: "04",
    distrito: "14",
    text: "Mollepampa",
  },
  {
    departamento: "08",
    provincia: "04",
    distrito: "22",
    text: "San Juan",
  },
  {
    departamento: "08",
    provincia: "04",
    distrito: "27",
    text: "Tantara",
  },
  {
    departamento: "08",
    provincia: "04",
    distrito: "28",
    text: "Ticrapo",
  },
  {
    departamento: "08",
    provincia: "04",
    distrito: "29",
    text: "Santa Ana",
  },
  {
    departamento: "08",
    provincia: "05",
    distrito: "00",
    text: "Tayacaja",
  },
  {
    departamento: "08",
    provincia: "05",
    distrito: "01",
    text: "Pampas",
  },
  {
    departamento: "08",
    provincia: "05",
    distrito: "02",
    text: "Acostambo",
  },
  {
    departamento: "08",
    provincia: "05",
    distrito: "03",
    text: "Acraquia",
  },
  {
    departamento: "08",
    provincia: "05",
    distrito: "04",
    text: "Ahuaycha",
  },
  {
    departamento: "08",
    provincia: "05",
    distrito: "06",
    text: "Colcabamba",
  },
  {
    departamento: "08",
    provincia: "05",
    distrito: "09",
    text: "Daniel Hernández",
  },
  {
    departamento: "08",
    provincia: "05",
    distrito: "11",
    text: "Huachocolpa",
  },
  {
    departamento: "08",
    provincia: "05",
    distrito: "12",
    text: "Huaribamba",
  },
  {
    departamento: "08",
    provincia: "05",
    distrito: "15",
    text: "Ñahuimpuquio",
  },
  {
    departamento: "08",
    provincia: "05",
    distrito: "17",
    text: "Pazos",
  },
  {
    departamento: "08",
    provincia: "05",
    distrito: "18",
    text: "Quishuar",
  },
  {
    departamento: "08",
    provincia: "05",
    distrito: "19",
    text: "Salcabamba",
  },
  {
    departamento: "08",
    provincia: "05",
    distrito: "20",
    text: "San Marcos de Rocchac",
  },
  {
    departamento: "08",
    provincia: "05",
    distrito: "23",
    text: "Surcubamba",
  },
  {
    departamento: "08",
    provincia: "05",
    distrito: "25",
    text: "Tintay Puncu",
  },
  {
    departamento: "08",
    provincia: "05",
    distrito: "26",
    text: "Salcahuasi",
  },
  {
    departamento: "08",
    provincia: "06",
    distrito: "00",
    text: "Huaytara",
  },
  {
    departamento: "08",
    provincia: "06",
    distrito: "01",
    text: "Ayavi",
  },
  {
    departamento: "08",
    provincia: "06",
    distrito: "02",
    text: "Córdova",
  },
  {
    departamento: "08",
    provincia: "06",
    distrito: "03",
    text: "Huayacundo Arma",
  },
  {
    departamento: "08",
    provincia: "06",
    distrito: "04",
    text: "Huaytara",
  },
  {
    departamento: "08",
    provincia: "06",
    distrito: "05",
    text: "Laramarca",
  },
  {
    departamento: "08",
    provincia: "06",
    distrito: "06",
    text: "Ocoyo",
  },
  {
    departamento: "08",
    provincia: "06",
    distrito: "07",
    text: "Pilpichaca",
  },
  {
    departamento: "08",
    provincia: "06",
    distrito: "08",
    text: "Querco",
  },
  {
    departamento: "08",
    provincia: "06",
    distrito: "09",
    text: "Quito-Arma",
  },
  {
    departamento: "08",
    provincia: "06",
    distrito: "10",
    text: "San Antonio de Cusicancha",
  },
  {
    departamento: "08",
    provincia: "06",
    distrito: "11",
    text: "San Francisco de Sangayaico",
  },
  {
    departamento: "08",
    provincia: "06",
    distrito: "12",
    text: "San Isidro",
  },
  {
    departamento: "08",
    provincia: "06",
    distrito: "13",
    text: "Santiago de Chocorvos",
  },
  {
    departamento: "08",
    provincia: "06",
    distrito: "14",
    text: "Santiago de Quirahuara",
  },
  {
    departamento: "08",
    provincia: "06",
    distrito: "15",
    text: "Santo Domingo de Capillas",
  },
  {
    departamento: "08",
    provincia: "06",
    distrito: "16",
    text: "Tambo",
  },
  {
    departamento: "08",
    provincia: "07",
    distrito: "00",
    text: "Churcampa",
  },
  {
    departamento: "08",
    provincia: "07",
    distrito: "01",
    text: "Churcampa",
  },
  {
    departamento: "08",
    provincia: "07",
    distrito: "02",
    text: "Anco",
  },
  {
    departamento: "08",
    provincia: "07",
    distrito: "03",
    text: "Chinchihuasi",
  },
  {
    departamento: "08",
    provincia: "07",
    distrito: "04",
    text: "El Carmen",
  },
  {
    departamento: "08",
    provincia: "07",
    distrito: "05",
    text: "La Merced",
  },
  {
    departamento: "08",
    provincia: "07",
    distrito: "06",
    text: "Locroja",
  },
  {
    departamento: "08",
    provincia: "07",
    distrito: "07",
    text: "Paucarbamba",
  },
  {
    departamento: "08",
    provincia: "07",
    distrito: "08",
    text: "San Miguel de Mayocc",
  },
  {
    departamento: "08",
    provincia: "07",
    distrito: "09",
    text: "San Pedro de Coris",
  },
  {
    departamento: "08",
    provincia: "07",
    distrito: "10",
    text: "Pachamarca",
  },
  {
    departamento: "08",
    provincia: "07",
    distrito: "11",
    text: "Cosme",
  },
  {
    departamento: "09",
    provincia: "00",
    distrito: "00",
    text: "Huanuco",
  },
  {
    departamento: "09",
    provincia: "01",
    distrito: "00",
    text: "Huanuco",
  },
  {
    departamento: "09",
    provincia: "01",
    distrito: "01",
    text: "Huanuco",
  },
  {
    departamento: "09",
    provincia: "01",
    distrito: "02",
    text: "Chinchao",
  },
  {
    departamento: "09",
    provincia: "01",
    distrito: "03",
    text: "Churubamba",
  },
  {
    departamento: "09",
    provincia: "01",
    distrito: "04",
    text: "Margos",
  },
  {
    departamento: "09",
    provincia: "01",
    distrito: "05",
    text: "Quisqui",
  },
  {
    departamento: "09",
    provincia: "01",
    distrito: "06",
    text: "San Francisco de Cayran",
  },
  {
    departamento: "09",
    provincia: "01",
    distrito: "07",
    text: "San Pedro de Chaulan",
  },
  {
    departamento: "09",
    provincia: "01",
    distrito: "08",
    text: "Santa Maria del Valle",
  },
  {
    departamento: "09",
    provincia: "01",
    distrito: "09",
    text: "Yarumayo",
  },
  {
    departamento: "09",
    provincia: "01",
    distrito: "10",
    text: "Amarilis",
  },
  {
    departamento: "09",
    provincia: "01",
    distrito: "11",
    text: "Pillco Marca",
  },
  {
    departamento: "09",
    provincia: "01",
    distrito: "12",
    text: "Yacus",
  },
  {
    departamento: "09",
    provincia: "02",
    distrito: "00",
    text: "Ambo",
  },
  {
    departamento: "09",
    provincia: "02",
    distrito: "01",
    text: "Ambo",
  },
  {
    departamento: "09",
    provincia: "02",
    distrito: "02",
    text: "Cayna",
  },
  {
    departamento: "09",
    provincia: "02",
    distrito: "03",
    text: "Colpas",
  },
  {
    departamento: "09",
    provincia: "02",
    distrito: "04",
    text: "Conchamarca",
  },
  {
    departamento: "09",
    provincia: "02",
    distrito: "05",
    text: "Huacar",
  },
  {
    departamento: "09",
    provincia: "02",
    distrito: "06",
    text: "San Francisco",
  },
  {
    departamento: "09",
    provincia: "02",
    distrito: "07",
    text: "San Rafael",
  },
  {
    departamento: "09",
    provincia: "02",
    distrito: "08",
    text: "Tomay Kichwa",
  },
  {
    departamento: "09",
    provincia: "03",
    distrito: "00",
    text: "Dos de Mayo",
  },
  {
    departamento: "09",
    provincia: "03",
    distrito: "01",
    text: "La Union",
  },
  {
    departamento: "09",
    provincia: "03",
    distrito: "07",
    text: "Chuquis",
  },
  {
    departamento: "09",
    provincia: "03",
    distrito: "12",
    text: "Marías",
  },
  {
    departamento: "09",
    provincia: "03",
    distrito: "14",
    text: "Pachas",
  },
  {
    departamento: "09",
    provincia: "03",
    distrito: "16",
    text: "Quivilla",
  },
  {
    departamento: "09",
    provincia: "03",
    distrito: "17",
    text: "Ripan",
  },
  {
    departamento: "09",
    provincia: "03",
    distrito: "21",
    text: "Shunqui",
  },
  {
    departamento: "09",
    provincia: "03",
    distrito: "22",
    text: "Sillapata",
  },
  {
    departamento: "09",
    provincia: "03",
    distrito: "23",
    text: "Yanas",
  },
  {
    departamento: "09",
    provincia: "04",
    distrito: "00",
    text: "Huamalíes",
  },
  {
    departamento: "09",
    provincia: "04",
    distrito: "01",
    text: "Llata",
  },
  {
    departamento: "09",
    provincia: "04",
    distrito: "02",
    text: "Arancay",
  },
  {
    departamento: "09",
    provincia: "04",
    distrito: "03",
    text: "Chavin de Pariarca",
  },
  {
    departamento: "09",
    provincia: "04",
    distrito: "04",
    text: "Jacas Grande",
  },
  {
    departamento: "09",
    provincia: "04",
    distrito: "05",
    text: "Jircan",
  },
  {
    departamento: "09",
    provincia: "04",
    distrito: "06",
    text: "Miraflores",
  },
  {
    departamento: "09",
    provincia: "04",
    distrito: "07",
    text: "Monzón",
  },
  {
    departamento: "09",
    provincia: "04",
    distrito: "08",
    text: "Punchao",
  },
  {
    departamento: "09",
    provincia: "04",
    distrito: "09",
    text: "Puños",
  },
  {
    departamento: "09",
    provincia: "04",
    distrito: "10",
    text: "Singa",
  },
  {
    departamento: "09",
    provincia: "04",
    distrito: "11",
    text: "Tantamayo",
  },
  {
    departamento: "09",
    provincia: "05",
    distrito: "00",
    text: "Marañon",
  },
  {
    departamento: "09",
    provincia: "05",
    distrito: "01",
    text: "Huacrachuco",
  },
  {
    departamento: "09",
    provincia: "05",
    distrito: "02",
    text: "Cholon",
  },
  {
    departamento: "09",
    provincia: "05",
    distrito: "05",
    text: "San Buenaventura",
  },
  {
    departamento: "09",
    provincia: "06",
    distrito: "00",
    text: "Leoncio Prado",
  },
  {
    departamento: "09",
    provincia: "06",
    distrito: "01",
    text: "Rupa-Rupa",
  },
  {
    departamento: "09",
    provincia: "06",
    distrito: "02",
    text: "Daniel Alomias Robles",
  },
  {
    departamento: "09",
    provincia: "06",
    distrito: "03",
    text: "Hermílio Valdizan",
  },
  {
    departamento: "09",
    provincia: "06",
    distrito: "04",
    text: "Luyando",
  },
  {
    departamento: "09",
    provincia: "06",
    distrito: "05",
    text: "Mariano Damaso Beraun",
  },
  {
    departamento: "09",
    provincia: "06",
    distrito: "06",
    text: "José Crespo y Castillo",
  },
  {
    departamento: "09",
    provincia: "07",
    distrito: "00",
    text: "Pachitea",
  },
  {
    departamento: "09",
    provincia: "07",
    distrito: "01",
    text: "Panao",
  },
  {
    departamento: "09",
    provincia: "07",
    distrito: "02",
    text: "Chaglla",
  },
  {
    departamento: "09",
    provincia: "07",
    distrito: "04",
    text: "Molino",
  },
  {
    departamento: "09",
    provincia: "07",
    distrito: "06",
    text: "Umari",
  },
  {
    departamento: "09",
    provincia: "08",
    distrito: "00",
    text: "Puerto Inca",
  },
  {
    departamento: "09",
    provincia: "08",
    distrito: "01",
    text: "Honoria",
  },
  {
    departamento: "09",
    provincia: "08",
    distrito: "02",
    text: "Puerto Inca",
  },
  {
    departamento: "09",
    provincia: "08",
    distrito: "03",
    text: "Codo del Pozuzo",
  },
  {
    departamento: "09",
    provincia: "08",
    distrito: "04",
    text: "Tournavista",
  },
  {
    departamento: "09",
    provincia: "08",
    distrito: "05",
    text: "Yuyapichis",
  },
  {
    departamento: "09",
    provincia: "09",
    distrito: "00",
    text: "Huacaybamba",
  },
  {
    departamento: "09",
    provincia: "09",
    distrito: "01",
    text: "Huacaybamba",
  },
  {
    departamento: "09",
    provincia: "09",
    distrito: "02",
    text: "Pinra",
  },
  {
    departamento: "09",
    provincia: "09",
    distrito: "03",
    text: "Canchabamba",
  },
  {
    departamento: "09",
    provincia: "09",
    distrito: "04",
    text: "Cochabamba",
  },
  {
    departamento: "09",
    provincia: "10",
    distrito: "00",
    text: "Lauricocha",
  },
  {
    departamento: "09",
    provincia: "10",
    distrito: "01",
    text: "Jesus",
  },
  {
    departamento: "09",
    provincia: "10",
    distrito: "02",
    text: "Baños",
  },
  {
    departamento: "09",
    provincia: "10",
    distrito: "03",
    text: "San Francisco de Asís",
  },
  {
    departamento: "09",
    provincia: "10",
    distrito: "04",
    text: "Queropalca",
  },
  {
    departamento: "09",
    provincia: "10",
    distrito: "05",
    text: "San Miguel de Cauri",
  },
  {
    departamento: "09",
    provincia: "10",
    distrito: "06",
    text: "Rondos",
  },
  {
    departamento: "09",
    provincia: "10",
    distrito: "07",
    text: "Jivia",
  },
  {
    departamento: "09",
    provincia: "11",
    distrito: "00",
    text: "Yarowilca",
  },
  {
    departamento: "09",
    provincia: "11",
    distrito: "01",
    text: "Chavinillo",
  },
  {
    departamento: "09",
    provincia: "11",
    distrito: "02",
    text: "Aparicio Pomares",
  },
  {
    departamento: "09",
    provincia: "11",
    distrito: "03",
    text: "Cahuac",
  },
  {
    departamento: "09",
    provincia: "11",
    distrito: "04",
    text: "Chacabamba",
  },
  {
    departamento: "09",
    provincia: "11",
    distrito: "05",
    text: "Jacas Chico",
  },
  {
    departamento: "09",
    provincia: "11",
    distrito: "06",
    text: "Obas",
  },
  {
    departamento: "09",
    provincia: "11",
    distrito: "07",
    text: "Pampamarca",
  },
  {
    departamento: "09",
    provincia: "11",
    distrito: "08",
    text: "Choras",
  },
  {
    departamento: "10",
    provincia: "00",
    distrito: "00",
    text: "Ica",
  },
  {
    departamento: "10",
    provincia: "01",
    distrito: "00",
    text: "Ica",
  },
  {
    departamento: "10",
    provincia: "01",
    distrito: "01",
    text: "Ica",
  },
  {
    departamento: "10",
    provincia: "01",
    distrito: "02",
    text: "La Tinguiña",
  },
  {
    departamento: "10",
    provincia: "01",
    distrito: "03",
    text: "Los Aquijes",
  },
  {
    departamento: "10",
    provincia: "01",
    distrito: "04",
    text: "Parcona",
  },
  {
    departamento: "10",
    provincia: "01",
    distrito: "05",
    text: "Pueblo Nuevo",
  },
  {
    departamento: "10",
    provincia: "01",
    distrito: "06",
    text: "Salas",
  },
  {
    departamento: "10",
    provincia: "01",
    distrito: "07",
    text: "San José de los Molinos",
  },
  {
    departamento: "10",
    provincia: "01",
    distrito: "08",
    text: "San Juan Bautista",
  },
  {
    departamento: "10",
    provincia: "01",
    distrito: "09",
    text: "Santiago",
  },
  {
    departamento: "10",
    provincia: "01",
    distrito: "10",
    text: "Subtanjalla",
  },
  {
    departamento: "10",
    provincia: "01",
    distrito: "11",
    text: "Yauca del Rosario",
  },
  {
    departamento: "10",
    provincia: "01",
    distrito: "12",
    text: "Tate",
  },
  {
    departamento: "10",
    provincia: "01",
    distrito: "13",
    text: "Pachacutec",
  },
  {
    departamento: "10",
    provincia: "01",
    distrito: "14",
    text: "Ocucaje",
  },
  {
    departamento: "10",
    provincia: "02",
    distrito: "00",
    text: "Chincha",
  },
  {
    departamento: "10",
    provincia: "02",
    distrito: "01",
    text: "Chincha Alta",
  },
  {
    departamento: "10",
    provincia: "02",
    distrito: "02",
    text: "Chavin",
  },
  {
    departamento: "10",
    provincia: "02",
    distrito: "03",
    text: "Chincha Baja",
  },
  {
    departamento: "10",
    provincia: "02",
    distrito: "04",
    text: "El Carmen",
  },
  {
    departamento: "10",
    provincia: "02",
    distrito: "05",
    text: "Grocio Prado",
  },
  {
    departamento: "10",
    provincia: "02",
    distrito: "06",
    text: "San Pedro de Huacarpana",
  },
  {
    departamento: "10",
    provincia: "02",
    distrito: "07",
    text: "Sunampe",
  },
  {
    departamento: "10",
    provincia: "02",
    distrito: "08",
    text: "Tambo de Mora",
  },
  {
    departamento: "10",
    provincia: "02",
    distrito: "09",
    text: "Alto Laran",
  },
  {
    departamento: "10",
    provincia: "02",
    distrito: "10",
    text: "Pueblo Nuevo",
  },
  {
    departamento: "10",
    provincia: "02",
    distrito: "11",
    text: "San Juan de Yanac",
  },
  {
    departamento: "10",
    provincia: "03",
    distrito: "00",
    text: "Nazca",
  },
  {
    departamento: "10",
    provincia: "03",
    distrito: "01",
    text: "Nazca",
  },
  {
    departamento: "10",
    provincia: "03",
    distrito: "02",
    text: "Changuillo",
  },
  {
    departamento: "10",
    provincia: "03",
    distrito: "03",
    text: "El Ingenio",
  },
  {
    departamento: "10",
    provincia: "03",
    distrito: "04",
    text: "Marcona",
  },
  {
    departamento: "10",
    provincia: "03",
    distrito: "05",
    text: "Vista Alegre",
  },
  {
    departamento: "10",
    provincia: "04",
    distrito: "00",
    text: "Pisco",
  },
  {
    departamento: "10",
    provincia: "04",
    distrito: "01",
    text: "Pisco",
  },
  {
    departamento: "10",
    provincia: "04",
    distrito: "02",
    text: "Huancano",
  },
  {
    departamento: "10",
    provincia: "04",
    distrito: "03",
    text: "Humay",
  },
  {
    departamento: "10",
    provincia: "04",
    distrito: "04",
    text: "Independencia",
  },
  {
    departamento: "10",
    provincia: "04",
    distrito: "05",
    text: "Paracas",
  },
  {
    departamento: "10",
    provincia: "04",
    distrito: "06",
    text: "San Andrés",
  },
  {
    departamento: "10",
    provincia: "04",
    distrito: "07",
    text: "San Clemente",
  },
  {
    departamento: "10",
    provincia: "04",
    distrito: "08",
    text: "Tupac Amaru Inca",
  },
  {
    departamento: "10",
    provincia: "05",
    distrito: "00",
    text: "Palpa",
  },
  {
    departamento: "10",
    provincia: "05",
    distrito: "01",
    text: "Palpa",
  },
  {
    departamento: "10",
    provincia: "05",
    distrito: "02",
    text: "Llipata",
  },
  {
    departamento: "10",
    provincia: "05",
    distrito: "03",
    text: "Rio Grande",
  },
  {
    departamento: "10",
    provincia: "05",
    distrito: "04",
    text: "Santa Cruz",
  },
  {
    departamento: "10",
    provincia: "05",
    distrito: "05",
    text: "Tibillo",
  },
  {
    departamento: "11",
    provincia: "00",
    distrito: "00",
    text: "Junín",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "00",
    text: "Huancayo",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "01",
    text: "Huancayo",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "03",
    text: "Carhuacallanga",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "04",
    text: "Colca",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "05",
    text: "Cullhuas",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "06",
    text: "Chacapampa",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "07",
    text: "Chicche",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "08",
    text: "Chilca",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "09",
    text: "Chongos Alto",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "12",
    text: "Chupuro",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "13",
    text: "El Tambo",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "14",
    text: "Huacrapuquio",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "16",
    text: "Hualhuas",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "18",
    text: "Huancan",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "19",
    text: "Huasicancha",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "20",
    text: "Huayucachi",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "21",
    text: "Ingenio",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "22",
    text: "Pariahuanca",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "23",
    text: "Pilcomayo",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "24",
    text: "Pucara",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "25",
    text: "Quichuay",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "26",
    text: "Quilcas",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "27",
    text: "San Agustín",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "28",
    text: "San Jerónimo de Tunan",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "31",
    text: "Santo Domingo de Acobamba",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "32",
    text: "Saño",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "33",
    text: "Sapallanga",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "34",
    text: "Sicaya",
  },
  {
    departamento: "11",
    provincia: "01",
    distrito: "36",
    text: "Viques",
  },
  {
    departamento: "11",
    provincia: "02",
    distrito: "00",
    text: "Concepcion",
  },
  {
    departamento: "11",
    provincia: "02",
    distrito: "01",
    text: "Concepcion",
  },
  {
    departamento: "11",
    provincia: "02",
    distrito: "02",
    text: "Aco",
  },
  {
    departamento: "11",
    provincia: "02",
    distrito: "03",
    text: "Andamarca",
  },
  {
    departamento: "11",
    provincia: "02",
    distrito: "04",
    text: "Comas",
  },
  {
    departamento: "11",
    provincia: "02",
    distrito: "05",
    text: "Cochas",
  },
  {
    departamento: "11",
    provincia: "02",
    distrito: "06",
    text: "Chambara",
  },
  {
    departamento: "11",
    provincia: "02",
    distrito: "07",
    text: "Heroínas Toledo",
  },
  {
    departamento: "11",
    provincia: "02",
    distrito: "08",
    text: "Manzanares",
  },
  {
    departamento: "11",
    provincia: "02",
    distrito: "09",
    text: "Mariscal Castilla",
  },
  {
    departamento: "11",
    provincia: "02",
    distrito: "10",
    text: "Matahuasi",
  },
  {
    departamento: "11",
    provincia: "02",
    distrito: "11",
    text: "Mito",
  },
  {
    departamento: "11",
    provincia: "02",
    distrito: "12",
    text: "Nueve de Julio",
  },
  {
    departamento: "11",
    provincia: "02",
    distrito: "13",
    text: "Orcotuna",
  },
  {
    departamento: "11",
    provincia: "02",
    distrito: "14",
    text: "Santa Rosa de Ocopa",
  },
  {
    departamento: "11",
    provincia: "02",
    distrito: "15",
    text: "San José de Quero",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "00",
    text: "Jauja",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "01",
    text: "Jauja",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "02",
    text: "Acolla",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "03",
    text: "Apata",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "04",
    text: "Ataura",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "05",
    text: "Canchayllo",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "06",
    text: "El Mantaro",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "07",
    text: "Huamali",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "08",
    text: "Huaripampa",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "09",
    text: "Huertas",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "10",
    text: "Janjaillo",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "11",
    text: "Julcán",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "12",
    text: "Leonor Ordóñez",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "13",
    text: "Llocllapampa",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "14",
    text: "Marco",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "15",
    text: "Masma",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "16",
    text: "Molinos",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "17",
    text: "Monobamba",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "18",
    text: "Muqui",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "19",
    text: "Muquiyauyo",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "20",
    text: "Paca",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "21",
    text: "Paccha",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "22",
    text: "Pancan",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "23",
    text: "Parco",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "24",
    text: "Pomacancha",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "25",
    text: "Ricran",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "26",
    text: "San Lorenzo",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "27",
    text: "San Pedro de Chunan",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "28",
    text: "Sincos",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "29",
    text: "Tunan Marca",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "30",
    text: "Yauli",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "31",
    text: "Curicaca",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "32",
    text: "Masma Chicche",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "33",
    text: "Sausa",
  },
  {
    departamento: "11",
    provincia: "03",
    distrito: "34",
    text: "Yauyos",
  },
  {
    departamento: "11",
    provincia: "04",
    distrito: "00",
    text: "Junín",
  },
  {
    departamento: "11",
    provincia: "04",
    distrito: "01",
    text: "Junín",
  },
  {
    departamento: "11",
    provincia: "04",
    distrito: "02",
    text: "Carhuamayo",
  },
  {
    departamento: "11",
    provincia: "04",
    distrito: "03",
    text: "Ondores",
  },
  {
    departamento: "11",
    provincia: "04",
    distrito: "04",
    text: "Ulcumayo",
  },
  {
    departamento: "11",
    provincia: "05",
    distrito: "00",
    text: "Tarma",
  },
  {
    departamento: "11",
    provincia: "05",
    distrito: "01",
    text: "Tarma",
  },
  {
    departamento: "11",
    provincia: "05",
    distrito: "02",
    text: "Acobamba",
  },
  {
    departamento: "11",
    provincia: "05",
    distrito: "03",
    text: "Huaricolca",
  },
  {
    departamento: "11",
    provincia: "05",
    distrito: "04",
    text: "Huasahuasi",
  },
  {
    departamento: "11",
    provincia: "05",
    distrito: "05",
    text: "La Union",
  },
  {
    departamento: "11",
    provincia: "05",
    distrito: "06",
    text: "Palca",
  },
  {
    departamento: "11",
    provincia: "05",
    distrito: "07",
    text: "Palcamayo",
  },
  {
    departamento: "11",
    provincia: "05",
    distrito: "08",
    text: "San Pedro de Cajas",
  },
  {
    departamento: "11",
    provincia: "05",
    distrito: "09",
    text: "Tapo",
  },
  {
    departamento: "11",
    provincia: "06",
    distrito: "00",
    text: "Yauli",
  },
  {
    departamento: "11",
    provincia: "06",
    distrito: "01",
    text: "La Oroya",
  },
  {
    departamento: "11",
    provincia: "06",
    distrito: "02",
    text: "Chacapalpa",
  },
  {
    departamento: "11",
    provincia: "06",
    distrito: "03",
    text: "Huay-Huay",
  },
  {
    departamento: "11",
    provincia: "06",
    distrito: "04",
    text: "Marcapomacocha",
  },
  {
    departamento: "11",
    provincia: "06",
    distrito: "05",
    text: "Morococha",
  },
  {
    departamento: "11",
    provincia: "06",
    distrito: "06",
    text: "Paccha",
  },
  {
    departamento: "11",
    provincia: "06",
    distrito: "07",
    text: "Santa Barbara de Carhuacayan",
  },
  {
    departamento: "11",
    provincia: "06",
    distrito: "08",
    text: "Suitucancha",
  },
  {
    departamento: "11",
    provincia: "06",
    distrito: "09",
    text: "Yauli",
  },
  {
    departamento: "11",
    provincia: "06",
    distrito: "10",
    text: "Santa Rosa de Sacco",
  },
  {
    departamento: "11",
    provincia: "07",
    distrito: "00",
    text: "Satipo",
  },
  {
    departamento: "11",
    provincia: "07",
    distrito: "01",
    text: "Satipo",
  },
  {
    departamento: "11",
    provincia: "07",
    distrito: "02",
    text: "Coviriali",
  },
  {
    departamento: "11",
    provincia: "07",
    distrito: "03",
    text: "Llaylla",
  },
  {
    departamento: "11",
    provincia: "07",
    distrito: "04",
    text: "Mazamari",
  },
  {
    departamento: "11",
    provincia: "07",
    distrito: "05",
    text: "Pampa Hermosa",
  },
  {
    departamento: "11",
    provincia: "07",
    distrito: "06",
    text: "Pangoa",
  },
  {
    departamento: "11",
    provincia: "07",
    distrito: "07",
    text: "Rio Negro",
  },
  {
    departamento: "11",
    provincia: "07",
    distrito: "08",
    text: "Rio Tambo",
  },
  {
    departamento: "11",
    provincia: "08",
    distrito: "00",
    text: "Chanchamayo",
  },
  {
    departamento: "11",
    provincia: "08",
    distrito: "01",
    text: "Chanchamayo",
  },
  {
    departamento: "11",
    provincia: "08",
    distrito: "02",
    text: "San Ramón",
  },
  {
    departamento: "11",
    provincia: "08",
    distrito: "03",
    text: "Vitoc",
  },
  {
    departamento: "11",
    provincia: "08",
    distrito: "04",
    text: "San Luis de Shuaro",
  },
  {
    departamento: "11",
    provincia: "08",
    distrito: "05",
    text: "Pichanaqui",
  },
  {
    departamento: "11",
    provincia: "08",
    distrito: "06",
    text: "Perene",
  },
  {
    departamento: "11",
    provincia: "09",
    distrito: "00",
    text: "Chupaca",
  },
  {
    departamento: "11",
    provincia: "09",
    distrito: "01",
    text: "Chupaca",
  },
  {
    departamento: "11",
    provincia: "09",
    distrito: "02",
    text: "Ahuac",
  },
  {
    departamento: "11",
    provincia: "09",
    distrito: "03",
    text: "Chongos Bajo",
  },
  {
    departamento: "11",
    provincia: "09",
    distrito: "04",
    text: "Huachac",
  },
  {
    departamento: "11",
    provincia: "09",
    distrito: "05",
    text: "Huamancaca Chico",
  },
  {
    departamento: "11",
    provincia: "09",
    distrito: "06",
    text: "San Juan de Yscos",
  },
  {
    departamento: "11",
    provincia: "09",
    distrito: "07",
    text: "San Juan de Jarpa",
  },
  {
    departamento: "11",
    provincia: "09",
    distrito: "08",
    text: "Tres de Diciembre",
  },
  {
    departamento: "11",
    provincia: "09",
    distrito: "09",
    text: "Yanacancha",
  },
  {
    departamento: "12",
    provincia: "00",
    distrito: "00",
    text: "La Libertad",
  },
  {
    departamento: "12",
    provincia: "01",
    distrito: "00",
    text: "Trujillo",
  },
  {
    departamento: "12",
    provincia: "01",
    distrito: "01",
    text: "Trujillo",
  },
  {
    departamento: "12",
    provincia: "01",
    distrito: "02",
    text: "Huanchaco",
  },
  {
    departamento: "12",
    provincia: "01",
    distrito: "03",
    text: "Laredo",
  },
  {
    departamento: "12",
    provincia: "01",
    distrito: "04",
    text: "Moche",
  },
  {
    departamento: "12",
    provincia: "01",
    distrito: "05",
    text: "Salaverry",
  },
  {
    departamento: "12",
    provincia: "01",
    distrito: "06",
    text: "Simbal",
  },
  {
    departamento: "12",
    provincia: "01",
    distrito: "07",
    text: "Victor Larco Herrera",
  },
  {
    departamento: "12",
    provincia: "01",
    distrito: "09",
    text: "Poroto",
  },
  {
    departamento: "12",
    provincia: "01",
    distrito: "10",
    text: "El Porvenir",
  },
  {
    departamento: "12",
    provincia: "01",
    distrito: "11",
    text: "La Esperanza",
  },
  {
    departamento: "12",
    provincia: "01",
    distrito: "12",
    text: "Florencia de Mora",
  },
  {
    departamento: "12",
    provincia: "02",
    distrito: "00",
    text: "Bolivar",
  },
  {
    departamento: "12",
    provincia: "02",
    distrito: "01",
    text: "Bolivar",
  },
  {
    departamento: "12",
    provincia: "02",
    distrito: "02",
    text: "Bambamarca",
  },
  {
    departamento: "12",
    provincia: "02",
    distrito: "03",
    text: "Condormarca",
  },
  {
    departamento: "12",
    provincia: "02",
    distrito: "04",
    text: "Longotea",
  },
  {
    departamento: "12",
    provincia: "02",
    distrito: "05",
    text: "Ucuncha",
  },
  {
    departamento: "12",
    provincia: "02",
    distrito: "06",
    text: "Uchumarca",
  },
  {
    departamento: "12",
    provincia: "03",
    distrito: "00",
    text: "Sánchez Carrión",
  },
  {
    departamento: "12",
    provincia: "03",
    distrito: "01",
    text: "Huamachuco",
  },
  {
    departamento: "12",
    provincia: "03",
    distrito: "02",
    text: "Cochorco",
  },
  {
    departamento: "12",
    provincia: "03",
    distrito: "03",
    text: "Curgos",
  },
  {
    departamento: "12",
    provincia: "03",
    distrito: "04",
    text: "Chugay",
  },
  {
    departamento: "12",
    provincia: "03",
    distrito: "05",
    text: "Marcabal",
  },
  {
    departamento: "12",
    provincia: "03",
    distrito: "06",
    text: "Sanagoran",
  },
  {
    departamento: "12",
    provincia: "03",
    distrito: "07",
    text: "Sarin",
  },
  {
    departamento: "12",
    provincia: "03",
    distrito: "08",
    text: "Sartimbamba",
  },
  {
    departamento: "12",
    provincia: "04",
    distrito: "00",
    text: "Otuzco",
  },
  {
    departamento: "12",
    provincia: "04",
    distrito: "01",
    text: "Otuzco",
  },
  {
    departamento: "12",
    provincia: "04",
    distrito: "02",
    text: "Agallpampa",
  },
  {
    departamento: "12",
    provincia: "04",
    distrito: "03",
    text: "Charat",
  },
  {
    departamento: "12",
    provincia: "04",
    distrito: "04",
    text: "Huaranchal",
  },
  {
    departamento: "12",
    provincia: "04",
    distrito: "05",
    text: "La Cuesta",
  },
  {
    departamento: "12",
    provincia: "04",
    distrito: "08",
    text: "Paranday",
  },
  {
    departamento: "12",
    provincia: "04",
    distrito: "09",
    text: "Salpo",
  },
  {
    departamento: "12",
    provincia: "04",
    distrito: "10",
    text: "Sinsicap",
  },
  {
    departamento: "12",
    provincia: "04",
    distrito: "11",
    text: "Usquil",
  },
  {
    departamento: "12",
    provincia: "04",
    distrito: "13",
    text: "Mache",
  },
  {
    departamento: "12",
    provincia: "05",
    distrito: "00",
    text: "Pacasmayo",
  },
  {
    departamento: "12",
    provincia: "05",
    distrito: "01",
    text: "San Pedro de Lloc",
  },
  {
    departamento: "12",
    provincia: "05",
    distrito: "03",
    text: "Guadalupe",
  },
  {
    departamento: "12",
    provincia: "05",
    distrito: "04",
    text: "Jequetepeque",
  },
  {
    departamento: "12",
    provincia: "05",
    distrito: "06",
    text: "Pacasmayo",
  },
  {
    departamento: "12",
    provincia: "05",
    distrito: "08",
    text: "San José",
  },
  {
    departamento: "12",
    provincia: "06",
    distrito: "00",
    text: "Pataz",
  },
  {
    departamento: "12",
    provincia: "06",
    distrito: "01",
    text: "Tayabamba",
  },
  {
    departamento: "12",
    provincia: "06",
    distrito: "02",
    text: "Buldibuyo",
  },
  {
    departamento: "12",
    provincia: "06",
    distrito: "03",
    text: "Chillia",
  },
  {
    departamento: "12",
    provincia: "06",
    distrito: "04",
    text: "Huaylillas",
  },
  {
    departamento: "12",
    provincia: "06",
    distrito: "05",
    text: "Huancaspata",
  },
  {
    departamento: "12",
    provincia: "06",
    distrito: "06",
    text: "Huayo",
  },
  {
    departamento: "12",
    provincia: "06",
    distrito: "07",
    text: "Ongon",
  },
  {
    departamento: "12",
    provincia: "06",
    distrito: "08",
    text: "Parcoy",
  },
  {
    departamento: "12",
    provincia: "06",
    distrito: "09",
    text: "Pataz",
  },
  {
    departamento: "12",
    provincia: "06",
    distrito: "10",
    text: "Pias",
  },
  {
    departamento: "12",
    provincia: "06",
    distrito: "11",
    text: "Taurija",
  },
  {
    departamento: "12",
    provincia: "06",
    distrito: "12",
    text: "Urpay",
  },
  {
    departamento: "12",
    provincia: "06",
    distrito: "13",
    text: "Santiago de Challas",
  },
  {
    departamento: "12",
    provincia: "07",
    distrito: "00",
    text: "Santiago de Chuco",
  },
  {
    departamento: "12",
    provincia: "07",
    distrito: "01",
    text: "Santiago de Chuco",
  },
  {
    departamento: "12",
    provincia: "07",
    distrito: "02",
    text: "Cachicadan",
  },
  {
    departamento: "12",
    provincia: "07",
    distrito: "03",
    text: "Mollebamba",
  },
  {
    departamento: "12",
    provincia: "07",
    distrito: "04",
    text: "Mollepata",
  },
  {
    departamento: "12",
    provincia: "07",
    distrito: "05",
    text: "Quiruvilca",
  },
  {
    departamento: "12",
    provincia: "07",
    distrito: "06",
    text: "Santa Cruz de Chuca",
  },
  {
    departamento: "12",
    provincia: "07",
    distrito: "07",
    text: "Sitabamba",
  },
  {
    departamento: "12",
    provincia: "07",
    distrito: "08",
    text: "Angasmarca",
  },
  {
    departamento: "12",
    provincia: "08",
    distrito: "00",
    text: "Ascope",
  },
  {
    departamento: "12",
    provincia: "08",
    distrito: "01",
    text: "Ascope",
  },
  {
    departamento: "12",
    provincia: "08",
    distrito: "02",
    text: "Chicama",
  },
  {
    departamento: "12",
    provincia: "08",
    distrito: "03",
    text: "Chocope",
  },
  {
    departamento: "12",
    provincia: "08",
    distrito: "04",
    text: "Santiago de Cao",
  },
  {
    departamento: "12",
    provincia: "08",
    distrito: "05",
    text: "Magdalena de Cao",
  },
  {
    departamento: "12",
    provincia: "08",
    distrito: "06",
    text: "Paijan",
  },
  {
    departamento: "12",
    provincia: "08",
    distrito: "07",
    text: "Rázuri",
  },
  {
    departamento: "12",
    provincia: "08",
    distrito: "08",
    text: "Casa Grande",
  },
  {
    departamento: "12",
    provincia: "09",
    distrito: "00",
    text: "Chepén",
  },
  {
    departamento: "12",
    provincia: "09",
    distrito: "01",
    text: "Chepén",
  },
  {
    departamento: "12",
    provincia: "09",
    distrito: "02",
    text: "Pacanga",
  },
  {
    departamento: "12",
    provincia: "09",
    distrito: "03",
    text: "Pueblo Nuevo",
  },
  {
    departamento: "12",
    provincia: "10",
    distrito: "00",
    text: "Julcán",
  },
  {
    departamento: "12",
    provincia: "10",
    distrito: "01",
    text: "Julcán",
  },
  {
    departamento: "12",
    provincia: "10",
    distrito: "02",
    text: "Carabamba",
  },
  {
    departamento: "12",
    provincia: "10",
    distrito: "03",
    text: "Calamarca",
  },
  {
    departamento: "12",
    provincia: "10",
    distrito: "04",
    text: "Huaso",
  },
  {
    departamento: "12",
    provincia: "11",
    distrito: "00",
    text: "Gran Chimú",
  },
  {
    departamento: "12",
    provincia: "11",
    distrito: "01",
    text: "Cascas",
  },
  {
    departamento: "12",
    provincia: "11",
    distrito: "02",
    text: "Lucma",
  },
  {
    departamento: "12",
    provincia: "11",
    distrito: "03",
    text: "Marmot",
  },
  {
    departamento: "12",
    provincia: "11",
    distrito: "04",
    text: "Sayapullo",
  },
  {
    departamento: "12",
    provincia: "12",
    distrito: "00",
    text: "Viru",
  },
  {
    departamento: "12",
    provincia: "12",
    distrito: "01",
    text: "Viru",
  },
  {
    departamento: "12",
    provincia: "12",
    distrito: "02",
    text: "Chao",
  },
  {
    departamento: "12",
    provincia: "12",
    distrito: "03",
    text: "Guadalupito",
  },
  {
    departamento: "13",
    provincia: "00",
    distrito: "00",
    text: "Lambayeque",
  },
  {
    departamento: "13",
    provincia: "01",
    distrito: "00",
    text: "Chiclayo",
  },
  {
    departamento: "13",
    provincia: "01",
    distrito: "01",
    text: "Chiclayo",
  },
  {
    departamento: "13",
    provincia: "01",
    distrito: "02",
    text: "Chongoyape",
  },
  {
    departamento: "13",
    provincia: "01",
    distrito: "03",
    text: "Eten",
  },
  {
    departamento: "13",
    provincia: "01",
    distrito: "04",
    text: "Eten Puerto",
  },
  {
    departamento: "13",
    provincia: "01",
    distrito: "05",
    text: "Lagunas",
  },
  {
    departamento: "13",
    provincia: "01",
    distrito: "06",
    text: "Monsefu",
  },
  {
    departamento: "13",
    provincia: "01",
    distrito: "07",
    text: "Nueva Arica",
  },
  {
    departamento: "13",
    provincia: "01",
    distrito: "08",
    text: "Oyotun",
  },
  {
    departamento: "13",
    provincia: "01",
    distrito: "09",
    text: "Picsi",
  },
  {
    departamento: "13",
    provincia: "01",
    distrito: "10",
    text: "Pimentel",
  },
  {
    departamento: "13",
    provincia: "01",
    distrito: "11",
    text: "Reque",
  },
  {
    departamento: "13",
    provincia: "01",
    distrito: "12",
    text: "José Leonardo Ortiz",
  },
  {
    departamento: "13",
    provincia: "01",
    distrito: "13",
    text: "Santa Rosa",
  },
  {
    departamento: "13",
    provincia: "01",
    distrito: "14",
    text: "Saña",
  },
  {
    departamento: "13",
    provincia: "01",
    distrito: "15",
    text: "La Victoria",
  },
  {
    departamento: "13",
    provincia: "01",
    distrito: "16",
    text: "Cayalti",
  },
  {
    departamento: "13",
    provincia: "01",
    distrito: "17",
    text: "Patapo",
  },
  {
    departamento: "13",
    provincia: "01",
    distrito: "18",
    text: "Pomalca",
  },
  {
    departamento: "13",
    provincia: "01",
    distrito: "19",
    text: "Pucala",
  },
  {
    departamento: "13",
    provincia: "01",
    distrito: "20",
    text: "Tuman",
  },
  {
    departamento: "13",
    provincia: "02",
    distrito: "00",
    text: "Ferreñafe",
  },
  {
    departamento: "13",
    provincia: "02",
    distrito: "01",
    text: "Ferreñafe",
  },
  {
    departamento: "13",
    provincia: "02",
    distrito: "02",
    text: "Incahuasi",
  },
  {
    departamento: "13",
    provincia: "02",
    distrito: "03",
    text: "Cañaris",
  },
  {
    departamento: "13",
    provincia: "02",
    distrito: "04",
    text: "Pitipo",
  },
  {
    departamento: "13",
    provincia: "02",
    distrito: "05",
    text: "Pueblo Nuevo",
  },
  {
    departamento: "13",
    provincia: "02",
    distrito: "06",
    text: "Manuel Antonio Mesones Muro",
  },
  {
    departamento: "13",
    provincia: "03",
    distrito: "00",
    text: "Lambayeque",
  },
  {
    departamento: "13",
    provincia: "03",
    distrito: "01",
    text: "Lambayeque",
  },
  {
    departamento: "13",
    provincia: "03",
    distrito: "02",
    text: "Chochope",
  },
  {
    departamento: "13",
    provincia: "03",
    distrito: "03",
    text: "Illimo",
  },
  {
    departamento: "13",
    provincia: "03",
    distrito: "04",
    text: "Jayanca",
  },
  {
    departamento: "13",
    provincia: "03",
    distrito: "05",
    text: "Mochumi",
  },
  {
    departamento: "13",
    provincia: "03",
    distrito: "06",
    text: "Morrope",
  },
  {
    departamento: "13",
    provincia: "03",
    distrito: "07",
    text: "Motupe",
  },
  {
    departamento: "13",
    provincia: "03",
    distrito: "08",
    text: "Olmos",
  },
  {
    departamento: "13",
    provincia: "03",
    distrito: "09",
    text: "Pacora",
  },
  {
    departamento: "13",
    provincia: "03",
    distrito: "10",
    text: "Salas",
  },
  {
    departamento: "13",
    provincia: "03",
    distrito: "11",
    text: "San José",
  },
  {
    departamento: "13",
    provincia: "03",
    distrito: "12",
    text: "Túcume",
  },
  {
    departamento: "14",
    provincia: "00",
    distrito: "00",
    text: "Lima",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "00",
    text: "Lima",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "01",
    text: "Lima",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "02",
    text: "Ancón",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "03",
    text: "Ate",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "04",
    text: "Breña",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "05",
    text: "Carabayllo",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "06",
    text: "Comas",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "07",
    text: "Chaclacayo",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "08",
    text: "Chorrillos",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "09",
    text: "La Victoria",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "10",
    text: "La Molina",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "11",
    text: "Lince",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "12",
    text: "Lurigancho",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "13",
    text: "Lurin",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "14",
    text: "Magdalena del Mar",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "15",
    text: "Miraflores",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "16",
    text: "Pachacamac",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "17",
    text: "Pueblo Libre",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "18",
    text: "Pucusana",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "19",
    text: "Puente Piedra",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "20",
    text: "Punta Hermosa",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "21",
    text: "Punta Negra",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "22",
    text: "Rímac",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "23",
    text: "San Bartolo",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "24",
    text: "San Isidro",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "25",
    text: "Barranco",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "26",
    text: "San Martín de Porres",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "27",
    text: "San Miguel",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "28",
    text: "Santa Maria del Mar",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "29",
    text: "Santa Rosa",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "30",
    text: "Santiago de Surco",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "31",
    text: "Surquillo",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "32",
    text: "Villa Maria del Triunfo",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "33",
    text: "Jesus Maria",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "34",
    text: "Independencia",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "35",
    text: "El Agustino",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "36",
    text: "San Juan de Miraflores",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "37",
    text: "San Juan de Lurigancho",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "38",
    text: "San Luis",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "39",
    text: "Cieneguilla",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "40",
    text: "San Borja",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "41",
    text: "Villa El Salvador",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "42",
    text: "Los Olivos",
  },
  {
    departamento: "14",
    provincia: "01",
    distrito: "43",
    text: "Santa Anita",
  },
  {
    departamento: "14",
    provincia: "02",
    distrito: "00",
    text: "Cajatambo",
  },
  {
    departamento: "14",
    provincia: "02",
    distrito: "01",
    text: "Cajatambo",
  },
  {
    departamento: "14",
    provincia: "02",
    distrito: "05",
    text: "Copa",
  },
  {
    departamento: "14",
    provincia: "02",
    distrito: "06",
    text: "Gorgor",
  },
  {
    departamento: "14",
    provincia: "02",
    distrito: "07",
    text: "Huancapon",
  },
  {
    departamento: "14",
    provincia: "02",
    distrito: "08",
    text: "Manas",
  },
  {
    departamento: "14",
    provincia: "03",
    distrito: "00",
    text: "Canta",
  },
  {
    departamento: "14",
    provincia: "03",
    distrito: "01",
    text: "Canta",
  },
  {
    departamento: "14",
    provincia: "03",
    distrito: "02",
    text: "Arahuay",
  },
  {
    departamento: "14",
    provincia: "03",
    distrito: "03",
    text: "Huamantanga",
  },
  {
    departamento: "14",
    provincia: "03",
    distrito: "04",
    text: "Huaros",
  },
  {
    departamento: "14",
    provincia: "03",
    distrito: "05",
    text: "Lachaqui",
  },
  {
    departamento: "14",
    provincia: "03",
    distrito: "06",
    text: "San Buenaventura",
  },
  {
    departamento: "14",
    provincia: "03",
    distrito: "07",
    text: "Santa Rosa de Quives",
  },
  {
    departamento: "14",
    provincia: "04",
    distrito: "00",
    text: "Cañete",
  },
  {
    departamento: "14",
    provincia: "04",
    distrito: "01",
    text: "San Vicente de Cañete",
  },
  {
    departamento: "14",
    provincia: "04",
    distrito: "02",
    text: "Calango",
  },
  {
    departamento: "14",
    provincia: "04",
    distrito: "03",
    text: "Cerro Azul",
  },
  {
    departamento: "14",
    provincia: "04",
    distrito: "04",
    text: "Coayllo",
  },
  {
    departamento: "14",
    provincia: "04",
    distrito: "05",
    text: "Chilca",
  },
  {
    departamento: "14",
    provincia: "04",
    distrito: "06",
    text: "Imperial",
  },
  {
    departamento: "14",
    provincia: "04",
    distrito: "07",
    text: "Lunahuana",
  },
  {
    departamento: "14",
    provincia: "04",
    distrito: "08",
    text: "Mala",
  },
  {
    departamento: "14",
    provincia: "04",
    distrito: "09",
    text: "Nuevo Imperial",
  },
  {
    departamento: "14",
    provincia: "04",
    distrito: "10",
    text: "Pacaran",
  },
  {
    departamento: "14",
    provincia: "04",
    distrito: "11",
    text: "Quilmana",
  },
  {
    departamento: "14",
    provincia: "04",
    distrito: "12",
    text: "San Antonio",
  },
  {
    departamento: "14",
    provincia: "04",
    distrito: "13",
    text: "San Luis",
  },
  {
    departamento: "14",
    provincia: "04",
    distrito: "14",
    text: "Santa Cruz de Flores",
  },
  {
    departamento: "14",
    provincia: "04",
    distrito: "15",
    text: "Zúñiga",
  },
  {
    departamento: "14",
    provincia: "04",
    distrito: "16",
    text: "Asia",
  },
  {
    departamento: "14",
    provincia: "05",
    distrito: "00",
    text: "Huaura",
  },
  {
    departamento: "14",
    provincia: "05",
    distrito: "01",
    text: "Huacho",
  },
  {
    departamento: "14",
    provincia: "05",
    distrito: "02",
    text: "Ambar",
  },
  {
    departamento: "14",
    provincia: "05",
    distrito: "04",
    text: "Caleta de Carquin",
  },
  {
    departamento: "14",
    provincia: "05",
    distrito: "05",
    text: "Checras",
  },
  {
    departamento: "14",
    provincia: "05",
    distrito: "06",
    text: "Hualmay",
  },
  {
    departamento: "14",
    provincia: "05",
    distrito: "07",
    text: "Huaura",
  },
  {
    departamento: "14",
    provincia: "05",
    distrito: "08",
    text: "Leoncio Prado",
  },
  {
    departamento: "14",
    provincia: "05",
    distrito: "09",
    text: "Paccho",
  },
  {
    departamento: "14",
    provincia: "05",
    distrito: "11",
    text: "Santa Leonor",
  },
  {
    departamento: "14",
    provincia: "05",
    distrito: "12",
    text: "Santa Maria",
  },
  {
    departamento: "14",
    provincia: "05",
    distrito: "13",
    text: "Sayan",
  },
  {
    departamento: "14",
    provincia: "05",
    distrito: "16",
    text: "Vegueta",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "00",
    text: "Huarochiri",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "01",
    text: "Matucana",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "02",
    text: "Antioquia",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "03",
    text: "Callahuanca",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "04",
    text: "Carampoma",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "05",
    text: "San Pedro de Casta",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "06",
    text: "Cuenca",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "07",
    text: "Chicla",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "08",
    text: "Huanza",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "09",
    text: "Huarochiri",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "10",
    text: "Lahuaytambo",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "11",
    text: "Langa",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "12",
    text: "Mariatana",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "13",
    text: "Ricardo Palma",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "14",
    text: "San Andrés de Tupicocha",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "15",
    text: "San Antonio",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "16",
    text: "San Bartolomé",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "17",
    text: "San Damian",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "18",
    text: "Sangallaya",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "19",
    text: "San Juan de Tantaranche",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "20",
    text: "San Lorenzo de Quinti",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "21",
    text: "San Mateo",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "22",
    text: "San Mateo de Otao",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "23",
    text: "San Pedro de Huancayre",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "24",
    text: "Santa Cruz de Cocachacra",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "25",
    text: "Santa Eulalia",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "26",
    text: "Santiago de Anchucaya",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "27",
    text: "Santiago de Tuna",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "28",
    text: "Santo Domingo de los Olleros",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "29",
    text: "Surco",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "30",
    text: "Huachupampa",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "31",
    text: "Laraos",
  },
  {
    departamento: "14",
    provincia: "06",
    distrito: "32",
    text: "San Juan de Iris",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "00",
    text: "Yauyos",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "01",
    text: "Yauyos",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "02",
    text: "Alis",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "03",
    text: "Ayauca",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "04",
    text: "Ayaviri",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "05",
    text: "Azángaro",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "06",
    text: "Cacra",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "07",
    text: "Carania",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "08",
    text: "Cochas",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "09",
    text: "Colonia",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "10",
    text: "Chocos",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "11",
    text: "Huampara",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "12",
    text: "Huancaya",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "13",
    text: "Huangascar",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "14",
    text: "Huantan",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "15",
    text: "Huañec",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "16",
    text: "Laraos",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "17",
    text: "Lincha",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "18",
    text: "Miraflores",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "19",
    text: "Omas",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "20",
    text: "Quinches",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "21",
    text: "Quinocay",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "22",
    text: "San Joaquín",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "23",
    text: "San Pedro de Pilas",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "24",
    text: "Tanta",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "25",
    text: "Tauripampa",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "26",
    text: "Tupe",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "27",
    text: "Tomas",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "28",
    text: "Viñac",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "29",
    text: "Vitis",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "30",
    text: "Hongos",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "31",
    text: "Madean",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "32",
    text: "Putinza",
  },
  {
    departamento: "14",
    provincia: "07",
    distrito: "33",
    text: "Catahuasi",
  },
  {
    departamento: "14",
    provincia: "08",
    distrito: "00",
    text: "Huaral",
  },
  {
    departamento: "14",
    provincia: "08",
    distrito: "01",
    text: "Huaral",
  },
  {
    departamento: "14",
    provincia: "08",
    distrito: "02",
    text: "Atavillos Alto",
  },
  {
    departamento: "14",
    provincia: "08",
    distrito: "03",
    text: "Atavillos Bajo",
  },
  {
    departamento: "14",
    provincia: "08",
    distrito: "04",
    text: "Aucallama",
  },
  {
    departamento: "14",
    provincia: "08",
    distrito: "05",
    text: "Chancay",
  },
  {
    departamento: "14",
    provincia: "08",
    distrito: "06",
    text: "Ihuari",
  },
  {
    departamento: "14",
    provincia: "08",
    distrito: "07",
    text: "Lampian",
  },
  {
    departamento: "14",
    provincia: "08",
    distrito: "08",
    text: "Pacaraos",
  },
  {
    departamento: "14",
    provincia: "08",
    distrito: "09",
    text: "San Miguel de Acos",
  },
  {
    departamento: "14",
    provincia: "08",
    distrito: "10",
    text: "Veintisiete de Noviembre",
  },
  {
    departamento: "14",
    provincia: "08",
    distrito: "11",
    text: "Santa Cruz de Andamarca",
  },
  {
    departamento: "14",
    provincia: "08",
    distrito: "12",
    text: "Sumbilca",
  },
  {
    departamento: "14",
    provincia: "09",
    distrito: "00",
    text: "Barranca",
  },
  {
    departamento: "14",
    provincia: "09",
    distrito: "01",
    text: "Barranca",
  },
  {
    departamento: "14",
    provincia: "09",
    distrito: "02",
    text: "Paramonga",
  },
  {
    departamento: "14",
    provincia: "09",
    distrito: "03",
    text: "Pativilca",
  },
  {
    departamento: "14",
    provincia: "09",
    distrito: "04",
    text: "Supe",
  },
  {
    departamento: "14",
    provincia: "09",
    distrito: "05",
    text: "Supe Puerto",
  },
  {
    departamento: "14",
    provincia: "10",
    distrito: "00",
    text: "Oyon",
  },
  {
    departamento: "14",
    provincia: "10",
    distrito: "01",
    text: "Oyon",
  },
  {
    departamento: "14",
    provincia: "10",
    distrito: "02",
    text: "Navan",
  },
  {
    departamento: "14",
    provincia: "10",
    distrito: "03",
    text: "Caujul",
  },
  {
    departamento: "14",
    provincia: "10",
    distrito: "04",
    text: "Andajes",
  },
  {
    departamento: "14",
    provincia: "10",
    distrito: "05",
    text: "Pachangara",
  },
  {
    departamento: "14",
    provincia: "10",
    distrito: "06",
    text: "Cochamarca",
  },
  {
    departamento: "15",
    provincia: "00",
    distrito: "00",
    text: "Loreto",
  },
  {
    departamento: "15",
    provincia: "01",
    distrito: "00",
    text: "Maynas",
  },
  {
    departamento: "15",
    provincia: "01",
    distrito: "01",
    text: "Iquitos",
  },
  {
    departamento: "15",
    provincia: "01",
    distrito: "02",
    text: "Alto Nanay",
  },
  {
    departamento: "15",
    provincia: "01",
    distrito: "03",
    text: "Fernando Lores",
  },
  {
    departamento: "15",
    provincia: "01",
    distrito: "04",
    text: "Las Amazonas",
  },
  {
    departamento: "15",
    provincia: "01",
    distrito: "05",
    text: "Mazan",
  },
  {
    departamento: "15",
    provincia: "01",
    distrito: "06",
    text: "Napo",
  },
  {
    departamento: "15",
    provincia: "01",
    distrito: "07",
    text: "Putumayo",
  },
  {
    departamento: "15",
    provincia: "01",
    distrito: "08",
    text: "Torres Causana",
  },
  {
    departamento: "15",
    provincia: "01",
    distrito: "10",
    text: "Indiana",
  },
  {
    departamento: "15",
    provincia: "01",
    distrito: "11",
    text: "Punchana",
  },
  {
    departamento: "15",
    provincia: "01",
    distrito: "12",
    text: "Belén",
  },
  {
    departamento: "15",
    provincia: "01",
    distrito: "13",
    text: "San Juan Bautista",
  },
  {
    departamento: "15",
    provincia: "01",
    distrito: "14",
    text: "Teniente Manuel Clavero",
  },
  {
    departamento: "15",
    provincia: "02",
    distrito: "00",
    text: "Alto Amazonas",
  },
  {
    departamento: "15",
    provincia: "02",
    distrito: "01",
    text: "Yurimaguas",
  },
  {
    departamento: "15",
    provincia: "02",
    distrito: "02",
    text: "Balsapuerto",
  },
  {
    departamento: "15",
    provincia: "02",
    distrito: "05",
    text: "Jeberos",
  },
  {
    departamento: "15",
    provincia: "02",
    distrito: "06",
    text: "Lagunas",
  },
  {
    departamento: "15",
    provincia: "02",
    distrito: "10",
    text: "Santa Cruz",
  },
  {
    departamento: "15",
    provincia: "02",
    distrito: "11",
    text: "Teniente Cesar López Rojas",
  },
  {
    departamento: "15",
    provincia: "03",
    distrito: "00",
    text: "Loreto",
  },
  {
    departamento: "15",
    provincia: "03",
    distrito: "01",
    text: "Nauta",
  },
  {
    departamento: "15",
    provincia: "03",
    distrito: "02",
    text: "Parinari",
  },
  {
    departamento: "15",
    provincia: "03",
    distrito: "03",
    text: "Tigre",
  },
  {
    departamento: "15",
    provincia: "03",
    distrito: "04",
    text: "Urarinas",
  },
  {
    departamento: "15",
    provincia: "03",
    distrito: "05",
    text: "Trompeteros",
  },
  {
    departamento: "15",
    provincia: "04",
    distrito: "00",
    text: "Requena",
  },
  {
    departamento: "15",
    provincia: "04",
    distrito: "01",
    text: "Requena",
  },
  {
    departamento: "15",
    provincia: "04",
    distrito: "02",
    text: "Alto Tapiche",
  },
  {
    departamento: "15",
    provincia: "04",
    distrito: "03",
    text: "Capelo",
  },
  {
    departamento: "15",
    provincia: "04",
    distrito: "04",
    text: "Emilio San Martín",
  },
  {
    departamento: "15",
    provincia: "04",
    distrito: "05",
    text: "Maquia",
  },
  {
    departamento: "15",
    provincia: "04",
    distrito: "06",
    text: "Puinahua",
  },
  {
    departamento: "15",
    provincia: "04",
    distrito: "07",
    text: "Saquena",
  },
  {
    departamento: "15",
    provincia: "04",
    distrito: "08",
    text: "Soplin",
  },
  {
    departamento: "15",
    provincia: "04",
    distrito: "09",
    text: "Tapiche",
  },
  {
    departamento: "15",
    provincia: "04",
    distrito: "10",
    text: "Jenaro Herrera",
  },
  {
    departamento: "15",
    provincia: "04",
    distrito: "11",
    text: "Yaquerana",
  },
  {
    departamento: "15",
    provincia: "05",
    distrito: "00",
    text: "Ucayali",
  },
  {
    departamento: "15",
    provincia: "05",
    distrito: "01",
    text: "Contamana",
  },
  {
    departamento: "15",
    provincia: "05",
    distrito: "02",
    text: "Vargas Guerra",
  },
  {
    departamento: "15",
    provincia: "05",
    distrito: "03",
    text: "Padre Marquez",
  },
  {
    departamento: "15",
    provincia: "05",
    distrito: "04",
    text: "Pampa Hermosa",
  },
  {
    departamento: "15",
    provincia: "05",
    distrito: "05",
    text: "Sarayacu",
  },
  {
    departamento: "15",
    provincia: "05",
    distrito: "06",
    text: "Inahuaya",
  },
  {
    departamento: "15",
    provincia: "06",
    distrito: "00",
    text: "Mariscal Ramón Castilla",
  },
  {
    departamento: "15",
    provincia: "06",
    distrito: "01",
    text: "Ramón Castilla",
  },
  {
    departamento: "15",
    provincia: "06",
    distrito: "02",
    text: "Pebas",
  },
  {
    departamento: "15",
    provincia: "06",
    distrito: "03",
    text: "Yavari",
  },
  {
    departamento: "15",
    provincia: "06",
    distrito: "04",
    text: "San Pablo",
  },
  {
    departamento: "15",
    provincia: "07",
    distrito: "00",
    text: "Datem del Marañon",
  },
  {
    departamento: "15",
    provincia: "07",
    distrito: "01",
    text: "Barranca",
  },
  {
    departamento: "15",
    provincia: "07",
    distrito: "02",
    text: "Andoas",
  },
  {
    departamento: "15",
    provincia: "07",
    distrito: "03",
    text: "Cahuapanas",
  },
  {
    departamento: "15",
    provincia: "07",
    distrito: "04",
    text: "Manseriche",
  },
  {
    departamento: "15",
    provincia: "07",
    distrito: "05",
    text: "Morona",
  },
  {
    departamento: "15",
    provincia: "07",
    distrito: "06",
    text: "Pastaza",
  },
  {
    departamento: "16",
    provincia: "00",
    distrito: "00",
    text: "Madre de Dios",
  },
  {
    departamento: "16",
    provincia: "01",
    distrito: "00",
    text: "Tambopata",
  },
  {
    departamento: "16",
    provincia: "01",
    distrito: "01",
    text: "Tambopata",
  },
  {
    departamento: "16",
    provincia: "01",
    distrito: "02",
    text: "Inambari",
  },
  {
    departamento: "16",
    provincia: "01",
    distrito: "03",
    text: "Las Piedras",
  },
  {
    departamento: "16",
    provincia: "01",
    distrito: "04",
    text: "Laberinto",
  },
  {
    departamento: "16",
    provincia: "02",
    distrito: "00",
    text: "Manu",
  },
  {
    departamento: "16",
    provincia: "02",
    distrito: "01",
    text: "Manu",
  },
  {
    departamento: "16",
    provincia: "02",
    distrito: "02",
    text: "Fitzcarrald",
  },
  {
    departamento: "16",
    provincia: "02",
    distrito: "03",
    text: "Madre de Dios",
  },
  {
    departamento: "16",
    provincia: "02",
    distrito: "04",
    text: "Huepetuhe",
  },
  {
    departamento: "16",
    provincia: "03",
    distrito: "00",
    text: "Tahuamanu",
  },
  {
    departamento: "16",
    provincia: "03",
    distrito: "01",
    text: "Iñapari",
  },
  {
    departamento: "16",
    provincia: "03",
    distrito: "02",
    text: "Iberia",
  },
  {
    departamento: "16",
    provincia: "03",
    distrito: "03",
    text: "Tahuamanu",
  },
  {
    departamento: "17",
    provincia: "00",
    distrito: "00",
    text: "Moquegua",
  },
  {
    departamento: "17",
    provincia: "01",
    distrito: "00",
    text: "Mariscal Nieto",
  },
  {
    departamento: "17",
    provincia: "01",
    distrito: "01",
    text: "Moquegua",
  },
  {
    departamento: "17",
    provincia: "01",
    distrito: "02",
    text: "Carumas",
  },
  {
    departamento: "17",
    provincia: "01",
    distrito: "03",
    text: "Cuchumbaya",
  },
  {
    departamento: "17",
    provincia: "01",
    distrito: "04",
    text: "San Cristóbal",
  },
  {
    departamento: "17",
    provincia: "01",
    distrito: "05",
    text: "Torata",
  },
  {
    departamento: "17",
    provincia: "01",
    distrito: "06",
    text: "Samegua",
  },
  {
    departamento: "17",
    provincia: "02",
    distrito: "00",
    text: "General Sánchez Cerro",
  },
  {
    departamento: "17",
    provincia: "02",
    distrito: "01",
    text: "Omate",
  },
  {
    departamento: "17",
    provincia: "02",
    distrito: "02",
    text: "Coalaque",
  },
  {
    departamento: "17",
    provincia: "02",
    distrito: "03",
    text: "Chojata",
  },
  {
    departamento: "17",
    provincia: "02",
    distrito: "04",
    text: "Ichuña",
  },
  {
    departamento: "17",
    provincia: "02",
    distrito: "05",
    text: "La Capilla",
  },
  {
    departamento: "17",
    provincia: "02",
    distrito: "06",
    text: "Lloque",
  },
  {
    departamento: "17",
    provincia: "02",
    distrito: "07",
    text: "Matalaque",
  },
  {
    departamento: "17",
    provincia: "02",
    distrito: "08",
    text: "Puquina",
  },
  {
    departamento: "17",
    provincia: "02",
    distrito: "09",
    text: "Quinistaquillas",
  },
  {
    departamento: "17",
    provincia: "02",
    distrito: "10",
    text: "Ubinas",
  },
  {
    departamento: "17",
    provincia: "02",
    distrito: "11",
    text: "Yunga",
  },
  {
    departamento: "17",
    provincia: "03",
    distrito: "00",
    text: "Ilo",
  },
  {
    departamento: "17",
    provincia: "03",
    distrito: "01",
    text: "Ilo",
  },
  {
    departamento: "17",
    provincia: "03",
    distrito: "02",
    text: "El Algarrobal",
  },
  {
    departamento: "17",
    provincia: "03",
    distrito: "03",
    text: "Pacocha",
  },
  {
    departamento: "18",
    provincia: "00",
    distrito: "00",
    text: "Pasco",
  },
  {
    departamento: "18",
    provincia: "01",
    distrito: "00",
    text: "Pasco",
  },
  {
    departamento: "18",
    provincia: "01",
    distrito: "01",
    text: "Chaupimarca",
  },
  {
    departamento: "18",
    provincia: "01",
    distrito: "03",
    text: "Huachon",
  },
  {
    departamento: "18",
    provincia: "01",
    distrito: "04",
    text: "Huariaca",
  },
  {
    departamento: "18",
    provincia: "01",
    distrito: "05",
    text: "Huayllay",
  },
  {
    departamento: "18",
    provincia: "01",
    distrito: "06",
    text: "Ninacaca",
  },
  {
    departamento: "18",
    provincia: "01",
    distrito: "07",
    text: "Pallanchacra",
  },
  {
    departamento: "18",
    provincia: "01",
    distrito: "08",
    text: "Paucartambo",
  },
  {
    departamento: "18",
    provincia: "01",
    distrito: "09",
    text: "San Francisco de Asís de Yarusyacan",
  },
  {
    departamento: "18",
    provincia: "01",
    distrito: "10",
    text: "Simon Bolivar",
  },
  {
    departamento: "18",
    provincia: "01",
    distrito: "11",
    text: "Ticlacayan",
  },
  {
    departamento: "18",
    provincia: "01",
    distrito: "12",
    text: "Tinyahuarco",
  },
  {
    departamento: "18",
    provincia: "01",
    distrito: "13",
    text: "Vicco",
  },
  {
    departamento: "18",
    provincia: "01",
    distrito: "14",
    text: "Yanacancha",
  },
  {
    departamento: "18",
    provincia: "02",
    distrito: "00",
    text: "Daniel Alcides Carrión",
  },
  {
    departamento: "18",
    provincia: "02",
    distrito: "01",
    text: "Yanahuanca",
  },
  {
    departamento: "18",
    provincia: "02",
    distrito: "02",
    text: "Chacayan",
  },
  {
    departamento: "18",
    provincia: "02",
    distrito: "03",
    text: "Goyllarisquizga",
  },
  {
    departamento: "18",
    provincia: "02",
    distrito: "04",
    text: "Paucar",
  },
  {
    departamento: "18",
    provincia: "02",
    distrito: "05",
    text: "San Pedro de Pillao",
  },
  {
    departamento: "18",
    provincia: "02",
    distrito: "06",
    text: "Santa Ana de Tusi",
  },
  {
    departamento: "18",
    provincia: "02",
    distrito: "07",
    text: "Tapuc",
  },
  {
    departamento: "18",
    provincia: "02",
    distrito: "08",
    text: "Vilcabamba",
  },
  {
    departamento: "18",
    provincia: "03",
    distrito: "00",
    text: "Oxapampa",
  },
  {
    departamento: "18",
    provincia: "03",
    distrito: "01",
    text: "Oxapampa",
  },
  {
    departamento: "18",
    provincia: "03",
    distrito: "02",
    text: "Chontabamba",
  },
  {
    departamento: "18",
    provincia: "03",
    distrito: "03",
    text: "Huancabamba",
  },
  {
    departamento: "18",
    provincia: "03",
    distrito: "04",
    text: "Puerto Bermúdez",
  },
  {
    departamento: "18",
    provincia: "03",
    distrito: "05",
    text: "Villa Rica",
  },
  {
    departamento: "18",
    provincia: "03",
    distrito: "06",
    text: "Pozuzo",
  },
  {
    departamento: "18",
    provincia: "03",
    distrito: "07",
    text: "Palcazu",
  },
  {
    departamento: "18",
    provincia: "03",
    distrito: "08",
    text: "Constitución",
  },
  {
    departamento: "19",
    provincia: "00",
    distrito: "00",
    text: "Piura",
  },
  {
    departamento: "19",
    provincia: "01",
    distrito: "00",
    text: "Piura",
  },
  {
    departamento: "19",
    provincia: "01",
    distrito: "01",
    text: "Piura",
  },
  {
    departamento: "19",
    provincia: "01",
    distrito: "03",
    text: "Castilla",
  },
  {
    departamento: "19",
    provincia: "01",
    distrito: "04",
    text: "Catacaos",
  },
  {
    departamento: "19",
    provincia: "01",
    distrito: "05",
    text: "La Arena",
  },
  {
    departamento: "19",
    provincia: "01",
    distrito: "06",
    text: "La Union",
  },
  {
    departamento: "19",
    provincia: "01",
    distrito: "07",
    text: "Las Lomas",
  },
  {
    departamento: "19",
    provincia: "01",
    distrito: "09",
    text: "Tambo Grande",
  },
  {
    departamento: "19",
    provincia: "01",
    distrito: "13",
    text: "Cura Mori",
  },
  {
    departamento: "19",
    provincia: "01",
    distrito: "14",
    text: "El Tallan",
  },
  {
    departamento: "19",
    provincia: "02",
    distrito: "00",
    text: "Ayabaca",
  },
  {
    departamento: "19",
    provincia: "02",
    distrito: "01",
    text: "Ayabaca",
  },
  {
    departamento: "19",
    provincia: "02",
    distrito: "02",
    text: "Frias",
  },
  {
    departamento: "19",
    provincia: "02",
    distrito: "03",
    text: "Lagunas",
  },
  {
    departamento: "19",
    provincia: "02",
    distrito: "04",
    text: "Montero",
  },
  {
    departamento: "19",
    provincia: "02",
    distrito: "05",
    text: "Pacaipampa",
  },
  {
    departamento: "19",
    provincia: "02",
    distrito: "06",
    text: "Sapillica",
  },
  {
    departamento: "19",
    provincia: "02",
    distrito: "07",
    text: "Sicchez",
  },
  {
    departamento: "19",
    provincia: "02",
    distrito: "08",
    text: "Suyo",
  },
  {
    departamento: "19",
    provincia: "02",
    distrito: "09",
    text: "Jilili",
  },
  {
    departamento: "19",
    provincia: "02",
    distrito: "10",
    text: "Paimas",
  },
  {
    departamento: "19",
    provincia: "03",
    distrito: "00",
    text: "Huancabamba",
  },
  {
    departamento: "19",
    provincia: "03",
    distrito: "01",
    text: "Huancabamba",
  },
  {
    departamento: "19",
    provincia: "03",
    distrito: "02",
    text: "Canchaque",
  },
  {
    departamento: "19",
    provincia: "03",
    distrito: "03",
    text: "Huarmaca",
  },
  {
    departamento: "19",
    provincia: "03",
    distrito: "04",
    text: "Sondor",
  },
  {
    departamento: "19",
    provincia: "03",
    distrito: "05",
    text: "Sondorillo",
  },
  {
    departamento: "19",
    provincia: "03",
    distrito: "06",
    text: "El Carmen de La Frontera",
  },
  {
    departamento: "19",
    provincia: "03",
    distrito: "07",
    text: "San Miguel de El Faique",
  },
  {
    departamento: "19",
    provincia: "03",
    distrito: "08",
    text: "Lalaquiz",
  },
  {
    departamento: "19",
    provincia: "04",
    distrito: "00",
    text: "Morropon",
  },
  {
    departamento: "19",
    provincia: "04",
    distrito: "01",
    text: "Chulucanas",
  },
  {
    departamento: "19",
    provincia: "04",
    distrito: "02",
    text: "Buenos Aires",
  },
  {
    departamento: "19",
    provincia: "04",
    distrito: "03",
    text: "Chalaco",
  },
  {
    departamento: "19",
    provincia: "04",
    distrito: "04",
    text: "Morropon",
  },
  {
    departamento: "19",
    provincia: "04",
    distrito: "05",
    text: "Salitral",
  },
  {
    departamento: "19",
    provincia: "04",
    distrito: "06",
    text: "Santa Catalina de Mossa",
  },
  {
    departamento: "19",
    provincia: "04",
    distrito: "07",
    text: "Santo Domingo",
  },
  {
    departamento: "19",
    provincia: "04",
    distrito: "08",
    text: "La Matanza",
  },
  {
    departamento: "19",
    provincia: "04",
    distrito: "09",
    text: "Yamango",
  },
  {
    departamento: "19",
    provincia: "04",
    distrito: "10",
    text: "San Juan de Bigote",
  },
  {
    departamento: "19",
    provincia: "05",
    distrito: "00",
    text: "Paita",
  },
  {
    departamento: "19",
    provincia: "05",
    distrito: "01",
    text: "Paita",
  },
  {
    departamento: "19",
    provincia: "05",
    distrito: "02",
    text: "Amotape",
  },
  {
    departamento: "19",
    provincia: "05",
    distrito: "03",
    text: "Arenal",
  },
  {
    departamento: "19",
    provincia: "05",
    distrito: "04",
    text: "La Huaca",
  },
  {
    departamento: "19",
    provincia: "05",
    distrito: "05",
    text: "Colan",
  },
  {
    departamento: "19",
    provincia: "05",
    distrito: "06",
    text: "Tamarindo",
  },
  {
    departamento: "19",
    provincia: "05",
    distrito: "07",
    text: "Vichayal",
  },
  {
    departamento: "19",
    provincia: "06",
    distrito: "00",
    text: "Sullana",
  },
  {
    departamento: "19",
    provincia: "06",
    distrito: "01",
    text: "Sullana",
  },
  {
    departamento: "19",
    provincia: "06",
    distrito: "02",
    text: "Bellavista",
  },
  {
    departamento: "19",
    provincia: "06",
    distrito: "03",
    text: "Lancones",
  },
  {
    departamento: "19",
    provincia: "06",
    distrito: "04",
    text: "Marcavelica",
  },
  {
    departamento: "19",
    provincia: "06",
    distrito: "05",
    text: "Miguel Checa",
  },
  {
    departamento: "19",
    provincia: "06",
    distrito: "06",
    text: "Querecotillo",
  },
  {
    departamento: "19",
    provincia: "06",
    distrito: "07",
    text: "Salitral",
  },
  {
    departamento: "19",
    provincia: "06",
    distrito: "08",
    text: "Ignacio Escudero",
  },
  {
    departamento: "19",
    provincia: "07",
    distrito: "00",
    text: "Talara",
  },
  {
    departamento: "19",
    provincia: "07",
    distrito: "01",
    text: "Pariñas",
  },
  {
    departamento: "19",
    provincia: "07",
    distrito: "02",
    text: "El Alto",
  },
  {
    departamento: "19",
    provincia: "07",
    distrito: "03",
    text: "La Brea",
  },
  {
    departamento: "19",
    provincia: "07",
    distrito: "04",
    text: "Lobitos",
  },
  {
    departamento: "19",
    provincia: "07",
    distrito: "05",
    text: "Mancora",
  },
  {
    departamento: "19",
    provincia: "07",
    distrito: "06",
    text: "Los Organos",
  },
  {
    departamento: "19",
    provincia: "08",
    distrito: "00",
    text: "Sechura",
  },
  {
    departamento: "19",
    provincia: "08",
    distrito: "01",
    text: "Sechura",
  },
  {
    departamento: "19",
    provincia: "08",
    distrito: "02",
    text: "Vice",
  },
  {
    departamento: "19",
    provincia: "08",
    distrito: "03",
    text: "Bernal",
  },
  {
    departamento: "19",
    provincia: "08",
    distrito: "04",
    text: "Bellavista de La Union",
  },
  {
    departamento: "19",
    provincia: "08",
    distrito: "05",
    text: "Cristo Nos Valga",
  },
  {
    departamento: "19",
    provincia: "08",
    distrito: "06",
    text: "Rinconada Llicuar",
  },
  {
    departamento: "20",
    provincia: "00",
    distrito: "00",
    text: "Puno",
  },
  {
    departamento: "20",
    provincia: "01",
    distrito: "00",
    text: "Puno",
  },
  {
    departamento: "20",
    provincia: "01",
    distrito: "01",
    text: "Puno",
  },
  {
    departamento: "20",
    provincia: "01",
    distrito: "02",
    text: "Acora",
  },
  {
    departamento: "20",
    provincia: "01",
    distrito: "03",
    text: "Atuncolla",
  },
  {
    departamento: "20",
    provincia: "01",
    distrito: "04",
    text: "Capachica",
  },
  {
    departamento: "20",
    provincia: "01",
    distrito: "05",
    text: "Coata",
  },
  {
    departamento: "20",
    provincia: "01",
    distrito: "06",
    text: "Chucuito",
  },
  {
    departamento: "20",
    provincia: "01",
    distrito: "07",
    text: "Huata",
  },
  {
    departamento: "20",
    provincia: "01",
    distrito: "08",
    text: "Mañazo",
  },
  {
    departamento: "20",
    provincia: "01",
    distrito: "09",
    text: "Paucarcolla",
  },
  {
    departamento: "20",
    provincia: "01",
    distrito: "10",
    text: "Pichacani",
  },
  {
    departamento: "20",
    provincia: "01",
    distrito: "11",
    text: "San Antonio",
  },
  {
    departamento: "20",
    provincia: "01",
    distrito: "12",
    text: "Tiquillaca",
  },
  {
    departamento: "20",
    provincia: "01",
    distrito: "13",
    text: "Vilque",
  },
  {
    departamento: "20",
    provincia: "01",
    distrito: "14",
    text: "Plateria",
  },
  {
    departamento: "20",
    provincia: "01",
    distrito: "15",
    text: "Amantani",
  },
  {
    departamento: "20",
    provincia: "02",
    distrito: "00",
    text: "Azángaro",
  },
  {
    departamento: "20",
    provincia: "02",
    distrito: "01",
    text: "Azángaro",
  },
  {
    departamento: "20",
    provincia: "02",
    distrito: "02",
    text: "Achaya",
  },
  {
    departamento: "20",
    provincia: "02",
    distrito: "03",
    text: "Arapa",
  },
  {
    departamento: "20",
    provincia: "02",
    distrito: "04",
    text: "Asillo",
  },
  {
    departamento: "20",
    provincia: "02",
    distrito: "05",
    text: "Caminaca",
  },
  {
    departamento: "20",
    provincia: "02",
    distrito: "06",
    text: "Chupa",
  },
  {
    departamento: "20",
    provincia: "02",
    distrito: "07",
    text: "José Domingo Choquehuanca",
  },
  {
    departamento: "20",
    provincia: "02",
    distrito: "08",
    text: "Muñani",
  },
  {
    departamento: "20",
    provincia: "02",
    distrito: "10",
    text: "Potoni",
  },
  {
    departamento: "20",
    provincia: "02",
    distrito: "12",
    text: "Saman",
  },
  {
    departamento: "20",
    provincia: "02",
    distrito: "13",
    text: "San Anton",
  },
  {
    departamento: "20",
    provincia: "02",
    distrito: "14",
    text: "San José",
  },
  {
    departamento: "20",
    provincia: "02",
    distrito: "15",
    text: "San Juan de Salinas",
  },
  {
    departamento: "20",
    provincia: "02",
    distrito: "16",
    text: "Santiago de Pupuja",
  },
  {
    departamento: "20",
    provincia: "02",
    distrito: "17",
    text: "Tirapata",
  },
  {
    departamento: "20",
    provincia: "03",
    distrito: "00",
    text: "Carabaya",
  },
  {
    departamento: "20",
    provincia: "03",
    distrito: "01",
    text: "Macusani",
  },
  {
    departamento: "20",
    provincia: "03",
    distrito: "02",
    text: "Ajoyani",
  },
  {
    departamento: "20",
    provincia: "03",
    distrito: "03",
    text: "Ayapata",
  },
  {
    departamento: "20",
    provincia: "03",
    distrito: "04",
    text: "Coasa",
  },
  {
    departamento: "20",
    provincia: "03",
    distrito: "05",
    text: "Corani",
  },
  {
    departamento: "20",
    provincia: "03",
    distrito: "06",
    text: "Crucero",
  },
  {
    departamento: "20",
    provincia: "03",
    distrito: "07",
    text: "Ituata",
  },
  {
    departamento: "20",
    provincia: "03",
    distrito: "08",
    text: "Ollachea",
  },
  {
    departamento: "20",
    provincia: "03",
    distrito: "09",
    text: "San Gaban",
  },
  {
    departamento: "20",
    provincia: "03",
    distrito: "10",
    text: "Usicayos",
  },
  {
    departamento: "20",
    provincia: "04",
    distrito: "00",
    text: "Chucuito",
  },
  {
    departamento: "20",
    provincia: "04",
    distrito: "01",
    text: "Juli",
  },
  {
    departamento: "20",
    provincia: "04",
    distrito: "02",
    text: "Desaguadero",
  },
  {
    departamento: "20",
    provincia: "04",
    distrito: "03",
    text: "Huacullani",
  },
  {
    departamento: "20",
    provincia: "04",
    distrito: "06",
    text: "Pisacoma",
  },
  {
    departamento: "20",
    provincia: "04",
    distrito: "07",
    text: "Pomata",
  },
  {
    departamento: "20",
    provincia: "04",
    distrito: "10",
    text: "Zepita",
  },
  {
    departamento: "20",
    provincia: "04",
    distrito: "12",
    text: "Kelluyo",
  },
  {
    departamento: "20",
    provincia: "05",
    distrito: "00",
    text: "Huancane",
  },
  {
    departamento: "20",
    provincia: "05",
    distrito: "01",
    text: "Huancane",
  },
  {
    departamento: "20",
    provincia: "05",
    distrito: "02",
    text: "Cojata",
  },
  {
    departamento: "20",
    provincia: "05",
    distrito: "04",
    text: "Inchupalla",
  },
  {
    departamento: "20",
    provincia: "05",
    distrito: "06",
    text: "Pusi",
  },
  {
    departamento: "20",
    provincia: "05",
    distrito: "07",
    text: "Rosaspata",
  },
  {
    departamento: "20",
    provincia: "05",
    distrito: "08",
    text: "Taraco",
  },
  {
    departamento: "20",
    provincia: "05",
    distrito: "09",
    text: "Vilque Chico",
  },
  {
    departamento: "20",
    provincia: "05",
    distrito: "11",
    text: "Huatasani",
  },
  {
    departamento: "20",
    provincia: "06",
    distrito: "00",
    text: "Lampa",
  },
  {
    departamento: "20",
    provincia: "06",
    distrito: "01",
    text: "Lampa",
  },
  {
    departamento: "20",
    provincia: "06",
    distrito: "02",
    text: "Cabanilla",
  },
  {
    departamento: "20",
    provincia: "06",
    distrito: "03",
    text: "Calapuja",
  },
  {
    departamento: "20",
    provincia: "06",
    distrito: "04",
    text: "Nicasio",
  },
  {
    departamento: "20",
    provincia: "06",
    distrito: "05",
    text: "Ocuviri",
  },
  {
    departamento: "20",
    provincia: "06",
    distrito: "06",
    text: "Palca",
  },
  {
    departamento: "20",
    provincia: "06",
    distrito: "07",
    text: "Paratia",
  },
  {
    departamento: "20",
    provincia: "06",
    distrito: "08",
    text: "Pucara",
  },
  {
    departamento: "20",
    provincia: "06",
    distrito: "09",
    text: "Santa Lucia",
  },
  {
    departamento: "20",
    provincia: "06",
    distrito: "10",
    text: "Vilavila",
  },
  {
    departamento: "20",
    provincia: "07",
    distrito: "00",
    text: "Melgar",
  },
  {
    departamento: "20",
    provincia: "07",
    distrito: "01",
    text: "Ayaviri",
  },
  {
    departamento: "20",
    provincia: "07",
    distrito: "02",
    text: "Antauta",
  },
  {
    departamento: "20",
    provincia: "07",
    distrito: "03",
    text: "Cupi",
  },
  {
    departamento: "20",
    provincia: "07",
    distrito: "04",
    text: "Llalli",
  },
  {
    departamento: "20",
    provincia: "07",
    distrito: "05",
    text: "Macari",
  },
  {
    departamento: "20",
    provincia: "07",
    distrito: "06",
    text: "Nuñoa",
  },
  {
    departamento: "20",
    provincia: "07",
    distrito: "07",
    text: "Orurillo",
  },
  {
    departamento: "20",
    provincia: "07",
    distrito: "08",
    text: "Santa Rosa",
  },
  {
    departamento: "20",
    provincia: "07",
    distrito: "09",
    text: "Umachiri",
  },
  {
    departamento: "20",
    provincia: "08",
    distrito: "00",
    text: "Sandia",
  },
  {
    departamento: "20",
    provincia: "08",
    distrito: "01",
    text: "Sandia",
  },
  {
    departamento: "20",
    provincia: "08",
    distrito: "03",
    text: "Cuyocuyo",
  },
  {
    departamento: "20",
    provincia: "08",
    distrito: "04",
    text: "Limbani",
  },
  {
    departamento: "20",
    provincia: "08",
    distrito: "05",
    text: "Phara",
  },
  {
    departamento: "20",
    provincia: "08",
    distrito: "06",
    text: "Patambuco",
  },
  {
    departamento: "20",
    provincia: "08",
    distrito: "07",
    text: "Quiaca",
  },
  {
    departamento: "20",
    provincia: "08",
    distrito: "08",
    text: "San Juan del Oro",
  },
  {
    departamento: "20",
    provincia: "08",
    distrito: "10",
    text: "Yanahuaya",
  },
  {
    departamento: "20",
    provincia: "08",
    distrito: "11",
    text: "Alto Inambari",
  },
  {
    departamento: "20",
    provincia: "08",
    distrito: "12",
    text: "San Pedro de Putina Punco",
  },
  {
    departamento: "20",
    provincia: "09",
    distrito: "00",
    text: "San Román",
  },
  {
    departamento: "20",
    provincia: "09",
    distrito: "01",
    text: "Juliaca",
  },
  {
    departamento: "20",
    provincia: "09",
    distrito: "02",
    text: "Cabana",
  },
  {
    departamento: "20",
    provincia: "09",
    distrito: "03",
    text: "Cabanillas",
  },
  {
    departamento: "20",
    provincia: "09",
    distrito: "04",
    text: "Caracoto",
  },
  {
    departamento: "20",
    provincia: "10",
    distrito: "00",
    text: "Yunguyo",
  },
  {
    departamento: "20",
    provincia: "10",
    distrito: "01",
    text: "Yunguyo",
  },
  {
    departamento: "20",
    provincia: "10",
    distrito: "02",
    text: "Unicachi",
  },
  {
    departamento: "20",
    provincia: "10",
    distrito: "03",
    text: "Anapia",
  },
  {
    departamento: "20",
    provincia: "10",
    distrito: "04",
    text: "Copani",
  },
  {
    departamento: "20",
    provincia: "10",
    distrito: "05",
    text: "Cuturapi",
  },
  {
    departamento: "20",
    provincia: "10",
    distrito: "06",
    text: "Ollaraya",
  },
  {
    departamento: "20",
    provincia: "10",
    distrito: "07",
    text: "Tinicachi",
  },
  {
    departamento: "20",
    provincia: "11",
    distrito: "00",
    text: "San Antonio de Putina",
  },
  {
    departamento: "20",
    provincia: "11",
    distrito: "01",
    text: "Putina",
  },
  {
    departamento: "20",
    provincia: "11",
    distrito: "02",
    text: "Pedro Vilca Apaza",
  },
  {
    departamento: "20",
    provincia: "11",
    distrito: "03",
    text: "Quilcapuncu",
  },
  {
    departamento: "20",
    provincia: "11",
    distrito: "04",
    text: "Ananea",
  },
  {
    departamento: "20",
    provincia: "11",
    distrito: "05",
    text: "Sina",
  },
  {
    departamento: "20",
    provincia: "12",
    distrito: "00",
    text: "El Collao",
  },
  {
    departamento: "20",
    provincia: "12",
    distrito: "01",
    text: "Ilave",
  },
  {
    departamento: "20",
    provincia: "12",
    distrito: "02",
    text: "Pilcuyo",
  },
  {
    departamento: "20",
    provincia: "12",
    distrito: "03",
    text: "Santa Rosa",
  },
  {
    departamento: "20",
    provincia: "12",
    distrito: "04",
    text: "Capazo",
  },
  {
    departamento: "20",
    provincia: "12",
    distrito: "05",
    text: "Conduriri",
  },
  {
    departamento: "20",
    provincia: "13",
    distrito: "00",
    text: "Moho",
  },
  {
    departamento: "20",
    provincia: "13",
    distrito: "01",
    text: "Moho",
  },
  {
    departamento: "20",
    provincia: "13",
    distrito: "02",
    text: "Conima",
  },
  {
    departamento: "20",
    provincia: "13",
    distrito: "03",
    text: "Tilali",
  },
  {
    departamento: "20",
    provincia: "13",
    distrito: "04",
    text: "Huayrapata",
  },
  {
    departamento: "21",
    provincia: "00",
    distrito: "00",
    text: "San Martín",
  },
  {
    departamento: "21",
    provincia: "01",
    distrito: "00",
    text: "Moyobamba",
  },
  {
    departamento: "21",
    provincia: "01",
    distrito: "01",
    text: "Moyobamba",
  },
  {
    departamento: "21",
    provincia: "01",
    distrito: "02",
    text: "Calzada",
  },
  {
    departamento: "21",
    provincia: "01",
    distrito: "03",
    text: "Habana",
  },
  {
    departamento: "21",
    provincia: "01",
    distrito: "04",
    text: "Jepelacio",
  },
  {
    departamento: "21",
    provincia: "01",
    distrito: "05",
    text: "Soritor",
  },
  {
    departamento: "21",
    provincia: "01",
    distrito: "06",
    text: "Yantalo",
  },
  {
    departamento: "21",
    provincia: "02",
    distrito: "00",
    text: "Huallaga",
  },
  {
    departamento: "21",
    provincia: "02",
    distrito: "01",
    text: "Saposoa",
  },
  {
    departamento: "21",
    provincia: "02",
    distrito: "02",
    text: "Piscoyacu",
  },
  {
    departamento: "21",
    provincia: "02",
    distrito: "03",
    text: "Sacanche",
  },
  {
    departamento: "21",
    provincia: "02",
    distrito: "04",
    text: "Tingo de Saposoa",
  },
  {
    departamento: "21",
    provincia: "02",
    distrito: "05",
    text: "Alto Saposoa",
  },
  {
    departamento: "21",
    provincia: "02",
    distrito: "06",
    text: "El Eslabón",
  },
  {
    departamento: "21",
    provincia: "03",
    distrito: "00",
    text: "Lamas",
  },
  {
    departamento: "21",
    provincia: "03",
    distrito: "01",
    text: "Lamas",
  },
  {
    departamento: "21",
    provincia: "03",
    distrito: "03",
    text: "Barranquita",
  },
  {
    departamento: "21",
    provincia: "03",
    distrito: "04",
    text: "Caynarachi",
  },
  {
    departamento: "21",
    provincia: "03",
    distrito: "05",
    text: "Cuñumbuqui",
  },
  {
    departamento: "21",
    provincia: "03",
    distrito: "06",
    text: "Pinto Recodo",
  },
  {
    departamento: "21",
    provincia: "03",
    distrito: "07",
    text: "Rumisapa",
  },
  {
    departamento: "21",
    provincia: "03",
    distrito: "11",
    text: "Shanao",
  },
  {
    departamento: "21",
    provincia: "03",
    distrito: "13",
    text: "Tabalosos",
  },
  {
    departamento: "21",
    provincia: "03",
    distrito: "14",
    text: "Zapatero",
  },
  {
    departamento: "21",
    provincia: "03",
    distrito: "15",
    text: "Alonso de Alvarado",
  },
  {
    departamento: "21",
    provincia: "03",
    distrito: "16",
    text: "San Roque de Cumbaza",
  },
  {
    departamento: "21",
    provincia: "04",
    distrito: "00",
    text: "Mariscal Cáceres",
  },
  {
    departamento: "21",
    provincia: "04",
    distrito: "01",
    text: "Juanjuí",
  },
  {
    departamento: "21",
    provincia: "04",
    distrito: "02",
    text: "Campanilla",
  },
  {
    departamento: "21",
    provincia: "04",
    distrito: "03",
    text: "Huicungo",
  },
  {
    departamento: "21",
    provincia: "04",
    distrito: "04",
    text: "Pachiza",
  },
  {
    departamento: "21",
    provincia: "04",
    distrito: "05",
    text: "Pajarillo",
  },
  {
    departamento: "21",
    provincia: "05",
    distrito: "00",
    text: "Rioja",
  },
  {
    departamento: "21",
    provincia: "05",
    distrito: "01",
    text: "Rioja",
  },
  {
    departamento: "21",
    provincia: "05",
    distrito: "02",
    text: "Posic",
  },
  {
    departamento: "21",
    provincia: "05",
    distrito: "03",
    text: "Yorongos",
  },
  {
    departamento: "21",
    provincia: "05",
    distrito: "04",
    text: "Yuracyacu",
  },
  {
    departamento: "21",
    provincia: "05",
    distrito: "05",
    text: "Nueva Cajamarca",
  },
  {
    departamento: "21",
    provincia: "05",
    distrito: "06",
    text: "Elías Soplin Vargas",
  },
  {
    departamento: "21",
    provincia: "05",
    distrito: "07",
    text: "San Fernando",
  },
  {
    departamento: "21",
    provincia: "05",
    distrito: "08",
    text: "Pardo Miguel",
  },
  {
    departamento: "21",
    provincia: "05",
    distrito: "09",
    text: "Awajun",
  },
  {
    departamento: "21",
    provincia: "06",
    distrito: "00",
    text: "San Martín",
  },
  {
    departamento: "21",
    provincia: "06",
    distrito: "01",
    text: "Tarapoto",
  },
  {
    departamento: "21",
    provincia: "06",
    distrito: "02",
    text: "Alberto Leveau",
  },
  {
    departamento: "21",
    provincia: "06",
    distrito: "04",
    text: "Cacatachi",
  },
  {
    departamento: "21",
    provincia: "06",
    distrito: "06",
    text: "Chazuta",
  },
  {
    departamento: "21",
    provincia: "06",
    distrito: "07",
    text: "Chipurana",
  },
  {
    departamento: "21",
    provincia: "06",
    distrito: "08",
    text: "El Porvenir",
  },
  {
    departamento: "21",
    provincia: "06",
    distrito: "09",
    text: "Huimbayoc",
  },
  {
    departamento: "21",
    provincia: "06",
    distrito: "10",
    text: "Juan Guerra",
  },
  {
    departamento: "21",
    provincia: "06",
    distrito: "11",
    text: "Morales",
  },
  {
    departamento: "21",
    provincia: "06",
    distrito: "12",
    text: "Papaplaya",
  },
  {
    departamento: "21",
    provincia: "06",
    distrito: "16",
    text: "San Antonio",
  },
  {
    departamento: "21",
    provincia: "06",
    distrito: "19",
    text: "Sauce",
  },
  {
    departamento: "21",
    provincia: "06",
    distrito: "20",
    text: "Shapaja",
  },
  {
    departamento: "21",
    provincia: "06",
    distrito: "21",
    text: "La Banda de Shilcayo",
  },
  {
    departamento: "21",
    provincia: "07",
    distrito: "00",
    text: "Bellavista",
  },
  {
    departamento: "21",
    provincia: "07",
    distrito: "01",
    text: "Bellavista",
  },
  {
    departamento: "21",
    provincia: "07",
    distrito: "02",
    text: "San Rafael",
  },
  {
    departamento: "21",
    provincia: "07",
    distrito: "03",
    text: "San Pablo",
  },
  {
    departamento: "21",
    provincia: "07",
    distrito: "04",
    text: "Alto Biavo",
  },
  {
    departamento: "21",
    provincia: "07",
    distrito: "05",
    text: "Huallaga",
  },
  {
    departamento: "21",
    provincia: "07",
    distrito: "06",
    text: "Bajo Biavo",
  },
  {
    departamento: "21",
    provincia: "08",
    distrito: "00",
    text: "Tocache",
  },
  {
    departamento: "21",
    provincia: "08",
    distrito: "01",
    text: "Tocache",
  },
  {
    departamento: "21",
    provincia: "08",
    distrito: "02",
    text: "Nuevo Progreso",
  },
  {
    departamento: "21",
    provincia: "08",
    distrito: "03",
    text: "Polvora",
  },
  {
    departamento: "21",
    provincia: "08",
    distrito: "04",
    text: "Shunte",
  },
  {
    departamento: "21",
    provincia: "08",
    distrito: "05",
    text: "Uchiza",
  },
  {
    departamento: "21",
    provincia: "09",
    distrito: "00",
    text: "Picota",
  },
  {
    departamento: "21",
    provincia: "09",
    distrito: "01",
    text: "Picota",
  },
  {
    departamento: "21",
    provincia: "09",
    distrito: "02",
    text: "Buenos Aires",
  },
  {
    departamento: "21",
    provincia: "09",
    distrito: "03",
    text: "Caspisapa",
  },
  {
    departamento: "21",
    provincia: "09",
    distrito: "04",
    text: "Pilluana",
  },
  {
    departamento: "21",
    provincia: "09",
    distrito: "05",
    text: "Pucacaca",
  },
  {
    departamento: "21",
    provincia: "09",
    distrito: "06",
    text: "San Cristóbal",
  },
  {
    departamento: "21",
    provincia: "09",
    distrito: "07",
    text: "San Hilarión",
  },
  {
    departamento: "21",
    provincia: "09",
    distrito: "08",
    text: "Tingo de Ponasa",
  },
  {
    departamento: "21",
    provincia: "09",
    distrito: "09",
    text: "Tres Unidos",
  },
  {
    departamento: "21",
    provincia: "09",
    distrito: "10",
    text: "Shamboyacu",
  },
  {
    departamento: "21",
    provincia: "10",
    distrito: "00",
    text: "El Dorado",
  },
  {
    departamento: "21",
    provincia: "10",
    distrito: "01",
    text: "San José de Sisa",
  },
  {
    departamento: "21",
    provincia: "10",
    distrito: "02",
    text: "Agua Blanca",
  },
  {
    departamento: "21",
    provincia: "10",
    distrito: "03",
    text: "Shatoja",
  },
  {
    departamento: "21",
    provincia: "10",
    distrito: "04",
    text: "San Martín",
  },
  {
    departamento: "21",
    provincia: "10",
    distrito: "05",
    text: "Santa Rosa",
  },
  {
    departamento: "22",
    provincia: "00",
    distrito: "00",
    text: "Tacna",
  },
  {
    departamento: "22",
    provincia: "01",
    distrito: "00",
    text: "Tacna",
  },
  {
    departamento: "22",
    provincia: "01",
    distrito: "01",
    text: "Tacna",
  },
  {
    departamento: "22",
    provincia: "01",
    distrito: "02",
    text: "Calana",
  },
  {
    departamento: "22",
    provincia: "01",
    distrito: "04",
    text: "Inclan",
  },
  {
    departamento: "22",
    provincia: "01",
    distrito: "07",
    text: "Pachia",
  },
  {
    departamento: "22",
    provincia: "01",
    distrito: "08",
    text: "Palca",
  },
  {
    departamento: "22",
    provincia: "01",
    distrito: "09",
    text: "Pocollay",
  },
  {
    departamento: "22",
    provincia: "01",
    distrito: "10",
    text: "Sama",
  },
  {
    departamento: "22",
    provincia: "01",
    distrito: "11",
    text: "Alto de La Alianza",
  },
  {
    departamento: "22",
    provincia: "01",
    distrito: "12",
    text: "Ciudad Nueva",
  },
  {
    departamento: "22",
    provincia: "01",
    distrito: "13",
    text: "Coronel Gregorio Albarracín Lanchipa",
  },
  {
    departamento: "22",
    provincia: "02",
    distrito: "00",
    text: "Tarata",
  },
  {
    departamento: "22",
    provincia: "02",
    distrito: "01",
    text: "Tarata",
  },
  {
    departamento: "22",
    provincia: "02",
    distrito: "05",
    text: "Héroes Albarracín",
  },
  {
    departamento: "22",
    provincia: "02",
    distrito: "06",
    text: "Estique",
  },
  {
    departamento: "22",
    provincia: "02",
    distrito: "07",
    text: "Estique-Pampa",
  },
  {
    departamento: "22",
    provincia: "02",
    distrito: "10",
    text: "Sitajara",
  },
  {
    departamento: "22",
    provincia: "02",
    distrito: "11",
    text: "Susapaya",
  },
  {
    departamento: "22",
    provincia: "02",
    distrito: "12",
    text: "Tarucachi",
  },
  {
    departamento: "22",
    provincia: "02",
    distrito: "13",
    text: "Ticaco",
  },
  {
    departamento: "22",
    provincia: "03",
    distrito: "00",
    text: "Jorge Basadre",
  },
  {
    departamento: "22",
    provincia: "03",
    distrito: "01",
    text: "Locumba",
  },
  {
    departamento: "22",
    provincia: "03",
    distrito: "02",
    text: "Ite",
  },
  {
    departamento: "22",
    provincia: "03",
    distrito: "03",
    text: "Ilabaya",
  },
  {
    departamento: "22",
    provincia: "04",
    distrito: "00",
    text: "Candarave",
  },
  {
    departamento: "22",
    provincia: "04",
    distrito: "01",
    text: "Candarave",
  },
  {
    departamento: "22",
    provincia: "04",
    distrito: "02",
    text: "Cairani",
  },
  {
    departamento: "22",
    provincia: "04",
    distrito: "03",
    text: "Curibaya",
  },
  {
    departamento: "22",
    provincia: "04",
    distrito: "04",
    text: "Huanuara",
  },
  {
    departamento: "22",
    provincia: "04",
    distrito: "05",
    text: "Quilahuani",
  },
  {
    departamento: "22",
    provincia: "04",
    distrito: "06",
    text: "Camilaca",
  },
  {
    departamento: "23",
    provincia: "00",
    distrito: "00",
    text: "Tumbes",
  },
  {
    departamento: "23",
    provincia: "01",
    distrito: "00",
    text: "Tumbes",
  },
  {
    departamento: "23",
    provincia: "01",
    distrito: "01",
    text: "Tumbes",
  },
  {
    departamento: "23",
    provincia: "01",
    distrito: "02",
    text: "Corrales",
  },
  {
    departamento: "23",
    provincia: "01",
    distrito: "03",
    text: "La Cruz",
  },
  {
    departamento: "23",
    provincia: "01",
    distrito: "04",
    text: "Pampas de Hospital",
  },
  {
    departamento: "23",
    provincia: "01",
    distrito: "05",
    text: "San Jacinto",
  },
  {
    departamento: "23",
    provincia: "01",
    distrito: "06",
    text: "San Juan de La Virgen",
  },
  {
    departamento: "23",
    provincia: "02",
    distrito: "00",
    text: "Contralmirante Villar",
  },
  {
    departamento: "23",
    provincia: "02",
    distrito: "01",
    text: "Zorritos",
  },
  {
    departamento: "23",
    provincia: "02",
    distrito: "02",
    text: "Casitas",
  },
  {
    departamento: "23",
    provincia: "02",
    distrito: "03",
    text: "Canoas de Punta Sal",
  },
  {
    departamento: "23",
    provincia: "03",
    distrito: "00",
    text: "Zarumilla",
  },
  {
    departamento: "23",
    provincia: "03",
    distrito: "01",
    text: "Zarumilla",
  },
  {
    departamento: "23",
    provincia: "03",
    distrito: "02",
    text: "Matapalo",
  },
  {
    departamento: "23",
    provincia: "03",
    distrito: "03",
    text: "Papayal",
  },
  {
    departamento: "23",
    provincia: "03",
    distrito: "04",
    text: "Aguas Verdes",
  },
  {
    departamento: "24",
    provincia: "00",
    distrito: "00",
    text: "Callao",
  },
  {
    departamento: "24",
    provincia: "01",
    distrito: "00",
    text: "Callao",
  },
  {
    departamento: "24",
    provincia: "01",
    distrito: "01",
    text: "Callao",
  },
  {
    departamento: "24",
    provincia: "01",
    distrito: "02",
    text: "Bellavista",
  },
  {
    departamento: "24",
    provincia: "01",
    distrito: "03",
    text: "La Punta",
  },
  {
    departamento: "24",
    provincia: "01",
    distrito: "04",
    text: "Carmen de La Legua",
  },
  {
    departamento: "24",
    provincia: "01",
    distrito: "05",
    text: "La Perla",
  },
  {
    departamento: "24",
    provincia: "01",
    distrito: "06",
    text: "Ventanilla",
  },
  {
    departamento: "24",
    provincia: "01",
    distrito: "07",
    text: "Mi Perú",
  },
  {
    departamento: "25",
    provincia: "00",
    distrito: "00",
    text: "Ucayali",
  },
  {
    departamento: "25",
    provincia: "01",
    distrito: "00",
    text: "Coronel Portillo",
  },
  {
    departamento: "25",
    provincia: "01",
    distrito: "01",
    text: "Calleria",
  },
  {
    departamento: "25",
    provincia: "01",
    distrito: "02",
    text: "Yarinacocha",
  },
  {
    departamento: "25",
    provincia: "01",
    distrito: "03",
    text: "Masisea",
  },
  {
    departamento: "25",
    provincia: "01",
    distrito: "04",
    text: "Campoverde",
  },
  {
    departamento: "25",
    provincia: "01",
    distrito: "05",
    text: "Iparia",
  },
  {
    departamento: "25",
    provincia: "01",
    distrito: "06",
    text: "Nueva Requena",
  },
  {
    departamento: "25",
    provincia: "01",
    distrito: "07",
    text: "Manantay",
  },
  {
    departamento: "25",
    provincia: "02",
    distrito: "00",
    text: "Padre Abad",
  },
  {
    departamento: "25",
    provincia: "02",
    distrito: "01",
    text: "Padre Abad",
  },
  {
    departamento: "25",
    provincia: "02",
    distrito: "02",
    text: "Irazola",
  },
  {
    departamento: "25",
    provincia: "02",
    distrito: "03",
    text: "Curimana",
  },
  {
    departamento: "25",
    provincia: "03",
    distrito: "00",
    text: "Atalaya",
  },
  {
    departamento: "25",
    provincia: "03",
    distrito: "01",
    text: "Raymondi",
  },
  {
    departamento: "25",
    provincia: "03",
    distrito: "02",
    text: "Tahuania",
  },
  {
    departamento: "25",
    provincia: "03",
    distrito: "03",
    text: "Yurua",
  },
  {
    departamento: "25",
    provincia: "03",
    distrito: "04",
    text: "Sepahua",
  },
  {
    departamento: "25",
    provincia: "04",
    distrito: "00",
    text: "Purús",
  },
  {
    departamento: "25",
    provincia: "04",
    distrito: "01",
    text: "Purús",
  },
];
